(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('styled-components'), require('@dasa-health/alma-tokens'), require('react'), require('@emotion/react'), require('@emotion/react/package.json'), require('@emotion/styled'), require('styled-system'), require('theme-ui'), require('@dasa-health/alma-icons'), require('react-dom'), require('imask'), require('react-datepicker')) :
  typeof define === 'function' && define.amd ? define(['exports', 'styled-components', '@dasa-health/alma-tokens', 'react', '@emotion/react', '@emotion/react/package.json', '@emotion/styled', 'styled-system', 'theme-ui', '@dasa-health/alma-icons', 'react-dom', 'imask', 'react-datepicker'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["alma-react"] = {}, global.StyledComponents, global["UndefineddasaHealth/almaTokens"], global.React, global["Undefinedemotion/react"], global.packageInfo, global["Undefinedemotion/styled"], global.StyledSystem, global.ThemeUi, global["UndefineddasaHealth/almaIcons"], global.ReactDom, global.Imask, global.ReactDatepicker));
})(this, (function (exports, styled, almaTokens, React, react, packageInfo, styled$1, styledSystem, themeUi, almaIcons, reactDom, IMask, ReactDatePicker) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var styled__default$1 = /*#__PURE__*/_interopDefaultLegacy(styled);
  var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
  var React__namespace = /*#__PURE__*/_interopNamespace(React);
  var packageInfo__default = /*#__PURE__*/_interopDefaultLegacy(packageInfo);
  var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled$1);
  var styledSystem__namespace = /*#__PURE__*/_interopNamespace(styledSystem);
  var IMask__default = /*#__PURE__*/_interopDefaultLegacy(IMask);
  var ReactDatePicker__default = /*#__PURE__*/_interopDefaultLegacy(ReactDatePicker);

  const tail$2 = (arr) => arr && arr.length ? arr[arr.length - 1] : void 0;
  const head = (arr) => arr && arr.length ? arr[0] : void 0;

  function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

  // based on https://github.com/developit/dlv
  var get$2 = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [key];

    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }

    return obj === undef ? def : obj;
  };
  var defaultBreakpoints$1 = [40, 52, 64].map(function (n) {
    return n + 'em';
  });
  var defaultTheme$2 = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  var aliases$1 = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  var multiples$1 = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    size: ['width', 'height']
  };
  var scales$1 = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  var positiveOrNegative$1 = function positiveOrNegative(scale, value) {
    if (typeof value !== 'number' || value >= 0) {
      return get$2(scale, value, value);
    }

    var absolute = Math.abs(value);
    var n = get$2(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return n * -1;
  };

  var transforms$1 = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'top', 'bottom', 'left', 'right'].reduce(function (acc, curr) {
    var _extends2;

    return _extends$1({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative$1, _extends2));
  }, {});
  var responsive$1 = function responsive(styles) {
    return function (theme) {
      var next = {};
      var breakpoints = get$2(theme, 'breakpoints', defaultBreakpoints$1);
      var mediaQueries = [null].concat(breakpoints.map(function (n) {
        return "@media screen and (min-width: " + n + ")";
      }));

      for (var key in styles) {
        var value = typeof styles[key] === 'function' ? styles[key](theme) : styles[key];
        if (value == null) continue;

        if (!Array.isArray(value)) {
          next[key] = value;
          continue;
        }

        for (var i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
          var media = mediaQueries[i];

          if (!media) {
            next[key] = value[i];
            continue;
          }

          next[media] = next[media] || {};
          if (value[i] == null) continue;
          next[media][key] = value[i];
        }
      }

      return next;
    };
  };
  var css$1 = function css(args) {
    return function (props) {
      if (props === void 0) {
        props = {};
      }

      var theme = _extends$1({}, defaultTheme$2, {}, props.theme || props);

      var result = {};
      var obj = typeof args === 'function' ? args(theme) : args;
      var styles = responsive$1(obj)(theme);

      for (var key in styles) {
        var x = styles[key];
        var val = typeof x === 'function' ? x(theme) : x;

        if (key === 'variant') {
          var variant = css(get$2(theme, val))(theme);
          result = _extends$1({}, result, {}, variant);
          continue;
        }

        if (val && typeof val === 'object') {
          result[key] = css(val)(theme);
          continue;
        }

        var prop = get$2(aliases$1, key, key);
        var scaleName = get$2(scales$1, prop);
        var scale = get$2(theme, scaleName, get$2(theme, prop, {}));
        var transform = get$2(transforms$1, prop, get$2);
        var value = transform(scale, val, val);

        if (multiples$1[prop]) {
          var dirs = multiples$1[prop];

          for (var i = 0; i < dirs.length; i++) {
            result[dirs[i]] = value;
          }
        } else {
          result[prop] = value;
        }
      }

      return result;
    };
  };
  var css$2 = css$1;

  const stringNormalize = (text) => text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  const cssTextEllipsisOneLine = styled.css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
  const mapResponsive = (prop, mapperFn) => {
    if (Array.isArray(prop)) {
      return prop.map((item) => {
        if (item === null) {
          return null;
        }
        return mapperFn(item);
      });
    } else if (prop) {
      return mapperFn(prop);
    }
    return null;
  };

  const sx$1 = (props) => css$2(props.sx);

  var __defProp$1j = Object.defineProperty;
  var __defProps$R = Object.defineProperties;
  var __getOwnPropDescs$R = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1j = Object.getOwnPropertySymbols;
  var __hasOwnProp$1j = Object.prototype.hasOwnProperty;
  var __propIsEnum$1j = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1j = (obj, key, value) => key in obj ? __defProp$1j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1j = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1j.call(b, prop))
        __defNormalProp$1j(a, prop, b[prop]);
    if (__getOwnPropSymbols$1j)
      for (var prop of __getOwnPropSymbols$1j(b)) {
        if (__propIsEnum$1j.call(b, prop))
          __defNormalProp$1j(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$R = (a, b) => __defProps$R(a, __getOwnPropDescs$R(b));
  const getThemedColorTokens = (newTokens) => {
    const tokens = newTokens ? newTokens : almaTokens.dasTokens;
    const palette = {
      black: tokens.ColorPaletteBlack,
      gray: {
        10: tokens.ColorPaletteGray10,
        20: tokens.ColorPaletteGray20,
        30: tokens.ColorPaletteGray30,
        40: tokens.ColorPaletteGray40,
        50: tokens.ColorPaletteGray50,
        60: tokens.ColorPaletteGray60,
        70: tokens.ColorPaletteGray70,
        80: tokens.ColorPaletteGray80
      },
      green: {
        10: tokens.ColorPaletteGreen10,
        20: tokens.ColorPaletteGreen20,
        30: tokens.ColorPaletteGreen30,
        40: tokens.ColorPaletteGreen40,
        50: tokens.ColorPaletteGreen50,
        60: tokens.ColorPaletteGreen60,
        70: tokens.ColorPaletteGreen70,
        80: tokens.ColorPaletteGreen80
      },
      purple: {
        10: tokens.ColorPalettePurple10,
        20: tokens.ColorPalettePurple20,
        30: tokens.ColorPalettePurple30,
        40: tokens.ColorPalettePurple40,
        50: tokens.ColorPalettePurple50,
        60: tokens.ColorPalettePurple60,
        70: tokens.ColorPalettePurple70,
        80: tokens.ColorPalettePurple80
      },
      red: {
        10: tokens.ColorPaletteRed10,
        20: tokens.ColorPaletteRed20,
        30: tokens.ColorPaletteRed30,
        40: tokens.ColorPaletteRed40,
        50: tokens.ColorPaletteRed50,
        60: tokens.ColorPaletteRed60,
        70: tokens.ColorPaletteRed70,
        80: tokens.ColorPaletteRed80
      },
      white: tokens.ColorPaletteWhite,
      yellow: {
        10: tokens.ColorPaletteYellow10,
        20: tokens.ColorPaletteYellow20,
        30: tokens.ColorPaletteYellow30,
        40: tokens.ColorPaletteYellow40,
        50: tokens.ColorPaletteYellow50,
        60: tokens.ColorPaletteYellow60,
        70: tokens.ColorPaletteYellow70,
        80: tokens.ColorPaletteYellow80
      }
    };
    const colorTokens = {
      brand: {
        primary: {
          10: tokens.ColorBrandPrimary10,
          20: tokens.ColorBrandPrimary20,
          30: tokens.ColorBrandPrimary30,
          40: tokens.ColorBrandPrimary40,
          50: tokens.ColorBrandPrimary50,
          60: tokens.ColorBrandPrimary60,
          70: tokens.ColorBrandPrimary70,
          80: tokens.ColorBrandPrimary80
        }
      },
      dataviz: {
        inverse: {
          negative: {
            shape: {
              "01": tokens.ColorDatavizInverseNegativeShape01,
              "02": tokens.ColorDatavizInverseNegativeShape02,
              "03": tokens.ColorDatavizInverseNegativeShape03
            },
            text: tokens.ColorDatavizInverseNegativeText
          },
          positive: {
            shape: {
              "01": tokens.ColorDatavizInversePositiveShape01,
              "02": tokens.ColorDatavizInversePositiveShape02,
              "03": tokens.ColorDatavizInversePositiveShape03
            },
            text: tokens.ColorDatavizInversePositiveText
          }
        },
        negative: {
          "01": tokens.ColorDatavizNegativeShape01,
          "02": tokens.ColorDatavizNegativeShape02,
          "03": tokens.ColorDatavizNegativeShape03,
          text: tokens.ColorDatavizNegativeText
        },
        positive: {
          "01": tokens.ColorDatavizPositiveShape01,
          "02": tokens.ColorDatavizPositiveShape02,
          "03": tokens.ColorDatavizPositiveShape03,
          text: tokens.ColorDatavizPositiveText
        }
      },
      feedback: {
        error: {
          shape: tokens.ColorFeedbackErrorShape,
          text: tokens.ColorFeedbackErrorText
        },
        inverse: {
          error: {
            shape: tokens.ColorFeedbackInverseErrorShape,
            text: tokens.ColorFeedbackInverseErrorText
          },
          on: {
            brand: {
              error: {
                shape: tokens.ColorFeedbackInverseOnBrandErrorShape,
                text: tokens.ColorFeedbackInverseOnBrandErrorText
              },
              success: {
                shape: tokens.ColorFeedbackInverseOnBrandSuccessShape,
                text: tokens.ColorFeedbackInverseOnBrandSuccessText
              }
            }
          },
          success: {
            shape: tokens.ColorFeedbackInverseSuccessShape,
            text: tokens.ColorFeedbackInverseSuccessText
          }
        },
        on: {
          brand: {
            error: {
              shape: tokens.ColorFeedbackOnBrandErrorShape,
              text: tokens.ColorFeedbackOnBrandErrorText
            },
            success: {
              shape: tokens.ColorFeedbackOnBrandSuccessShape,
              text: tokens.ColorFeedbackOnBrandSuccessText
            }
          }
        },
        success: {
          shape: tokens.ColorFeedbackSuccessShape,
          text: tokens.ColorFeedbackSuccessText
        }
      },
      interaction: {
        accent: {
          "01": tokens.ColorInteractionAccent01,
          "02": tokens.ColorInteractionAccent02,
          "03": tokens.ColorInteractionAccent03
        },
        blend: {
          "01": tokens.ColorInteractionBlend01,
          "02": tokens.ColorInteractionBlend02,
          "03": tokens.ColorInteractionBlend03,
          "04": tokens.ColorInteractionBlend04,
          "05": tokens.ColorInteractionBlend05,
          "06": tokens.ColorInteractionBlend06,
          "07": tokens.ColorInteractionBlend07,
          "08": tokens.ColorInteractionBlend08
        },
        danger: {
          "01": tokens.ColorInteractionDanger01,
          "02": tokens.ColorInteractionDanger02,
          "03": tokens.ColorInteractionDanger03
        },
        inverse: {
          accent: {
            "01": tokens.ColorInteractionInverseAccent01,
            "02": tokens.ColorInteractionInverseAccent02,
            "03": tokens.ColorInteractionInverseAccent03
          },
          blend: {
            "01": tokens.ColorInteractionInverseBlend01,
            "02": tokens.ColorInteractionInverseBlend02,
            "03": tokens.ColorInteractionInverseBlend03,
            "04": tokens.ColorInteractionInverseBlend04,
            "05": tokens.ColorInteractionInverseBlend05,
            "06": tokens.ColorInteractionInverseBlend06,
            "07": tokens.ColorInteractionInverseBlend07,
            "08": tokens.ColorInteractionInverseBlend08
          },
          danger: {
            "01": tokens.ColorInteractionInverseDanger01,
            "02": tokens.ColorInteractionInverseDanger02,
            "03": tokens.ColorInteractionInverseDanger03
          },
          on: {
            brand: {
              accent: {
                "01": tokens.ColorInteractionInverseOnBrandAccent01,
                "02": tokens.ColorInteractionInverseOnBrandAccent02,
                "03": tokens.ColorInteractionInverseOnBrandAccent03
              },
              blend: {
                "01": tokens.ColorInteractionInverseOnBrandBlend01,
                "02": tokens.ColorInteractionInverseOnBrandBlend02,
                "03": tokens.ColorInteractionInverseOnBrandBlend03,
                "04": tokens.ColorInteractionInverseOnBrandBlend04,
                "05": tokens.ColorInteractionInverseOnBrandBlend05,
                "06": tokens.ColorInteractionInverseOnBrandBlend06,
                "07": tokens.ColorInteractionInverseOnBrandBlend07,
                "08": tokens.ColorInteractionInverseOnBrandBlend08
              },
              danger: {
                "01": tokens.ColorInteractionInverseOnBrandDanger01,
                "02": tokens.ColorInteractionInverseOnBrandDanger02,
                "03": tokens.ColorInteractionInverseOnBrandDanger03
              },
              select: {
                active: tokens.ColorInteractionInverseOnBrandSelectActive,
                default: tokens.ColorInteractionInverseOnBrandSelectDefault,
                focus: tokens.ColorInteractionInverseOnBrandSelectFocus
              },
              subtle: {
                "01": tokens.ColorInteractionInverseOnBrandSubtle01,
                "02": tokens.ColorInteractionInverseOnBrandSubtle02,
                "03": tokens.ColorInteractionInverseOnBrandSubtle03
              }
            }
          },
          select: {
            active: tokens.ColorInteractionInverseSelectActive,
            default: tokens.ColorInteractionInverseSelectDefault,
            focus: tokens.ColorInteractionInverseSelectFocus
          },
          subtle: {
            "01": tokens.ColorInteractionInverseSubtle01,
            "02": tokens.ColorInteractionInverseSubtle02,
            "03": tokens.ColorInteractionInverseSubtle03
          }
        },
        on: {
          brand: {
            accent: {
              "01": tokens.ColorInteractionOnBrandAccent01,
              "02": tokens.ColorInteractionOnBrandAccent02,
              "03": tokens.ColorInteractionOnBrandAccent03
            },
            blend: {
              "01": tokens.ColorInteractionOnBrandBlend01,
              "02": tokens.ColorInteractionOnBrandBlend02,
              "03": tokens.ColorInteractionOnBrandBlend03,
              "04": tokens.ColorInteractionOnBrandBlend04,
              "05": tokens.ColorInteractionOnBrandBlend05,
              "06": tokens.ColorInteractionOnBrandBlend06,
              "07": tokens.ColorInteractionOnBrandBlend07,
              "08": tokens.ColorInteractionOnBrandBlend08
            },
            danger: {
              "01": tokens.ColorInteractionOnBrandDanger01,
              "02": tokens.ColorInteractionOnBrandDanger02,
              "03": tokens.ColorInteractionOnBrandDanger03
            },
            select: {
              active: tokens.ColorInteractionOnBrandSelectActive,
              default: tokens.ColorInteractionOnBrandSelectDefault,
              focus: tokens.ColorInteractionOnBrandSelectFocus
            },
            subtle: {
              "01": tokens.ColorInteractionOnBrandSubtle01,
              "02": tokens.ColorInteractionOnBrandSubtle02,
              "03": tokens.ColorInteractionOnBrandSubtle03
            }
          }
        },
        select: {
          active: tokens.ColorInteractionSelectActive,
          default: tokens.ColorInteractionSelectDefault,
          focus: tokens.ColorInteractionSelectFocus
        },
        subtle: {
          "01": tokens.ColorInteractionSubtle01,
          "02": tokens.ColorInteractionSubtle02,
          "03": tokens.ColorInteractionSubtle03
        }
      },
      neutral: {
        "00": tokens.ColorNeutral00,
        10: tokens.ColorNeutral10,
        20: tokens.ColorNeutral20,
        30: tokens.ColorNeutral30,
        inverse: {
          "00": tokens.ColorNeutralInverse00,
          10: tokens.ColorNeutralInverse10,
          20: tokens.ColorNeutralInverse20,
          30: tokens.ColorNeutralInverse30,
          on: {
            brand: {
              "00": tokens.ColorNeutralInverseOnBrand00,
              10: tokens.ColorNeutralInverseOnBrand10,
              20: tokens.ColorNeutralInverseOnBrand20,
              30: tokens.ColorNeutralInverseOnBrand30
            }
          }
        },
        on: {
          brand: {
            "00": tokens.ColorNeutralOnBrand00,
            10: tokens.ColorNeutralOnBrand10,
            20: tokens.ColorNeutralOnBrand20,
            30: tokens.ColorNeutralOnBrand30
          }
        }
      },
      support: {
        "01": tokens.ColorSupport01,
        "02": tokens.ColorSupport02,
        inverse: {
          "01": tokens.ColorSupportInverse01,
          "02": tokens.ColorSupportInverse02,
          on: {
            brand: {
              "01": tokens.ColorSupportInverseOnBrand01,
              "02": tokens.ColorSupportInverseOnBrand02
            }
          }
        },
        on: {
          brand: {
            "01": tokens.ColorSupportOnBrand01,
            "02": tokens.ColorSupportOnBrand02
          }
        }
      },
      typeface: {
        inverse: {
          meld: tokens.ColorTypefaceInverseMeld,
          on: {
            brand: {
              meld: tokens.ColorTypefaceInverseOnBrandMeld,
              pure: tokens.ColorTypefaceInverseOnBrandPure,
              smooth: tokens.ColorTypefaceInverseOnBrandSmooth,
              strong: tokens.ColorTypefaceInverseOnBrandStrong
            }
          },
          pure: tokens.ColorTypefaceInversePure,
          smooth: tokens.ColorTypefaceInverseSmooth,
          strong: tokens.ColorTypefaceInverseStrong
        },
        meld: tokens.ColorTypefaceMeld,
        on: {
          brand: {
            meld: tokens.ColorTypefaceOnBrandMeld,
            pure: tokens.ColorTypefaceOnBrandPure,
            smooth: tokens.ColorTypefaceOnBrandSmooth,
            strong: tokens.ColorTypefaceOnBrandStrong
          }
        },
        pure: tokens.ColorTypefacePure,
        smooth: tokens.ColorTypefaceSmooth,
        strong: tokens.ColorTypefaceStrong
      }
    };
    return __spreadProps$R(__spreadValues$1j({}, colorTokens), {
      accent: tokens.ColorSupport01,
      background: "inherit",
      muted: tokens.ColorPaletteGray50,
      palette,
      primary: tokens.ColorBrandPrimary40,
      secondary: tokens.ColorInteractionAccent01,
      text: "inherit"
    });
  };

  const radii = {
    circle: almaTokens.dasTokens.BorderRadiusCircle,
    lg: almaTokens.dasTokens.BorderRadiusLg,
    md: almaTokens.dasTokens.BorderRadiusMd,
    none: almaTokens.dasTokens.BorderRadiusNone,
    pill: almaTokens.dasTokens.BorderRadiusPill,
    sm: almaTokens.dasTokens.BorderRadiusSm,
    xs: almaTokens.dasTokens.BorderRadiusXs
  };

  const shadows = {
    "01": almaTokens.dasTokens.Shadow01,
    "02": almaTokens.dasTokens.Shadow02,
    "03": almaTokens.dasTokens.Shadow03,
    "04": almaTokens.dasTokens.Shadow04
  };

  const space$1 = {
    inline: {
      giant: almaTokens.dasTokens.SpacingInlineGiant,
      huge: almaTokens.dasTokens.SpacingInlineHuge,
      lg: almaTokens.dasTokens.SpacingInlineLg,
      md: almaTokens.dasTokens.SpacingInlineMd,
      nano: almaTokens.dasTokens.SpacingInlineNano,
      quark: almaTokens.dasTokens.SpacingInlineQuark,
      sm: almaTokens.dasTokens.SpacingInlineSm,
      xl: almaTokens.dasTokens.SpacingInlineXl,
      xs: almaTokens.dasTokens.SpacingInlineXs,
      xxl: almaTokens.dasTokens.SpacingInlineXxl,
      xxs: almaTokens.dasTokens.SpacingInlineXxs,
      xxxl: almaTokens.dasTokens.SpacingInlineXxxl,
      xxxs: almaTokens.dasTokens.SpacingInlineXxxs
    },
    inset: {
      lg: almaTokens.dasTokens.SpacingInsetLg,
      md: almaTokens.dasTokens.SpacingInsetMd,
      nano: almaTokens.dasTokens.SpacingInsetNano,
      quark: almaTokens.dasTokens.SpacingInsetQuark,
      sm: almaTokens.dasTokens.SpacingInsetSm,
      xs: almaTokens.dasTokens.SpacingInsetXs
    },
    squish: {
      nano: almaTokens.dasTokens.SpacingSquishNano,
      quark: almaTokens.dasTokens.SpacingSquishQuark,
      sm: almaTokens.dasTokens.SpacingSquishSm,
      xs: almaTokens.dasTokens.SpacingSquishXs
    },
    stack: {
      giant: almaTokens.dasTokens.SpacingStackGiant,
      huge: almaTokens.dasTokens.SpacingStackHuge,
      lg: almaTokens.dasTokens.SpacingStackLg,
      md: almaTokens.dasTokens.SpacingStackMd,
      nano: almaTokens.dasTokens.SpacingStackNano,
      quark: almaTokens.dasTokens.SpacingStackQuark,
      sm: almaTokens.dasTokens.SpacingStackSm,
      xl: almaTokens.dasTokens.SpacingStackXl,
      xs: almaTokens.dasTokens.SpacingStackXs,
      xxl: almaTokens.dasTokens.SpacingStackXxl,
      xxs: almaTokens.dasTokens.SpacingStackXxs,
      xxxl: almaTokens.dasTokens.SpacingStackXxxl,
      xxxs: almaTokens.dasTokens.SpacingStackXxxs
    }
  };

  const borderWidths = {
    hairline: almaTokens.dasTokens.BorderWidthHairline,
    heavy: almaTokens.dasTokens.BorderWidthHeavy,
    none: almaTokens.dasTokens.BorderWidthNone,
    thick: almaTokens.dasTokens.BorderWidthThick,
    thin: almaTokens.dasTokens.BorderWidthThin
  };

  const typography = {
    fontSizes: {
      display: almaTokens.dasTokens.FontSizeDisplay,
      giant: almaTokens.dasTokens.FontSizeGiant,
      lg: almaTokens.dasTokens.FontSizeLg,
      md: almaTokens.dasTokens.FontSizeMd,
      sm: almaTokens.dasTokens.FontSizeSm,
      xl: almaTokens.dasTokens.FontSizeXl,
      xs: almaTokens.dasTokens.FontSizeXs,
      xxl: almaTokens.dasTokens.FontSizeXxl,
      xxs: almaTokens.dasTokens.FontSizeXxs,
      xxxl: almaTokens.dasTokens.FontSizeXxxl,
      xxxs: almaTokens.dasTokens.FontSizeXxxs
    },
    letterSpacings: {
      medium: almaTokens.dasTokens.LetterSpacingMedium,
      small: almaTokens.dasTokens.LetterSpacingSmall,
      standard: almaTokens.dasTokens.LetterSpacingStandard
    },
    lineHeights: {
      distant: almaTokens.dasTokens.LineHeightDistant,
      huge: almaTokens.dasTokens.LineHeightHuge,
      large: almaTokens.dasTokens.LineHeightLarge,
      medium: almaTokens.dasTokens.LineHeightMedium,
      standard: almaTokens.dasTokens.LineHeightStandard,
      superdistant: almaTokens.dasTokens.LineHeightSuperdistant,
      tiny: almaTokens.dasTokens.LineHeightTiny
    }
  };
  const fonts = {
    base: almaTokens.dasTokens.FontFamilyBase
  };
  const fontWeights = {
    bold: almaTokens.dasTokens.FontWeightBold,
    light: almaTokens.dasTokens.FontWeightLight,
    medium: almaTokens.dasTokens.FontWeightMedium,
    regular: almaTokens.dasTokens.FontWeightRegular,
    semibold: almaTokens.dasTokens.FontWeightSemibold
  };

  const breakpoints = ["37.5rem", "52.5rem", "64rem", "90rem"];

  const forms = {
    input: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      borderWidth: 1,
      fontFamily: "base",
      outline: "none"
    },
    label: {
      color: "grays.60",
      fontSize: 1,
      fontWeight: "normal",
      margin: 0,
      width: "auto"
    },
    select: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      fontFamily: "base"
    },
    slider: {
      bg: "muted"
    },
    textarea: {
      "&:focus": {
        borderColor: "primary",
        borderWidth: 1,
        outline: "none"
      },
      borderColor: "grays.60",
      fontFamily: "base"
    }
  };

  const text = {
    default: {
      color: "inherit"
    },
    h0: {
      fontSize: 7,
      fontWeight: "bold"
    },
    h1: {
      fontSize: 6,
      fontWeight: "bold"
    },
    h2: {
      fontSize: 5,
      fontWeight: "bold"
    },
    h3: {
      fontSize: 4,
      fontWeight: "bold"
    },
    h4: {
      fontSize: 3,
      fontWeight: "bold"
    },
    h5: {
      fontSize: 2,
      fontWeight: "bold"
    },
    h6: {
      fontSize: 1,
      fontWeight: "bold"
    }
  };

  const opacities = {
    "01": almaTokens.dasTokens.Opacity01,
    "02": almaTokens.dasTokens.Opacity02,
    "03": almaTokens.dasTokens.Opacity03,
    "04": almaTokens.dasTokens.Opacity04,
    "05": almaTokens.dasTokens.Opacity05,
    "06": almaTokens.dasTokens.Opacity06,
    "07": almaTokens.dasTokens.Opacity07,
    "08": almaTokens.dasTokens.Opacity08
  };

  var __defProp$1i = Object.defineProperty;
  var __defProps$Q = Object.defineProperties;
  var __getOwnPropDescs$Q = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1i = Object.getOwnPropertySymbols;
  var __hasOwnProp$1i = Object.prototype.hasOwnProperty;
  var __propIsEnum$1i = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1i = (obj, key, value) => key in obj ? __defProp$1i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1i = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1i.call(b, prop))
        __defNormalProp$1i(a, prop, b[prop]);
    if (__getOwnPropSymbols$1i)
      for (var prop of __getOwnPropSymbols$1i(b)) {
        if (__propIsEnum$1i.call(b, prop))
          __defNormalProp$1i(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$Q = (a, b) => __defProps$Q(a, __getOwnPropDescs$Q(b));
  const { lineHeights, fontSizes, letterSpacings } = typography;
  const getCustomTheme = (defaultTokens, modes) => {
    const getCustomModes = () => {
      if (modes && modes.length > 0) {
        const modesObject = {};
        modes.forEach((mode) => {
          const { name, tokens } = mode;
          return modesObject[name] = getThemedColorTokens(tokens);
        });
        return modesObject;
      }
      return {};
    };
    return {
      borderWidths,
      breakpoints,
      colors: __spreadProps$Q(__spreadValues$1i({}, getThemedColorTokens(defaultTokens)), {
        modes: getCustomModes()
      }),
      config: {
        initialColorModeName: "default",
        printColorModeName: "default",
        useColorSchemeMediaQuery: false,
        useLocalStorage: false
      },
      fontSizes,
      fontWeights,
      fonts,
      forms,
      letterSpacings,
      lineHeights,
      opacities,
      radii,
      shadows,
      space: space$1,
      text
    };
  };
  const defaultColors = getThemedColorTokens();
  const defaultTheme$1 = getCustomTheme();

  var isMergeableObject = function isMergeableObject(value) {
  	return isNonNullObject(value)
  		&& !isSpecial(value)
  };

  function isNonNullObject(value) {
  	return !!value && typeof value === 'object'
  }

  function isSpecial(value) {
  	var stringValue = Object.prototype.toString.call(value);

  	return stringValue === '[object RegExp]'
  		|| stringValue === '[object Date]'
  		|| isReactElement(value)
  }

  // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
  var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

  function isReactElement(value) {
  	return value.$$typeof === REACT_ELEMENT_TYPE
  }

  function emptyTarget(val) {
  	return Array.isArray(val) ? [] : {}
  }

  function cloneUnlessOtherwiseSpecified(value, options) {
  	return (options.clone !== false && options.isMergeableObject(value))
  		? deepmerge(emptyTarget(value), value, options)
  		: value
  }

  function defaultArrayMerge(target, source, options) {
  	return target.concat(source).map(function(element) {
  		return cloneUnlessOtherwiseSpecified(element, options)
  	})
  }

  function getMergeFunction(key, options) {
  	if (!options.customMerge) {
  		return deepmerge
  	}
  	var customMerge = options.customMerge(key);
  	return typeof customMerge === 'function' ? customMerge : deepmerge
  }

  function getEnumerableOwnPropertySymbols(target) {
  	return Object.getOwnPropertySymbols
  		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
  			return target.propertyIsEnumerable(symbol)
  		})
  		: []
  }

  function getKeys(target) {
  	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
  }

  function propertyIsOnObject(object, property) {
  	try {
  		return property in object
  	} catch(_) {
  		return false
  	}
  }

  // Protects from prototype poisoning and unexpected merging up the prototype chain.
  function propertyIsUnsafe(target, key) {
  	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
  		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
  			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
  }

  function mergeObject(target, source, options) {
  	var destination = {};
  	if (options.isMergeableObject(target)) {
  		getKeys(target).forEach(function(key) {
  			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
  		});
  	}
  	getKeys(source).forEach(function(key) {
  		if (propertyIsUnsafe(target, key)) {
  			return
  		}

  		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
  			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
  		} else {
  			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
  		}
  	});
  	return destination
  }

  function deepmerge(target, source, options) {
  	options = options || {};
  	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
  	// implementations can use it. The caller may not replace it.
  	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

  	var sourceIsArray = Array.isArray(source);
  	var targetIsArray = Array.isArray(target);
  	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  	if (!sourceAndTargetTypesMatch) {
  		return cloneUnlessOtherwiseSpecified(source, options)
  	} else if (sourceIsArray) {
  		return options.arrayMerge(target, source, options)
  	} else {
  		return mergeObject(target, source, options)
  	}
  }

  deepmerge.all = function deepmergeAll(array, options) {
  	if (!Array.isArray(array)) {
  		throw new Error('first argument should be an array')
  	}

  	return array.reduce(function(prev, next) {
  		return deepmerge(prev, next, options)
  	}, {})
  };

  var deepmerge_1 = deepmerge;

  var cjs = deepmerge_1;

  /**
   * Allows for nested scales with shorthand values
   * @example
   * {
   *   colors: {
   *     primary: { __default: '#00f', light: '#33f' }
   *   }
   * }
   * css({ color: 'primary' }); // { color: '#00f' }
   * css({ color: 'primary.light' }) // { color: '#33f' }
   */

  const THEME_UI_DEFAULT_KEY = '__default';

  const hasDefault = x => {
    return typeof x === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x;
  };
  /**
   * Extracts value under path from a deeply nested object.
   * Used for Themes, variants and Theme UI style objects.
   * Given a path to object with `__default` key, returns the value under that key.
   *
   * @param obj a theme, variant or style object
   * @param path path separated with dots (`.`)
   * @param fallback default value returned if get(obj, path) is not found
   */


  function get$1(obj, path, fallback, p, undef) {
    const pathArray = path && typeof path === 'string' ? path.split('.') : [path];

    for (p = 0; p < pathArray.length; p++) {
      obj = obj ? obj[pathArray[p]] : undef;
    }

    if (obj === undef) return fallback;
    return hasDefault(obj) ? obj[THEME_UI_DEFAULT_KEY] : obj;
  }
  const getObjectWithVariants = (obj, theme) => {
    if (obj && obj['variant']) {
      let result = {};

      for (const key in obj) {
        const x = obj[key];

        if (key === 'variant') {
          const val = typeof x === 'function' ? x(theme) : x;
          const variant = getObjectWithVariants(get$1(theme, val), theme);
          result = { ...result,
            ...variant
          };
        } else {
          result[key] = x;
        }
      }

      return result;
    }

    return obj;
  };
  const defaultBreakpoints = [40, 52, 64].map(n => n + 'em');
  const defaultTheme = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
  };
  const aliases = {
    bg: 'backgroundColor',
    m: 'margin',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    mx: 'marginX',
    my: 'marginY',
    p: 'padding',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    px: 'paddingX',
    py: 'paddingY'
  };
  const multiples = {
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    scrollMarginX: ['scrollMarginLeft', 'scrollMarginRight'],
    scrollMarginY: ['scrollMarginTop', 'scrollMarginBottom'],
    scrollPaddingX: ['scrollPaddingLeft', 'scrollPaddingRight'],
    scrollPaddingY: ['scrollPaddingTop', 'scrollPaddingBottom'],
    size: ['width', 'height']
  };
  const scales = {
    color: 'colors',
    backgroundColor: 'colors',
    borderColor: 'colors',
    caretColor: 'colors',
    columnRuleColor: 'colors',
    textDecorationColor: 'colors',
    opacity: 'opacities',
    transition: 'transitions',
    margin: 'space',
    marginTop: 'space',
    marginRight: 'space',
    marginBottom: 'space',
    marginLeft: 'space',
    marginX: 'space',
    marginY: 'space',
    marginBlock: 'space',
    marginBlockEnd: 'space',
    marginBlockStart: 'space',
    marginInline: 'space',
    marginInlineEnd: 'space',
    marginInlineStart: 'space',
    padding: 'space',
    paddingTop: 'space',
    paddingRight: 'space',
    paddingBottom: 'space',
    paddingLeft: 'space',
    paddingX: 'space',
    paddingY: 'space',
    paddingBlock: 'space',
    paddingBlockEnd: 'space',
    paddingBlockStart: 'space',
    paddingInline: 'space',
    paddingInlineEnd: 'space',
    paddingInlineStart: 'space',
    scrollMargin: 'space',
    scrollMarginTop: 'space',
    scrollMarginRight: 'space',
    scrollMarginBottom: 'space',
    scrollMarginLeft: 'space',
    scrollMarginX: 'space',
    scrollMarginY: 'space',
    scrollPadding: 'space',
    scrollPaddingTop: 'space',
    scrollPaddingRight: 'space',
    scrollPaddingBottom: 'space',
    scrollPaddingLeft: 'space',
    scrollPaddingX: 'space',
    scrollPaddingY: 'space',
    inset: 'space',
    insetBlock: 'space',
    insetBlockEnd: 'space',
    insetBlockStart: 'space',
    insetInline: 'space',
    insetInlineEnd: 'space',
    insetInlineStart: 'space',
    top: 'space',
    right: 'space',
    bottom: 'space',
    left: 'space',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    gap: 'space',
    columnGap: 'space',
    rowGap: 'space',
    fontFamily: 'fonts',
    fontSize: 'fontSizes',
    fontWeight: 'fontWeights',
    lineHeight: 'lineHeights',
    letterSpacing: 'letterSpacings',
    border: 'borders',
    borderTop: 'borders',
    borderRight: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderWidth: 'borderWidths',
    borderStyle: 'borderStyles',
    borderRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderTopWidth: 'borderWidths',
    borderTopColor: 'colors',
    borderTopStyle: 'borderStyles',
    borderBottomWidth: 'borderWidths',
    borderBottomColor: 'colors',
    borderBottomStyle: 'borderStyles',
    borderLeftWidth: 'borderWidths',
    borderLeftColor: 'colors',
    borderLeftStyle: 'borderStyles',
    borderRightWidth: 'borderWidths',
    borderRightColor: 'colors',
    borderRightStyle: 'borderStyles',
    borderBlock: 'borders',
    borderBlockColor: 'colors',
    borderBlockEnd: 'borders',
    borderBlockEndColor: 'colors',
    borderBlockEndStyle: 'borderStyles',
    borderBlockEndWidth: 'borderWidths',
    borderBlockStart: 'borders',
    borderBlockStartColor: 'colors',
    borderBlockStartStyle: 'borderStyles',
    borderBlockStartWidth: 'borderWidths',
    borderBlockStyle: 'borderStyles',
    borderBlockWidth: 'borderWidths',
    borderEndEndRadius: 'radii',
    borderEndStartRadius: 'radii',
    borderInline: 'borders',
    borderInlineColor: 'colors',
    borderInlineEnd: 'borders',
    borderInlineEndColor: 'colors',
    borderInlineEndStyle: 'borderStyles',
    borderInlineEndWidth: 'borderWidths',
    borderInlineStart: 'borders',
    borderInlineStartColor: 'colors',
    borderInlineStartStyle: 'borderStyles',
    borderInlineStartWidth: 'borderWidths',
    borderInlineStyle: 'borderStyles',
    borderInlineWidth: 'borderWidths',
    borderStartEndRadius: 'radii',
    borderStartStartRadius: 'radii',
    columnRuleWidth: 'borderWidths',
    outlineColor: 'colors',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    flexBasis: 'sizes',
    size: 'sizes',
    blockSize: 'sizes',
    inlineSize: 'sizes',
    maxBlockSize: 'sizes',
    maxInlineSize: 'sizes',
    minBlockSize: 'sizes',
    minInlineSize: 'sizes',
    columnWidth: 'sizes',
    // svg
    fill: 'colors',
    stroke: 'colors'
  };

  const positiveOrNegative = (scale, value) => {
    if (typeof value !== 'number' || value >= 0) {
      if (typeof value === 'string' && value.startsWith('-')) {
        const valueWithoutMinus = value.substring(1);
        const n = get$1(scale, valueWithoutMinus, valueWithoutMinus);

        if (typeof n === 'number') {
          return n * -1;
        }

        return `-${n}`;
      }

      return get$1(scale, value, value);
    }

    const absolute = Math.abs(value);
    const n = get$1(scale, absolute, absolute);
    if (typeof n === 'string') return '-' + n;
    return Number(n) * -1;
  };

  const transforms = ['margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginBlock', 'marginBlockEnd', 'marginBlockStart', 'marginInline', 'marginInlineEnd', 'marginInlineStart', 'top', 'bottom', 'left', 'right'].reduce((acc, curr) => ({ ...acc,
    [curr]: positiveOrNegative
  }), {});

  const responsive = styles => theme => {
    const next = {};
    const breakpoints = theme && theme.breakpoints || defaultBreakpoints;
    const mediaQueries = [null, ...breakpoints.map(n => n.includes('@media') ? n : `@media screen and (min-width: ${n})`)];

    for (const k in styles) {
      const key = k;
      let value = styles[key];

      if (typeof value === 'function') {
        value = value(theme || {});
      }

      if (value === false || value == null) {
        continue;
      }

      if (!Array.isArray(value)) {
        next[key] = value;
        continue;
      }

      for (let i = 0; i < value.slice(0, mediaQueries.length).length; i++) {
        const media = mediaQueries[i];

        if (!media) {
          next[key] = value[i];
          continue;
        }

        next[media] = next[media] || {};
        if (value[i] == null) continue;
        next[media][key] = value[i];
      }
    }

    return next;
  };

  const css = (args = {}) => (props = {}) => {
    const theme = { ...defaultTheme,
      ...('theme' in props ? props.theme : props)
    }; // insert variant props before responsive styles, so they can be merged
    // we need to maintain order of the style props, so if a variant is place in the middle
    // of other props, it will extends its props at that same location order.

    const obj = getObjectWithVariants(typeof args === 'function' ? args(theme) : args, theme);
    const styles = responsive(obj)(theme);
    let result = {};

    for (const key in styles) {
      const x = styles[key];
      const val = typeof x === 'function' ? x(theme) : x;

      if (val && typeof val === 'object') {
        if (hasDefault(val)) {
          result[key] = val[THEME_UI_DEFAULT_KEY];
          continue;
        } // On type level, val can also be an array here,
        // but we transform all arrays in `responsive` function.


        result[key] = css(val)(theme);
        continue;
      }

      const prop = key in aliases ? aliases[key] : key;
      const scaleName = prop in scales ? scales[prop] : undefined;
      const scale = scaleName ? theme == null ? void 0 : theme[scaleName] : get$1(theme, prop, {});
      const transform = get$1(transforms, prop, get$1);
      const value = transform(scale, val, val);

      if (prop in multiples) {
        const dirs = multiples[prop];

        for (let i = 0; i < dirs.length; i++) {
          result[dirs[i]] = value;
        }
      } else {
        result[prop] = value;
      }
    }

    return result;
  };

  const getCSS = props => theme => {
    const styles = css(props.sx)(theme);
    const raw = typeof props.css === 'function' ? props.css(theme) : props.css;
    return [styles, raw];
  };

  const parseProps = props => {
    if (!props || !props.sx && !props.css) return props;
    const next = {};

    for (let key in props) {
      if (key === 'sx') continue;
      next[key] = props[key];
    }

    next.css = getCSS(props);
    return next;
  };

  var parseProps$1 = parseProps;

  const __EMOTION_VERSION__ = packageInfo__default["default"].version;
  const jsx = (type, props, ...children) => react.jsx(type, parseProps$1(props), ...children);

  /**
   * @internal
   */
  const __themeUiDefaultContextValue = {
    __EMOTION_VERSION__,
    theme: {}
  };
  /**
   * @internal
   */

  const __ThemeUIContext = /*#__PURE__*/React.createContext(__themeUiDefaultContextValue);
  const useThemeUI = () => React.useContext(__ThemeUIContext);
  const canUseSymbol = typeof Symbol === 'function' && Symbol.for;
  const REACT_ELEMENT = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
  const FORWARD_REF = canUseSymbol ? Symbol.for('react.forward_ref') : 0xeac7;
  const deepmergeOptions = {
    isMergeableObject: n => {
      return !!n && typeof n === 'object' && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
    },
    arrayMerge: (_leftArray, rightArray) => rightArray
  };
  /**
   * Deeply merge themes
   */

  const merge$1 = (a, b) => cjs(a, b, deepmergeOptions);

  function mergeAll(...args) {
    return cjs.all(args, deepmergeOptions);
  }

  merge$1.all = mergeAll;

  /**
   * @internal
   */
  const __ThemeUIInternalBaseThemeProvider = ({
    context,
    children
  }) => jsx(react.ThemeContext.Provider, {
    value: context.theme
  }, jsx(__ThemeUIContext.Provider, {
    value: context,
    children
  }));
  function ThemeProvider$1({
    theme,
    children
  }) {
    const outer = useThemeUI();

    if (process.env.NODE_ENV !== 'production') {
      if (outer.__EMOTION_VERSION__ !== __EMOTION_VERSION__) {
        console.warn('Multiple versions of Emotion detected,', 'and theming might not work as expected.', 'Please ensure there is only one copy of @emotion/react installed in your application.');
      }
    }

    const context = typeof theme === 'function' ? { ...outer,
      theme: theme(outer.theme)
    } : merge$1.all({}, outer, {
      theme
    });
    return jsx(__ThemeUIInternalBaseThemeProvider, {
      context,
      children
    });
  }

  const DasaSansFontFace = styled.css`
    @font-face {
        font-family: 'Dasa Sans';
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Bold.eot');
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Bold.eot?#iefix') format('embedded-opentype'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff/DasaSans-Bold.woff') format('woff'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff2/DasaSans-Bold.woff2') format('woff2');
        font-weight: 700;
    }
    @font-face {
        font-family: 'Dasa Sans';
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Semibold.eot');
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Semibold.eot?#iefix') format('embedded-opentype'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff/DasaSans-Semibold.woff') format('woff'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff2/DasaSans-Semibold.woff2') format('woff2');
        font-weight: 600;
    }
    @font-face {
        font-family: 'Dasa Sans';
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Medium.eot');
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Medium.eot?#iefix') format('embedded-opentype'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff/DasaSans-Medium.woff') format('woff'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff2/DasaSans-Medium.woff2') format('woff2');
        font-weight: 500;
    }
    @font-face {
        font-family: 'Dasa Sans';
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Regular.eot');
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Regular.eot?#iefix') format('embedded-opentype'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff/DasaSans-Regular.woff') format('woff'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff2/DasaSans-Regular.woff2') format('woff2');
        font-weight: 400;
    }
    @font-face {
        font-family: 'Dasa Sans';
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Light.eot');
        src: url('https://alma-assets-hml.dasaexp.io/fonts/eot/DasaSans-Light.eot?#iefix') format('embedded-opentype'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff/DasaSans-Light.woff') format('woff'),
            url('https://alma-assets-hml.dasaexp.io/fonts/woff2/DasaSans-Light.woff2') format('woff2');
        font-weight: 300;
    }
`;

  var css_248z$1 = ".tippy-box[data-animation=fade][data-state=hidden]{opacity:0}[data-tippy-root]{max-width:calc(100vw - 10px)}.tippy-box{position:relative;background-color:#333;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;white-space:normal;outline:0;transition-property:transform,visibility,opacity}.tippy-box[data-placement^=top]>.tippy-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-arrow:before{bottom:-7px;left:0;border-width:8px 8px 0;border-top-color:initial;transform-origin:center top}.tippy-box[data-placement^=bottom]>.tippy-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-arrow:before{top:-7px;left:0;border-width:0 8px 8px;border-bottom-color:initial;transform-origin:center bottom}.tippy-box[data-placement^=left]>.tippy-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-arrow:before{border-width:8px 0 8px 8px;border-left-color:initial;right:-7px;transform-origin:center left}.tippy-box[data-placement^=right]>.tippy-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-arrow:before{left:-7px;border-width:8px 8px 8px 0;border-right-color:initial;transform-origin:center right}.tippy-box[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{width:16px;height:16px;color:#333}.tippy-arrow:before{content:\"\";position:absolute;border-color:transparent;border-style:solid}.tippy-content{position:relative;padding:5px 9px;z-index:1}";

  var css_248z = ".tippy-box[data-placement^=top]>.tippy-svg-arrow{bottom:0}.tippy-box[data-placement^=top]>.tippy-svg-arrow:after,.tippy-box[data-placement^=top]>.tippy-svg-arrow>svg{top:16px;transform:rotate(180deg)}.tippy-box[data-placement^=bottom]>.tippy-svg-arrow{top:0}.tippy-box[data-placement^=bottom]>.tippy-svg-arrow>svg{bottom:16px}.tippy-box[data-placement^=left]>.tippy-svg-arrow{right:0}.tippy-box[data-placement^=left]>.tippy-svg-arrow:after,.tippy-box[data-placement^=left]>.tippy-svg-arrow>svg{transform:rotate(90deg);top:calc(50% - 3px);left:11px}.tippy-box[data-placement^=right]>.tippy-svg-arrow{left:0}.tippy-box[data-placement^=right]>.tippy-svg-arrow:after,.tippy-box[data-placement^=right]>.tippy-svg-arrow>svg{transform:rotate(-90deg);top:calc(50% - 3px);right:11px}.tippy-svg-arrow{width:16px;height:16px;fill:#333;text-align:initial}.tippy-svg-arrow,.tippy-svg-arrow>svg{position:absolute}";

  const GlobalStylesCoreCss = styled.css`
    ${css_248z$1}
    ${css_248z}
`;
  const GlobalStylesCore = styled.createGlobalStyle`
    ${GlobalStylesCoreCss}
`;

  const GlobalStyles = styled.createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        border: 0;
        vertical-align: baseline;
        font-family: 'Dasa Sans', Arial, 'Lato', sans-serif;
    }
    *:focus {
        outline: none;
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        line-height: 1;
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    ${GlobalStylesCoreCss}
    ${DasaSansFontFace}
`;

  const toVarName = key => `--theme-ui-${key.replace('-__default', '')}`;

  const toVarValue = key => `var(${toVarName(key)})`;

  const join = (...args) => args.filter(Boolean).join('-');

  const reservedKeys = new Set(['useCustomProperties', 'initialColorModeName', 'printColorModeName', 'initialColorMode', 'useLocalStorage', 'config']); // convert theme values to custom properties

  const toCustomProperties = (obj, parent) => {
    const next = Array.isArray(obj) ? [] : {};

    for (let key in obj) {
      const value = obj[key];
      const name = join(parent, key);

      if (value && typeof value === 'object') {
        next[key] = toCustomProperties(value, name);
        continue;
      }

      if (reservedKeys.has(key)) {
        next[key] = value;
        continue;
      }

      next[key] = toVarValue(name);
    }

    return next;
  };
  /**
   * @internal
   * Recursively transforms an object into CSS variables excluding "modes" key.
   */

  const __objectToVars = (parent, obj) => {
    let vars = {};

    for (let key in obj) {
      if (key === 'modes') continue;
      const name = join(parent, key);
      const value = obj[key];

      if (value && typeof value === 'object') {
        vars = { ...vars,
          ...__objectToVars(name, value)
        };
      } else {
        vars[toVarName(name)] = value;
      }
    }

    return vars;
  };
  /**
   * @internal
   * Creates root styles for color modes.
   * - Transforms color scale into CSS variables.
   * - Sets background and text color.
   */

  const __createColorStyles = (theme = {}) => {
    const {
      useCustomProperties,
      initialColorModeName,
      printColorModeName,
      useRootStyles
    } = theme.config || theme || {};
    const colors = theme.rawColors || theme.colors;
    if (!colors || useRootStyles === false) return {};

    if (useCustomProperties === false) {
      return css({
        color: 'text',
        bg: 'background'
      })(theme);
    }

    const modes = colors.modes || {};

    const styles = __createColorProperties(colors, modes);

    if (printColorModeName) {
      const mode = printColorModeName === 'initial' || printColorModeName === initialColorModeName ? colors : modes[printColorModeName];
      styles['@media print'] = __objectToVars('colors', mode);
    }

    const colorToVarValue = color => toVarValue(`colors-${color}`);

    return css({ ...styles,
      color: colorToVarValue('text'),
      bg: colorToVarValue('background')
    })(theme);
  };
  /**
   * @internal
   * Returns an object with colors turned into Custom CSS Properties and
   * .theme-ui-<colormode> classes used for no-flash serverside rendering.
   */

  function __createColorProperties(colors, modes) {
    const styles = __objectToVars('colors', colors);

    Object.keys(modes).forEach(mode => {
      const className = `.theme-ui-${mode}`;
      const key = `&${className}, ${className} &`;
      styles[key] = __objectToVars('colors', modes[mode]);
    });
    return styles;
  }

  const STORAGE_KEY = 'theme-ui-color-mode';
  const DARK_QUERY = '(prefers-color-scheme: dark)';
  const LIGHT_QUERY = '(prefers-color-scheme: light)';
  const storage = {
    get: () => {
      try {
        return window.localStorage.getItem(STORAGE_KEY);
      } catch (err) {
        console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
      }
    },
    set: value => {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (err) {
        console.warn('localStorage is disabled and color mode might not work as expected.', 'Please check your Site Settings.', err);
      }
    }
  };

  const getPreferredColorScheme = () => {
    if (typeof window !== 'undefined' && window.matchMedia) {
      if (window.matchMedia(DARK_QUERY).matches) {
        return 'dark';
      }

      if (window.matchMedia(LIGHT_QUERY).matches) {
        return 'light';
      }
    }

    return null;
  };

  const useClientsideEffect = typeof window === 'undefined' ? () => {} : React.useLayoutEffect;

  const TopLevelColorModeProvider = ({
    outerCtx,
    children
  }) => {
    const outerTheme = outerCtx.theme || {};
    const {
      initialColorModeName,
      useColorSchemeMediaQuery,
      useLocalStorage
    } = outerTheme.config || outerTheme;
    let [colorMode, setColorMode] = React.useState(() => {
      const preferredMode = useColorSchemeMediaQuery !== false && getPreferredColorScheme();
      return preferredMode || initialColorModeName;
    }); // on first render, we read the color mode from localStorage and
    // clear the class on document element body

    useClientsideEffect(() => {
      const stored = useLocalStorage !== false && storage.get();

      if (typeof document !== 'undefined') {
        document.documentElement.classList.remove('theme-ui-' + stored);
      }

      if (useColorSchemeMediaQuery !== 'system' && stored && stored !== colorMode) {
        colorMode = stored;
        setColorMode(stored);
      }
    }, []); // when mode changes, we save it to localStorage

    React.useEffect(() => {
      if (colorMode && useLocalStorage !== false) {
        storage.set(colorMode);
      }
    }, [colorMode, useLocalStorage]);
    const setPreferredColorScheme = React.useCallback(() => {
      const preferredColorScheme = getPreferredColorScheme();
      setColorMode(preferredColorScheme || initialColorModeName);
    }, [initialColorModeName]);
    React.useEffect(() => {
      if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
        // It doesn't matter if we add the listener only to the dark media query
        // Because in our callback function we'll check for both media queries (light and dark).
        const darkMQL = window.matchMedia(DARK_QUERY);

        if (typeof darkMQL.addEventListener === 'function') {
          darkMQL.addEventListener('change', setPreferredColorScheme);
        } else if (typeof darkMQL.addListener === 'function') {
          darkMQL.addListener(setPreferredColorScheme);
        }
      }

      return () => {
        if (useColorSchemeMediaQuery === 'system' && window.matchMedia) {
          const darkMQL = window.matchMedia(DARK_QUERY);

          if (typeof darkMQL.removeEventListener === 'function') {
            darkMQL.removeEventListener('change', setPreferredColorScheme);
          } else if (typeof darkMQL.removeListener === 'function') {
            darkMQL.removeListener(setPreferredColorScheme);
          }
        }
      };
    }, [useColorSchemeMediaQuery, setPreferredColorScheme]);

    if (process.env.NODE_ENV !== 'production') {
      var _outerTheme$colors;

      if ((_outerTheme$colors = outerTheme.colors) != null && _outerTheme$colors.modes && initialColorModeName && Object.keys(outerTheme.colors.modes).indexOf(initialColorModeName) > -1) {
        console.warn('[theme-ui] The `initialColorModeName` value should be a unique name' + ' and cannot reference a key in `theme.colors.modes`.');
      }
    }

    const newTheme = useThemeWithAppliedColorMode({
      colorMode,
      outerTheme
    });
    const newCtx = { ...outerCtx,
      theme: newTheme,
      colorMode,
      setColorMode
    };
    return /*#__PURE__*/React__default["default"].createElement(__ThemeUIInternalBaseThemeProvider, {
      context: newCtx
    }, /*#__PURE__*/React__default["default"].createElement(GlobalColorStyles, {
      theme: newTheme
    }), children);
  };

  function useColorMode() {
    const {
      colorMode,
      setColorMode
    } = useThemeUI();

    if (typeof setColorMode !== 'function') {
      throw new Error(`[useColorMode] requires the ColorModeProvider component`);
    } // We're allowing the user to specify a narrower type for its color mode name.


    return [colorMode, setColorMode];
  }

  const omitModes = colors => {
    const res = { ...colors
    };
    delete res.modes;
    return res;
  };

  function copyRawColors(colors, outerThemeRawColors) {
    for (const [key, value] of Object.entries(colors)) {
      if (typeof value === 'string' && !value.startsWith('var(')) {
        outerThemeRawColors[key] = value;
      } else if (typeof value === 'object') {
        const newValue = { ...outerThemeRawColors[key]
        };
        copyRawColors(value, newValue);
        outerThemeRawColors[key] = newValue;
      }
    }
  }

  function useThemeWithAppliedColorMode({
    outerTheme,
    colorMode
  }) {
    const theme = React.useMemo(() => {
      const res = { ...outerTheme
      };
      const modes = get$1(res, 'colors.modes', {});
      const currentColorMode = get$1(modes, colorMode, {});

      if (colorMode) {
        res.colors = { ...res.colors,
          ...currentColorMode
        };
      }

      const {
        useCustomProperties,
        initialColorModeName = '__default'
      } = outerTheme.config || outerTheme;
      let outerThemeRawColors = outerTheme.rawColors || outerTheme.colors || {};

      if (useCustomProperties !== false) {
        const alreadyHasRawColors = res.rawColors != null;
        const colors = res.colors || {};

        if (alreadyHasRawColors) {
          outerThemeRawColors = { ...outerThemeRawColors
          };
          copyRawColors(colors, outerThemeRawColors);

          if (outerThemeRawColors.modes) {
            outerThemeRawColors.modes[initialColorModeName] = omitModes(outerThemeRawColors);
          }

          res.rawColors = outerThemeRawColors;
        } else {
          if (!('modes' in outerThemeRawColors)) {
            res.rawColors = colors;
          } else {
            const modes = {
              [initialColorModeName]: omitModes(outerThemeRawColors),
              ...outerThemeRawColors.modes
            };
            res.rawColors = { ...colors,
              modes
            };
            /* modes doesn't match index signature by design */
          }
        }

        res.colors = toCustomProperties(omitModes(outerThemeRawColors), 'colors');
      }

      return res;
    }, [colorMode, outerTheme]);
    return theme;
  }

  function GlobalColorStyles({
    theme
  }) {
    return jsx(react.Global, {
      styles: () => {
        return {
          html: __createColorStyles(theme)
        };
      }
    });
  }

  function NestedColorModeProvider({
    outerCtx,
    children
  }) {
    var _newTheme$config2;

    const newTheme = useThemeWithAppliedColorMode({
      outerTheme: outerCtx.theme,
      colorMode: outerCtx.colorMode
    }); // Nested theme providers need to be rerendered after hydration for the correct
    // color mode to apply.

    const [needsRerender, setNeedsRerender] = React.useState( // Note: we could also check some "ssr-enabled" flag as an optimization for
    // SPAs, as deeply nested theme providers will also pay a performance penalty
    // for this SSR bug fix
    () => {
      var _newTheme$config;

      return ((_newTheme$config = newTheme.config) == null ? void 0 : _newTheme$config.useLocalStorage) !== false;
    });
    useClientsideEffect(() => void setNeedsRerender(false), []);
    const themeColors = newTheme.rawColors || newTheme.colors;
    const useCustomProperties = (_newTheme$config2 = newTheme.config) == null ? void 0 : _newTheme$config2.useCustomProperties;
    const colorVars = React.useMemo(() => {
      if (useCustomProperties === false) {
        return {};
      }

      const colors = themeColors || {};
      return css(__createColorProperties(colors, colors.modes || {}))(newTheme);
    }, [newTheme, themeColors, useCustomProperties]);
    return /*#__PURE__*/React__default["default"].createElement(__ThemeUIInternalBaseThemeProvider, {
      context: { ...outerCtx,
        theme: newTheme
      }
    }, jsx('div', {
      'data-themeui-nested-provider': true,
      // the key here ensures that children will be rerendered after color
      // mode is read from localStorage
      key: Number(needsRerender),
      suppressHydrationWarning: true,
      css: colorVars,
      children
    }));
  }

  const ColorModeProvider = ({
    children
  }) => {
    const outerCtx = useThemeUI();
    const isTopLevelColorModeProvider = typeof outerCtx.setColorMode !== 'function';
    return isTopLevelColorModeProvider ? /*#__PURE__*/React__default["default"].createElement(TopLevelColorModeProvider, {
      outerCtx: outerCtx
    }, children) : /*#__PURE__*/React__default["default"].createElement(NestedColorModeProvider, {
      outerCtx: outerCtx
    }, children);
  };

  var __defProp$1h = Object.defineProperty;
  var __getOwnPropSymbols$1h = Object.getOwnPropertySymbols;
  var __hasOwnProp$1h = Object.prototype.hasOwnProperty;
  var __propIsEnum$1h = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1h = (obj, key, value) => key in obj ? __defProp$1h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1h = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1h.call(b, prop))
        __defNormalProp$1h(a, prop, b[prop]);
    if (__getOwnPropSymbols$1h)
      for (var prop of __getOwnPropSymbols$1h(b)) {
        if (__propIsEnum$1h.call(b, prop))
          __defNormalProp$1h(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$X = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$1h.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1h)
      for (var prop of __getOwnPropSymbols$1h(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1h.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const useThemeContext = useThemeUI;
  const ThemeProvider = (_a) => {
    var _b = _a, {
      children,
      theme: themeProps,
      cleanGlobalStyle = false
    } = _b, props = __objRest$X(_b, [
      "children",
      "theme",
      "cleanGlobalStyle"
    ]);
    const customTheme = Object.assign(defaultTheme$1, themeProps || {});
    return /* @__PURE__ */ React__default["default"].createElement(ThemeProvider$1, {
      theme: (theme) => merge$1(theme, customTheme)
    }, cleanGlobalStyle ? /* @__PURE__ */ React__default["default"].createElement(GlobalStylesCore, null) : /* @__PURE__ */ React__default["default"].createElement(GlobalStyles, null), /* @__PURE__ */ React__default["default"].createElement(styled.ThemeProvider, __spreadValues$1h({
      theme: customTheme
    }, props), /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, children)));
  };

  function memoize$1(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var index$1 = memoize(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );

  var all = styledSystem.compose(styledSystem.space, styledSystem.typography, styledSystem.color, styledSystem.layout, styledSystem.flexbox, styledSystem.border, styledSystem.background, styledSystem.position, styledSystem.grid, styledSystem.shadow, styledSystem.buttonStyle, styledSystem.textStyle, styledSystem.colorStyle);
  var props = all.propNames;
  var createShouldForwardProp = function createShouldForwardProp(props) {
    var regex = new RegExp("^(" + props.join('|') + ")$");
    return memoize$1(function (prop) {
      return index$1(prop) && !regex.test(prop);
    });
  };
  createShouldForwardProp(props);

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty$1.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols) {
  			symbols = getOwnPropertySymbols(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  var merge = function merge(a, b) {
    var result = objectAssign({}, a, b);

    for (var key in a) {
      var _assign;

      if (!a[key] || typeof b[key] !== 'object') continue;
      objectAssign(result, (_assign = {}, _assign[key] = objectAssign(a[key], b[key]), _assign));
    }

    return result;
  }; // sort object-value responsive styles

  var sort = function sort(obj) {
    var next = {};
    Object.keys(obj).sort(function (a, b) {
      return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    }).forEach(function (key) {
      next[key] = obj[key];
    });
    return next;
  };

  var defaults$1 = {
    breakpoints: [40, 52, 64].map(function (n) {
      return n + 'em';
    })
  };

  var createMediaQuery = function createMediaQuery(n) {
    return "@media screen and (min-width: " + n + ")";
  };

  var getValue = function getValue(n, scale) {
    return get(scale, n, n);
  };

  var get = function get(obj, key, def, p, undef) {
    key = key && key.split ? key.split('.') : [key];

    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }

    return obj === undef ? def : obj;
  };
  var createParser = function createParser(config) {
    var cache = {};

    var parse = function parse(props) {
      var styles = {};
      var shouldSort = false;
      var isCacheDisabled = props.theme && props.theme.disableStyledSystemCache;

      for (var key in props) {
        if (!config[key]) continue;
        var sx = config[key];
        var raw = props[key];
        var scale = get(props.theme, sx.scale, sx.defaults);

        if (typeof raw === 'object') {
          cache.breakpoints = !isCacheDisabled && cache.breakpoints || get(props.theme, 'breakpoints', defaults$1.breakpoints);

          if (Array.isArray(raw)) {
            cache.media = !isCacheDisabled && cache.media || [null].concat(cache.breakpoints.map(createMediaQuery));
            styles = merge(styles, parseResponsiveStyle(cache.media, sx, scale, raw, props));
            continue;
          }

          if (raw !== null) {
            styles = merge(styles, parseResponsiveObject(cache.breakpoints, sx, scale, raw, props));
            shouldSort = true;
          }

          continue;
        }

        objectAssign(styles, sx(raw, scale, props));
      } // sort object-based responsive styles


      if (shouldSort) {
        styles = sort(styles);
      }

      return styles;
    };

    parse.config = config;
    parse.propNames = Object.keys(config);
    parse.cache = cache;
    var keys = Object.keys(config).filter(function (k) {
      return k !== 'config';
    });

    if (keys.length > 1) {
      keys.forEach(function (key) {
        var _createParser;

        parse[key] = createParser((_createParser = {}, _createParser[key] = config[key], _createParser));
      });
    }

    return parse;
  };

  var parseResponsiveStyle = function parseResponsiveStyle(mediaQueries, sx, scale, raw, _props) {
    var styles = {};
    raw.slice(0, mediaQueries.length).forEach(function (value, i) {
      var media = mediaQueries[i];
      var style = sx(value, scale, _props);

      if (!media) {
        objectAssign(styles, style);
      } else {
        var _assign2;

        objectAssign(styles, (_assign2 = {}, _assign2[media] = objectAssign({}, styles[media], style), _assign2));
      }
    });
    return styles;
  };

  var parseResponsiveObject = function parseResponsiveObject(breakpoints, sx, scale, raw, _props) {
    var styles = {};

    for (var key in raw) {
      var breakpoint = breakpoints[key];
      var value = raw[key];
      var style = sx(value, scale, _props);

      if (!breakpoint) {
        objectAssign(styles, style);
      } else {
        var _assign3;

        var media = createMediaQuery(breakpoint);
        objectAssign(styles, (_assign3 = {}, _assign3[media] = objectAssign({}, styles[media], style), _assign3));
      }
    }

    return styles;
  };

  var createStyleFunction = function createStyleFunction(_ref) {
    var properties = _ref.properties,
        property = _ref.property,
        scale = _ref.scale,
        _ref$transform = _ref.transform,
        transform = _ref$transform === void 0 ? getValue : _ref$transform,
        defaultScale = _ref.defaultScale;
    properties = properties || [property];

    var sx = function sx(value, scale, _props) {
      var result = {};
      var n = transform(value, scale, _props);
      if (n === null) return;
      properties.forEach(function (prop) {
        result[prop] = n;
      });
      return result;
    };

    sx.scale = scale;
    sx.defaults = defaultScale;
    return sx;
  }; // new v5 API

  var system$1 = function system(args) {
    if (args === void 0) {
      args = {};
    }

    var config = {};
    Object.keys(args).forEach(function (key) {
      var conf = args[key];

      if (conf === true) {
        // shortcut definition
        config[key] = createStyleFunction({
          property: key,
          scale: key
        });
        return;
      }

      if (typeof conf === 'function') {
        config[key] = conf;
        return;
      }

      config[key] = createStyleFunction(conf);
    });
    var parser = createParser(config);
    return parser;
  };
  var compose$1 = function compose() {
    var config = {};

    for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
      parsers[_key] = arguments[_key];
    }

    parsers.forEach(function (parser) {
      if (!parser || !parser.config) return;
      objectAssign(config, parser.config);
    });
    var parser = createParser(config);
    return parser;
  };

  var defaults = {
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
  };

  var isNumber = function isNumber(n) {
    return typeof n === 'number' && !isNaN(n);
  };

  var getMargin = function getMargin(n, scale) {
    if (!isNumber(n)) {
      return get(scale, n, n);
    }

    var isNegative = n < 0;
    var absolute = Math.abs(n);
    var value = get(scale, absolute, absolute);

    if (!isNumber(value)) {
      return isNegative ? '-' + value : value;
    }

    return value * (isNegative ? -1 : 1);
  };

  var configs = {};
  configs.margin = {
    margin: {
      property: 'margin',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginTop: {
      property: 'marginTop',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginRight: {
      property: 'marginRight',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginBottom: {
      property: 'marginBottom',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginLeft: {
      property: 'marginLeft',
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginX: {
      properties: ['marginLeft', 'marginRight'],
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    },
    marginY: {
      properties: ['marginTop', 'marginBottom'],
      scale: 'space',
      transform: getMargin,
      defaultScale: defaults.space
    }
  };
  configs.margin.m = configs.margin.margin;
  configs.margin.mt = configs.margin.marginTop;
  configs.margin.mr = configs.margin.marginRight;
  configs.margin.mb = configs.margin.marginBottom;
  configs.margin.ml = configs.margin.marginLeft;
  configs.margin.mx = configs.margin.marginX;
  configs.margin.my = configs.margin.marginY;
  configs.padding = {
    padding: {
      property: 'padding',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingTop: {
      property: 'paddingTop',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingRight: {
      property: 'paddingRight',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingBottom: {
      property: 'paddingBottom',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingLeft: {
      property: 'paddingLeft',
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingX: {
      properties: ['paddingLeft', 'paddingRight'],
      scale: 'space',
      defaultScale: defaults.space
    },
    paddingY: {
      properties: ['paddingTop', 'paddingBottom'],
      scale: 'space',
      defaultScale: defaults.space
    }
  };
  configs.padding.p = configs.padding.padding;
  configs.padding.pt = configs.padding.paddingTop;
  configs.padding.pr = configs.padding.paddingRight;
  configs.padding.pb = configs.padding.paddingBottom;
  configs.padding.pl = configs.padding.paddingLeft;
  configs.padding.px = configs.padding.paddingX;
  configs.padding.py = configs.padding.paddingY;
  var margin = system$1(configs.margin);
  var padding = system$1(configs.padding);
  var space = compose$1(margin, padding);

  var config = {
    color: {
      property: 'color',
      scale: 'colors'
    },
    backgroundColor: {
      property: 'backgroundColor',
      scale: 'colors'
    },
    opacity: true
  };
  config.bg = config.backgroundColor;
  var color = system$1(config);

  const boxSystemProps = [...space.propNames, ...color.propNames];
  const shouldForwardProp = createShouldForwardProp(boxSystemProps);

  const sx = props => css(props.sx)(props.theme);

  const base = props => css(props.__css)(props.theme);

  const variant = ({
    theme,
    variant,
    __themeKey = 'variants'
  }) => css(get$1(theme, __themeKey + '.' + variant, get$1(theme, variant)));

  const Box$1 = styled__default["default"]('div', {
    shouldForwardProp
  })({
    boxSizing: 'border-box',
    margin: 0,
    minWidth: 0
  }, base, variant, space, color, sx, props => props.css);
  Box$1.displayName = 'Box';

  const Flex$1 = styled__default["default"](Box$1)({
    display: 'flex'
  });
  Flex$1.displayName = 'Flex';

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  const Image = /*#__PURE__*/React__default["default"].forwardRef(function Image(props, ref) {
    return /*#__PURE__*/React__default["default"].createElement(Box$1, _extends({
      ref: ref,
      as: "img"
    }, props, {
      __themeKey: "images",
      __css: {
        maxWidth: '100%',
        height: 'auto',
        ...props.__css
      }
    }));
  });

  react.keyframes({
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  });

  var __defProp$1g = Object.defineProperty;
  var __getOwnPropSymbols$1g = Object.getOwnPropertySymbols;
  var __hasOwnProp$1g = Object.prototype.hasOwnProperty;
  var __propIsEnum$1g = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1g = (obj, key, value) => key in obj ? __defProp$1g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1g = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1g.call(b, prop))
        __defNormalProp$1g(a, prop, b[prop]);
    if (__getOwnPropSymbols$1g)
      for (var prop of __getOwnPropSymbols$1g(b)) {
        if (__propIsEnum$1g.call(b, prop))
          __defNormalProp$1g(a, prop, b[prop]);
      }
    return a;
  };
  const getSizeStyle = (variant) => {
    switch (variant) {
      case "md":
        return {
          height: 48,
          width: 48
        };
      case "sm":
        return {
          height: 32,
          width: 32
        };
      default:
        return {
          height: 56,
          width: 56
        };
    }
  };
  const getContainerStyle$4 = (variant, brand) => __spreadValues$1g({
    borderRadius: "circle",
    borderStyle: "solid",
    borderWidth: "hairline",
    boxSizing: "border-box",
    color: brand ? "typeface.on.brand.pure" : "neutral.30",
    display: "inline-flex",
    justifyContent: "center",
    overflow: "hidden",
    placeItems: "center",
    position: "relative"
  }, getSizeStyle(variant));
  const imageStyle = {
    height: "100%",
    objectFit: "cover",
    position: "relative",
    width: "100%",
    zIndex: "1"
  };
  const initialsStyle = {
    m: "auto",
    position: "absolute"
  };

  const portugueseNameArticles = ["da", "de", "do"];
  const getInitials = (text = "") => {
    const filteredNames = text.split(/\W+/gi).filter((name) => !portugueseNameArticles.includes(name.toLowerCase()));
    const leadingName = head(filteredNames);
    const trallingName = head(filteredNames.slice(1, 2));
    if (!filteredNames.length) {
      return "";
    }
    if (filteredNames.length === 1) {
      return `${leadingName && leadingName.slice(0, 2).toUpperCase()} `;
    }
    return `${leadingName && leadingName.slice(0, 1)}${trallingName && trallingName.slice(0, 1)}`.toUpperCase();
  };

  const { get: getKey, compose, system } = styledSystem__namespace;
  const COMMON = compose(styledSystem__namespace.space, styledSystem__namespace.color, styledSystem__namespace.display);
  const whiteSpace = system({
    whiteSpace: {
      property: "whiteSpace"
    }
  });
  const TYPOGRAPHY = compose(styledSystem__namespace.typography, whiteSpace);
  const BORDER = compose(styledSystem__namespace.border, styledSystem__namespace.shadow);
  const { layout: LAYOUT } = styledSystem__namespace;
  const { flexbox: FLEX } = styledSystem__namespace;
  const { grid: GRID } = styledSystem__namespace;
  const weekParser = {
    Friday: "Sexta",
    Monday: "Segunda",
    Saturday: "S\xE1bado",
    Sunday: "Domingo",
    Thursday: "Quinta",
    Tuesday: "Ter\xE7a",
    Wednesday: "Quarta"
  };
  const months = [
    "Janeiro",
    "Fevereiro",
    "Mar\xE7o",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro"
  ];
  const monthParse = {
    Abril: 3,
    Agosto: 7,
    Dezembro: 11,
    Fevereiro: 1,
    Janeiro: 0,
    Julho: 6,
    Junho: 5,
    Maio: 4,
    Mar\u00E7o: 2,
    Novembro: 10,
    Outubro: 9,
    Setembro: 8
  };

  const getBoxStyle = ({ fullWidth, width }) => ({
    width: fullWidth ? "100%" : width
  });

  var __defProp$1f = Object.defineProperty;
  var __defProps$P = Object.defineProperties;
  var __getOwnPropDescs$P = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1f = Object.getOwnPropertySymbols;
  var __hasOwnProp$1f = Object.prototype.hasOwnProperty;
  var __propIsEnum$1f = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1f = (obj, key, value) => key in obj ? __defProp$1f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1f = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1f.call(b, prop))
        __defNormalProp$1f(a, prop, b[prop]);
    if (__getOwnPropSymbols$1f)
      for (var prop of __getOwnPropSymbols$1f(b)) {
        if (__propIsEnum$1f.call(b, prop))
          __defNormalProp$1f(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$P = (a, b) => __defProps$P(a, __getOwnPropDescs$P(b));
  const Wrapper$1 = styled__default$1["default"](themeUi.Box)(LAYOUT, FLEX, TYPOGRAPHY, COMMON, BORDER, sx$1);
  const Box = React__default["default"].forwardRef((props, ref) => /* @__PURE__ */ React__default["default"].createElement(Wrapper$1, __spreadProps$P(__spreadValues$1f({
    sx: __spreadValues$1f(__spreadValues$1f({}, getBoxStyle(props)), props.sx)
  }, props), {
    ref
  })));

  var __defProp$1e = Object.defineProperty;
  var __getOwnPropSymbols$1e = Object.getOwnPropertySymbols;
  var __hasOwnProp$1e = Object.prototype.hasOwnProperty;
  var __propIsEnum$1e = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1e = (obj, key, value) => key in obj ? __defProp$1e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1e = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1e.call(b, prop))
        __defNormalProp$1e(a, prop, b[prop]);
    if (__getOwnPropSymbols$1e)
      for (var prop of __getOwnPropSymbols$1e(b)) {
        if (__propIsEnum$1e.call(b, prop))
          __defNormalProp$1e(a, prop, b[prop]);
      }
    return a;
  };
  const Wrapper = styled__default$1["default"](Box)(COMMON, TYPOGRAPHY, sx$1, LAYOUT);
  const noWrapStyle = ({ noWrap, noOfLines }) => {
    const defaultStyle = {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    };
    const linesStyle = {
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: noOfLines || 1,
      display: "-webkit-box !important",
      whiteSpace: "normal"
    };
    if (noOfLines || noWrap) {
      return __spreadValues$1e(__spreadValues$1e({}, defaultStyle), linesStyle);
    }
    return {};
  };

  var __defProp$1d = Object.defineProperty;
  var __defProps$O = Object.defineProperties;
  var __getOwnPropDescs$O = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1d = Object.getOwnPropertySymbols;
  var __hasOwnProp$1d = Object.prototype.hasOwnProperty;
  var __propIsEnum$1d = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1d = (obj, key, value) => key in obj ? __defProp$1d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1d = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1d.call(b, prop))
        __defNormalProp$1d(a, prop, b[prop]);
    if (__getOwnPropSymbols$1d)
      for (var prop of __getOwnPropSymbols$1d(b)) {
        if (__propIsEnum$1d.call(b, prop))
          __defNormalProp$1d(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$O = (a, b) => __defProps$O(a, __getOwnPropDescs$O(b));
  var __objRest$W = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$1d.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1d)
      for (var prop of __getOwnPropSymbols$1d(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1d.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Typography = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { sx } = _b, props = __objRest$W(_b, ["sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Wrapper, __spreadProps$O(__spreadValues$1d({
      as: "p",
      m: 0,
      p: 0,
      sx: __spreadValues$1d(__spreadValues$1d({}, noWrapStyle(props)), sx)
    }, props), {
      ref
    }));
  });

  const isSmallProp$2 = (variant) => variant === "sm";
  const getColorTypfaceTokenByProp = ({ brand, inverse }, suffix) => `typeface.${inverse ? "inverse." : ""}${brand ? "on.brand." : ""}${suffix}`;

  var __defProp$1c = Object.defineProperty;
  var __getOwnPropSymbols$1c = Object.getOwnPropertySymbols;
  var __hasOwnProp$1c = Object.prototype.hasOwnProperty;
  var __propIsEnum$1c = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1c = (obj, key, value) => key in obj ? __defProp$1c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1c = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1c.call(b, prop))
        __defNormalProp$1c(a, prop, b[prop]);
    if (__getOwnPropSymbols$1c)
      for (var prop of __getOwnPropSymbols$1c(b)) {
        if (__propIsEnum$1c.call(b, prop))
          __defNormalProp$1c(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$V = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$1c.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1c)
      for (var prop of __getOwnPropSymbols$1c(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1c.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Body = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant } = _b, props = __objRest$V(_b, ["variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues$1c({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "huge" : "superdistant",
      ref
    }, props));
  });
  Body.defaultProps = {
    brand: false,
    variant: "lg"
  };

  var __defProp$1b = Object.defineProperty;
  var __defProps$N = Object.defineProperties;
  var __getOwnPropDescs$N = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$1b = Object.getOwnPropertySymbols;
  var __hasOwnProp$1b = Object.prototype.hasOwnProperty;
  var __propIsEnum$1b = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1b = (obj, key, value) => key in obj ? __defProp$1b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1b = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1b.call(b, prop))
        __defNormalProp$1b(a, prop, b[prop]);
    if (__getOwnPropSymbols$1b)
      for (var prop of __getOwnPropSymbols$1b(b)) {
        if (__propIsEnum$1b.call(b, prop))
          __defNormalProp$1b(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$N = (a, b) => __defProps$N(a, __getOwnPropDescs$N(b));
  var __objRest$U = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$1b.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1b)
      for (var prop of __getOwnPropSymbols$1b(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1b.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const AvatarBase = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { name, imageSrc, variant, brand, sx } = _b, props = __objRest$U(_b, ["name", "imageSrc", "variant", "brand", "sx"]);
    const initials = getInitials(name);
    const hasSrcImg = !!imageSrc || false;
    const typoSize = variant === "sm" ? "sm" : "lg";
    const [showImage, handleShowImage] = React.useState(hasSrcImg);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$N(__spreadValues$1b({
      sx: __spreadValues$1b(__spreadValues$1b({}, getContainerStyle$4(variant, brand)), sx)
    }, props), {
      ref
    }), showImage ? /* @__PURE__ */ React__default["default"].createElement(Image, {
      alt: name,
      as: "img",
      "data-testid": "avatar-image",
      onError: () => handleShowImage(false),
      src: imageSrc,
      sx: imageStyle
    }) : /* @__PURE__ */ React__default["default"].createElement(Box, {
      as: "span",
      sx: initialsStyle
    }, /* @__PURE__ */ React__default["default"].createElement(Body, {
      color: brand ? "neutral.on.brand.30" : "typeface.pure",
      variant: typoSize
    }, initials)));
  });
  const PersonAvatar = React__default["default"].forwardRef((_c, ref) => {
    var props = __objRest$U(_c, []);
    return /* @__PURE__ */ React__default["default"].createElement(AvatarBase, __spreadProps$N(__spreadValues$1b({
      sx: {
        borderRadius: "circle"
      }
    }, props), {
      ref
    }));
  });
  const BrandAvatar = React__default["default"].forwardRef((_d, ref) => {
    var props = __objRest$U(_d, []);
    return /* @__PURE__ */ React__default["default"].createElement(AvatarBase, __spreadProps$N(__spreadValues$1b({
      sx: {
        borderRadius: "xs"
      }
    }, props), {
      ref
    }));
  });
  styled__default$1["default"](PersonAvatar);
  styled__default$1["default"](BrandAvatar);

  const getIconSize$1 = (size) => {
    switch (size) {
      case "md":
        return "1.5rem";
      case "lg":
        return "2rem";
      default:
        return "1rem";
    }
  };
  const getIconStyle$1 = ({ size, variant, color }) => ({
    "& > svg": {
      cursor: "inherit",
      fill: "currentcolor",
      fontSize: mapResponsive(size, (propSize) => getIconSize$1(propSize))
    },
    border: "none",
    borderRadius: "pill",
    color: variant || color || "inherit",
    cursor: "inherit",
    height: mapResponsive(size, (propSize) => getIconSize$1(propSize)),
    minWidth: "auto",
    width: mapResponsive(size, (propSize) => getIconSize$1(propSize))
  });

  var __defProp$1a = Object.defineProperty;
  var __getOwnPropSymbols$1a = Object.getOwnPropertySymbols;
  var __hasOwnProp$1a = Object.prototype.hasOwnProperty;
  var __propIsEnum$1a = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1a = (obj, key, value) => key in obj ? __defProp$1a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1a = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1a.call(b, prop))
        __defNormalProp$1a(a, prop, b[prop]);
    if (__getOwnPropSymbols$1a)
      for (var prop of __getOwnPropSymbols$1a(b)) {
        if (__propIsEnum$1a.call(b, prop))
          __defNormalProp$1a(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$T = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$1a.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1a)
      for (var prop of __getOwnPropSymbols$1a(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1a.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Icon = React.forwardRef((_a, ref) => {
    var _b = _a, { sx = {}, size = "md" } = _b, props = __objRest$T(_b, ["sx", "size"]);
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.IconButton, __spreadValues$1a({
      as: "span",
      ref,
      sx: __spreadValues$1a(__spreadValues$1a({}, getIconStyle$1(__spreadValues$1a({ size }, props))), sx)
    }, props));
  });

  const getSpinnerStyle = (size, strokeWidth) => {
    let loadingSize;
    if (size === "lg") {
      loadingSize = 32;
    } else if (size === "md") {
      loadingSize = 24;
    } else {
      loadingSize = 16;
    }
    return {
      "& div": {
        animation: "spin 1s linear infinite",
        borderBottomColor: "inherit",
        borderLeftColor: "transparent",
        borderRadius: "circle",
        borderRightColor: "inherit",
        borderStyle: "solid",
        borderTopColor: "inherit",
        borderWidth: strokeWidth,
        display: "block",
        height: "100%",
        position: "relative",
        width: "100%"
      },
      "@keyframes spin": {
        "0%": {
          transform: "rotate(0deg)"
        },
        "100%": {
          transform: "rotate(360deg)"
        }
      },
      alignItems: "center",
      display: "flex",
      height: loadingSize,
      justifyContent: "center",
      position: "relative",
      width: loadingSize
    };
  };

  var __defProp$19 = Object.defineProperty;
  var __getOwnPropSymbols$19 = Object.getOwnPropertySymbols;
  var __hasOwnProp$19 = Object.prototype.hasOwnProperty;
  var __propIsEnum$19 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$19 = (obj, key, value) => key in obj ? __defProp$19(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$19 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$19.call(b, prop))
        __defNormalProp$19(a, prop, b[prop]);
    if (__getOwnPropSymbols$19)
      for (var prop of __getOwnPropSymbols$19(b)) {
        if (__propIsEnum$19.call(b, prop))
          __defNormalProp$19(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$S = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$19.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$19)
      for (var prop of __getOwnPropSymbols$19(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$19.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Spinner = React.forwardRef((_a, ref) => {
    var _b = _a, { progress, size = "lg", strokeWidth = 2, text = "", sx } = _b, props = __objRest$S(_b, ["progress", "size", "strokeWidth", "text", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$19({
      "aria-describedby": "id",
      "aria-valuemax": 100,
      "aria-valuemin": 0,
      "aria-valuetext": progress ? progress.toString() : text,
      ref,
      role: "progressbar",
      sx: __spreadValues$19(__spreadValues$19({}, getSpinnerStyle(size, strokeWidth)), sx),
      tabIndex: 0
    }, props), /* @__PURE__ */ React__default["default"].createElement(Box, null));
  });

  var __defProp$18 = Object.defineProperty;
  var __getOwnPropSymbols$18 = Object.getOwnPropertySymbols;
  var __hasOwnProp$18 = Object.prototype.hasOwnProperty;
  var __propIsEnum$18 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$18 = (obj, key, value) => key in obj ? __defProp$18(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$18 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$18.call(b, prop))
        __defNormalProp$18(a, prop, b[prop]);
    if (__getOwnPropSymbols$18)
      for (var prop of __getOwnPropSymbols$18(b)) {
        if (__propIsEnum$18.call(b, prop))
          __defNormalProp$18(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$R = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$18.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$18)
      for (var prop of __getOwnPropSymbols$18(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$18.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Action = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant = "lg" } = _b, props = __objRest$R(_b, ["variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues$18({
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      fontWeight: "bold",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "tiny" : "superdistant",
      ref
    }, props));
  });

  var __defProp$17 = Object.defineProperty;
  var __defProps$M = Object.defineProperties;
  var __getOwnPropDescs$M = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$17 = Object.getOwnPropertySymbols;
  var __hasOwnProp$17 = Object.prototype.hasOwnProperty;
  var __propIsEnum$17 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$17 = (obj, key, value) => key in obj ? __defProp$17(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$17 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$17.call(b, prop))
        __defNormalProp$17(a, prop, b[prop]);
    if (__getOwnPropSymbols$17)
      for (var prop of __getOwnPropSymbols$17(b)) {
        if (__propIsEnum$17.call(b, prop))
          __defNormalProp$17(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$M = (a, b) => __defProps$M(a, __getOwnPropDescs$M(b));
  var __objRest$Q = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$17.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$17)
      for (var prop of __getOwnPropSymbols$17(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$17.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const getCursorStyle = ({
    isLoading,
    disabled
  }) => {
    if (isLoading) {
      return "progress";
    } else if (disabled) {
      return "not-allowed";
    }
    return "pointer";
  };
  const getButtonBaseStyle = ({ borderRadius = "xs", fullWidth, width, isLoading, disabled }) => ({
    alignItems: "center",
    bg: "transparent",
    border: "2px solid",
    borderColor: "transparent",
    borderRadius,
    boxSizing: "border-box",
    cursor: getCursorStyle({ disabled, isLoading }),
    display: "flex",
    justifyContent: "center",
    minWidth: 99,
    transition: "all 0.1s",
    width: fullWidth && "100%" || width || "auto"
  });
  const activeInteractionBaseStyle = {
    borderWidth: "hairline",
    boxShadow: "none"
  };
  const disabledBaseStyle = {
    bg: "transparent",
    borderStyle: "none",
    boxShadow: "none",
    cursor: "auto"
  };
  const buttonShapeStyleSize = {
    lg: {
      height: "48px",
      px: "inline.xxxs"
    },
    sm: {
      height: "32px",
      px: "inline.nano"
    }
  };
  const getButtonsVariantsStyle = ({ brand, variant }) => {
    if (brand) {
      return {};
    }
    if (variant === "primary") {
      return {
        "&:active:enabled": __spreadValues$17({
          bg: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$M(__spreadValues$17({}, disabledBaseStyle), {
          bg: "interaction.blend.02",
          color: "typeface.meld"
        }),
        "&:focus:enabled:not(:active)": {
          bg: "interaction.accent.02",
          borderColor: "interaction.accent.02",
          borderStyle: "solid",
          borderWidth: "thin",
          boxShadow: `inset 0 0 0 2px ${defaultTheme$1.colors.neutral["00"]}`,
          outline: "none"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.accent.02"
        },
        bg: "interaction.accent.01",
        borderWidth: "hairline",
        color: "typeface.inverse.strong"
      };
    } else if (variant === "secondary") {
      return {
        "&:active:enabled": __spreadValues$17({
          bg: "interaction.subtle.02",
          borderColor: "interaction.accent.03",
          color: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$M(__spreadValues$17({}, disabledBaseStyle), {
          borderColor: "interaction.blend.04",
          borderStyle: "solid",
          color: "typeface.meld"
        }),
        "&:focus:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          borderColor: "interaction.accent.02",
          borderWidth: "thin",
          boxShadow: `inset 0 0 0 2px ${defaultTheme$1.colors.neutral["00"]}`,
          color: "interaction.accent.02"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          borderColor: "interaction.accent.02",
          color: "interaction.accent.02"
        },
        borderColor: "interaction.accent.01",
        borderStyle: "solid",
        borderWidth: "hairline",
        color: "interaction.accent.01"
      };
    } else if (variant === "tertiary") {
      return {
        "&:active:enabled": __spreadValues$17({
          bg: "interaction.subtle.02",
          color: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$M(__spreadValues$17({}, disabledBaseStyle), {
          color: "typeface.meld"
        }),
        "&:focus:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          borderColor: "interaction.accent.02",
          borderWidth: "thin",
          boxShadow: `inset 0 0 0 2px ${defaultTheme$1.colors.neutral["00"]}`
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.subtle.01",
          color: "interaction.accent.02"
        },
        borderWidth: "hairline",
        color: "interaction.accent.01"
      };
    }
    return {};
  };
  const getBrandButtonTheme = ({ brand, variant }) => {
    if (!brand) {
      return {};
    }
    if (variant === "primary") {
      return {
        "&:active": __spreadValues$17({
          bg: "interaction.on.brand.accent.03",
          borderColor: "transparent",
          color: "interaction.accent.03"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$M(__spreadValues$17({}, disabledBaseStyle), {
          bg: "interaction.on.brand.blend.02",
          color: "typeface.on.brand.meld"
        }),
        "&:focus:not(:active)": {
          bg: "interaction.on.brand.accent.02",
          borderColor: "interaction.on.brand.accent.02",
          borderWidth: "thin",
          boxShadow: `inset 0 0 0 2px ${defaultTheme$1.colors.interaction.accent["02"]}`,
          color: "interaction.accent.02",
          outline: "none"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.on.brand.accent.02",
          color: "interaction.accent.02"
        },
        bg: "interaction.on.brand.accent.01",
        borderWidth: "hairline",
        color: "interaction.accent.01"
      };
    } else if (variant === "tertiary" || variant === "secondary") {
      return {
        "&:active": __spreadValues$17({
          bg: "interaction.on.brand.subtle.02"
        }, activeInteractionBaseStyle),
        "&:disabled": __spreadProps$M(__spreadValues$17({}, disabledBaseStyle), {
          borderColor: "interaction.on.brand.blend.04",
          borderStyle: "solid",
          color: "typeface.on.brand.meld"
        }),
        "&:focus:not(:active)": {
          bg: "interaction.on.brand.subtle.01",
          borderWidth: "thin",
          boxShadow: `inset 0 0 0 2px ${defaultTheme$1.colors.interaction.inverse.on.brand.blend["04"]}`,
          outline: "none"
        },
        "&:hover:enabled:not(:active)": {
          bg: "interaction.on.brand.subtle.01"
        },
        borderColor: "interaction.on.brand.accent.01",
        borderWidth: "hairline",
        color: "interaction.on.brand.accent.01"
      };
    }
    return {};
  };
  const getButtonStyle = (_a) => {
    var _b = _a, { size = "lg", width } = _b, props = __objRest$Q(_b, ["size", "width"]);
    return __spreadProps$M(__spreadValues$17(__spreadValues$17(__spreadValues$17(__spreadValues$17({}, buttonShapeStyleSize[size]), getButtonBaseStyle(__spreadValues$17({ width }, props))), getButtonsVariantsStyle(props)), getBrandButtonTheme(props)), {
      "& > *": {
        pointerEvents: "none"
      }
    });
  };

  const getIsSmallSize = ({ size }) => size === "sm";
  const getIconSize = ({ size }) => getIsSmallSize({ size }) ? 16 : 20;
  const getIconSpacing = ({ size }) => size && getIsSmallSize({ size }) ? "inline.quark" : "inline.nano";
  const getSpinnerStrokeSize = ({ size }) => size && getIsSmallSize({ size }) ? 2 : 3;

  var __defProp$16 = Object.defineProperty;
  var __defProps$L = Object.defineProperties;
  var __getOwnPropDescs$L = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$16 = Object.getOwnPropertySymbols;
  var __hasOwnProp$16 = Object.prototype.hasOwnProperty;
  var __propIsEnum$16 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$16 = (obj, key, value) => key in obj ? __defProp$16(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$16 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$16.call(b, prop))
        __defNormalProp$16(a, prop, b[prop]);
    if (__getOwnPropSymbols$16)
      for (var prop of __getOwnPropSymbols$16(b)) {
        if (__propIsEnum$16.call(b, prop))
          __defNormalProp$16(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$L = (a, b) => __defProps$L(a, __getOwnPropDescs$L(b));
  var __objRest$P = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$16.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$16)
      for (var prop of __getOwnPropSymbols$16(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$16.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Button = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant = "primary", brand = false, onMouseUp, disabled = false, size = "lg", sx, iconOnly, children, isLoading } = _b, props = __objRest$P(_b, ["variant", "brand", "onMouseUp", "disabled", "size", "sx", "iconOnly", "children", "isLoading"]);
    const buttonSimilarProps = __spreadProps$L(__spreadValues$16({}, props), { brand, disabled, isLoading, size, variant });
    const { leadingIcon, leadingIconSize, trailingIcon, trailingIconSize } = props;
    const renderLeadingIcon = () => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(Icon, {
      size: leadingIconSize
    }, leadingIcon), /* @__PURE__ */ React__default["default"].createElement(Box, {
      mr: iconOnly ? 0 : getIconSpacing({ size })
    })));
    const renderLoading = () => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, isLoading && /* @__PURE__ */ React__default["default"].createElement(Spinner, {
      ml: iconOnly ? 0 : getIconSpacing({ size }),
      size: getIconSize({ size }),
      strokeWidth: getSpinnerStrokeSize({ size })
    }));
    const renderButtonContent = () => {
      if (iconOnly) {
        return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, !isLoading && renderLeadingIcon(), renderLoading(), children && children);
      }
      return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, renderLeadingIcon(), !iconOnly && /* @__PURE__ */ React__default["default"].createElement(Action, {
        color: "inherit",
        sx: { pointerEvents: "none" },
        variant: size
      }, children), !isLoading && trailingIcon && /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(Box, {
        ml: getIconSpacing({ size })
      }), /* @__PURE__ */ React__default["default"].createElement(Icon, {
        size: trailingIconSize
      }, trailingIcon)), renderLoading());
    };
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Button, __spreadProps$L(__spreadValues$16({
      "aria-disabled": disabled,
      "data-loading": isLoading,
      sx: __spreadValues$16(__spreadValues$16({}, getButtonStyle(buttonSimilarProps)), sx),
      tabIndex: 0
    }, buttonSimilarProps), {
      disabled,
      onMouseUp: (evt) => {
        const target = evt.target;
        target.blur();
        if (onMouseUp) {
          onMouseUp(evt);
        }
      },
      ref
    }), renderButtonContent());
  });

  const getIconOnlyStyle = (floating, size, brand, disabled, color, isLoading) => {
    let iconSize;
    switch (size) {
      case "lg":
        iconSize = 48;
        break;
      case "sm":
        iconSize = floating ? 48 : 32;
        break;
      default:
        iconSize = 48;
        break;
    }
    const iconColor = () => {
      if (color) {
        return color;
      } else if (floating) {
        if (disabled || isLoading) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }
        return brand ? "interaction.accent.01" : "interaction.on.brand.08";
      }
      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };
    const fillColor = () => {
      if (color) {
        return color;
      } else if (floating) {
        if (disabled || isLoading) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }
        return brand ? "interaction.accent.01" : "interaction.on.brand.08";
      }
      return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
    };
    const backgroundColor = () => {
      if (floating) {
        if (disabled || isLoading) {
          return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
        }
        return brand ? "interaction.on.brand.blend.08" : "interaction.accent.01";
      }
      return "transparent";
    };
    const hoverBackgroundColor = () => {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }
      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };
    const focusBackgroundColor = () => {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }
      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };
    const focusBorderColor = () => {
      if (floating) {
        return brand ? "interaction.inverse.accent.03" : "interaction.accent.02";
      }
      return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
    };
    const focusBoxshadowColor = () => {
      if (floating) {
        return brand ? defaultTheme$1.colors.interaction.accent["02"] : defaultTheme$1.colors.neutral["00"];
      }
      return brand ? defaultTheme$1.colors.interaction.inverse.on.brand.blend["04"] : defaultTheme$1.colors.neutral["00"];
    };
    const activeBackgroundColor = () => {
      if (floating) {
        return brand ? "interaction.inverse.accent.01" : "interaction.accent.03";
      }
      return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
    };
    return {
      "& span > svg > path": {
        fill: iconColor()
      },
      "&:active:enabled": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: activeBackgroundColor()
      },
      "&:disabled": {
        "& span > svg": {
          cursor: "not-allowed",
          fill: color ? color : brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        "& span > svg > path": {
          cursor: "not-allowed",
          fill: color ? color : brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        cursor: "not-allowed"
      },
      "&:disabled:enabled": {
        "& span > svg > path": {
          fill: color ? color : brand ? "interaction.on.brand.blend.05" : "interaction.blend.05"
        },
        cursor: "not-allowed"
      },
      "&:focus:enabled:not(:active)": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: focusBackgroundColor(),
        borderColor: focusBorderColor(),
        borderStyle: "solid",
        borderWidth: "thin",
        boxShadow: `inset 0 0 0 2px ${focusBoxshadowColor()}`
      },
      "&:hover:enabled:not(:active)": {
        "& span > svg > path": {
          fill: fillColor()
        },
        backgroundColor: hoverBackgroundColor()
      },
      alignItems: "center",
      backgroundColor: backgroundColor(),
      borderColor: "transparent",
      borderRadius: floating ? "circle" : "xs",
      borderStyle: "solid",
      borderWidth: "thin",
      boxShadow: floating ? defaultTheme$1.shadows["03"] : void 0,
      color: iconColor(),
      cursor: disabled ? "not-allowed" : "pointer",
      display: "flex",
      height: iconSize,
      justifyContent: "center",
      minWidth: "min-content",
      px: 0,
      transition: "all 0.1s",
      width: iconSize
    };
  };

  var __defProp$15 = Object.defineProperty;
  var __getOwnPropSymbols$15 = Object.getOwnPropertySymbols;
  var __hasOwnProp$15 = Object.prototype.hasOwnProperty;
  var __propIsEnum$15 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$15 = (obj, key, value) => key in obj ? __defProp$15(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$15 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$15.call(b, prop))
        __defNormalProp$15(a, prop, b[prop]);
    if (__getOwnPropSymbols$15)
      for (var prop of __getOwnPropSymbols$15(b)) {
        if (__propIsEnum$15.call(b, prop))
          __defNormalProp$15(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$O = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$15.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$15)
      for (var prop of __getOwnPropSymbols$15(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$15.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const ButtonIcon = (_a) => {
    var _b = _a, { brand, floating, isLoading, size = "lg", sx, disabled } = _b, props = __objRest$O(_b, ["brand", "floating", "isLoading", "size", "sx", "disabled"]);
    return /* @__PURE__ */ React__default["default"].createElement(Button, __spreadValues$15({
      disabled,
      iconOnly: true,
      isLoading,
      sx: __spreadValues$15(__spreadValues$15({}, getIconOnlyStyle(floating, size, brand, disabled, props.color, isLoading)), sx),
      tabIndex: 0
    }, props));
  };

  var __defProp$14 = Object.defineProperty;
  var __getOwnPropSymbols$14 = Object.getOwnPropertySymbols;
  var __hasOwnProp$14 = Object.prototype.hasOwnProperty;
  var __propIsEnum$14 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$14 = (obj, key, value) => key in obj ? __defProp$14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$14 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$14.call(b, prop))
        __defNormalProp$14(a, prop, b[prop]);
    if (__getOwnPropSymbols$14)
      for (var prop of __getOwnPropSymbols$14(b)) {
        if (__propIsEnum$14.call(b, prop))
          __defNormalProp$14(a, prop, b[prop]);
      }
    return a;
  };
  const ButtonFloating = (props) => /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, __spreadValues$14({
    floating: true
  }, props));

  var __defProp$13 = Object.defineProperty;
  var __defProps$K = Object.defineProperties;
  var __getOwnPropDescs$K = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$13 = Object.getOwnPropertySymbols;
  var __hasOwnProp$13 = Object.prototype.hasOwnProperty;
  var __propIsEnum$13 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$13 = (obj, key, value) => key in obj ? __defProp$13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$13 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$13.call(b, prop))
        __defNormalProp$13(a, prop, b[prop]);
    if (__getOwnPropSymbols$13)
      for (var prop of __getOwnPropSymbols$13(b)) {
        if (__propIsEnum$13.call(b, prop))
          __defNormalProp$13(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$K = (a, b) => __defProps$K(a, __getOwnPropDescs$K(b));
  const baseStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  };
  const axisStyle = {
    both: __spreadProps$K(__spreadValues$13({}, baseStyle), {
      insetStart: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }),
    default: __spreadValues$13({}, baseStyle),
    horizontal: __spreadProps$K(__spreadValues$13({}, baseStyle), {
      insetStart: "50%",
      transform: "translateX(-50%)"
    }),
    vertical: __spreadProps$K(__spreadValues$13({}, baseStyle), {
      top: "50%",
      transform: "translateY(-50%)"
    })
  };

  var __defProp$12 = Object.defineProperty;
  var __defProps$J = Object.defineProperties;
  var __getOwnPropDescs$J = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$12 = Object.getOwnPropertySymbols;
  var __hasOwnProp$12 = Object.prototype.hasOwnProperty;
  var __propIsEnum$12 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$12 = (obj, key, value) => key in obj ? __defProp$12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$12 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$12.call(b, prop))
        __defNormalProp$12(a, prop, b[prop]);
    if (__getOwnPropSymbols$12)
      for (var prop of __getOwnPropSymbols$12(b)) {
        if (__propIsEnum$12.call(b, prop))
          __defNormalProp$12(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$J = (a, b) => __defProps$J(a, __getOwnPropDescs$J(b));
  var __objRest$N = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$12.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$12)
      for (var prop of __getOwnPropSymbols$12(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$12.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Center = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { axis = "default", sx } = _b, props = __objRest$N(_b, ["axis", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$J(__spreadValues$12({
      sx: __spreadValues$12(__spreadValues$12({}, axisStyle[axis]), sx)
    }, props), {
      ref
    }));
  });

  const getCheckBoxStyle = (brand, disabled, hover, focus, active) => {
    const getSpanBackgroundColor = () => {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }
      return "transparent";
    };
    const getSpanBorderColor = () => {
      if (focus) {
        return brand ? "interaction.on.brand.blend.05" : "interaction.blend.05";
      }
      return "transparent";
    };
    const getInputColor = () => {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }
      return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
    };
    const getCheckedInputColor = () => {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }
      return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
    };
    return {
      alignItems: "center",
      input: {
        ":checked": {
          "~ svg": {
            color: getCheckedInputColor()
          }
        },
        ":not(:checked)": {
          "~ svg": {
            color: getInputColor()
          }
        },
        "~ svg": {
          backgroundColor: "transparent !important",
          color: getInputColor(),
          position: "relative"
        }
      },
      position: "relative",
      span: {
        bg: getSpanBackgroundColor(),
        borderColor: getSpanBorderColor(),
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        boxSizing: "border-box",
        display: "block",
        height: "40px",
        position: "absolute",
        transform: "translateX(-8px)",
        width: "40px"
      }
    };
  };

  var __defProp$11 = Object.defineProperty;
  var __defProps$I = Object.defineProperties;
  var __getOwnPropDescs$I = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$11 = Object.getOwnPropertySymbols;
  var __hasOwnProp$11 = Object.prototype.hasOwnProperty;
  var __propIsEnum$11 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$11 = (obj, key, value) => key in obj ? __defProp$11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$11 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$11.call(b, prop))
        __defNormalProp$11(a, prop, b[prop]);
    if (__getOwnPropSymbols$11)
      for (var prop of __getOwnPropSymbols$11(b)) {
        if (__propIsEnum$11.call(b, prop))
          __defNormalProp$11(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$I = (a, b) => __defProps$I(a, __getOwnPropDescs$I(b));
  var __objRest$M = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$11.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$11)
      for (var prop of __getOwnPropSymbols$11(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$11.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const CheckBox = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { label, onChange, indeterminate, brand, sx } = _b, props = __objRest$M(_b, ["label", "onChange", "indeterminate", "brand", "sx"]);
    const [hover, setHover] = React.useState(false);
    const [focus, setFocus] = React.useState(false);
    const [active, setActive] = React.useState(false);
    const [controlIndeterminate, setControlIndeterminate] = React.useState(!!indeterminate);
    const getLabelColor = () => {
      if (props.disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }
      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };
    React__default["default"].useEffect(() => {
      setControlIndeterminate(!!indeterminate);
    }, [indeterminate]);
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, {
      onBlur: () => setFocus(false),
      onFocus: () => !props.disabled && setFocus(true),
      onMouseDown: () => !props.disabled && setActive(true),
      onMouseEnter: () => !props.disabled && setHover(true),
      onMouseLeave: () => setHover(false),
      onMouseUp: (evt) => {
        evt.currentTarget.blur();
        setActive(false);
      },
      sx: __spreadValues$11(__spreadValues$11({}, getCheckBoxStyle(brand, props.disabled, hover, focus, active)), sx)
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      as: "span"
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { position: "relative" }
    }, /* @__PURE__ */ React__default["default"].createElement(themeUi.Checkbox, __spreadProps$I(__spreadValues$11({}, props), {
      onChange: (e) => {
        onChange && onChange(e);
        indeterminate && setControlIndeterminate(!e.target.checked);
      },
      ref
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { height: "100%", left: 0, pointerEvents: "none", position: "absolute", top: 0, width: "100%" }
    }, controlIndeterminate && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      as: "div",
      color: getLabelColor()
    }, /* @__PURE__ */ React__default["default"].createElement(almaIcons.CheckboxIndeterminate, null))))), typeof label === "string" ? /* @__PURE__ */ React__default["default"].createElement(Body, {
      brand,
      color: getLabelColor(),
      ml: "inline.nano",
      tabIndex: -1,
      variant: "lg"
    }, label) : label);
  });

  var __defProp$10 = Object.defineProperty;
  var __getOwnPropSymbols$10 = Object.getOwnPropertySymbols;
  var __hasOwnProp$10 = Object.prototype.hasOwnProperty;
  var __propIsEnum$10 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$10 = (obj, key, value) => key in obj ? __defProp$10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$10 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$10.call(b, prop))
        __defNormalProp$10(a, prop, b[prop]);
    if (__getOwnPropSymbols$10)
      for (var prop of __getOwnPropSymbols$10(b)) {
        if (__propIsEnum$10.call(b, prop))
          __defNormalProp$10(a, prop, b[prop]);
      }
    return a;
  };
  const getDividerStyle = (brand, variant) => {
    const customStyle = {};
    if (variant === "horizontal") {
      customStyle["borderTopWidth"] = "1px";
      customStyle["width"] = "100%";
    } else {
      customStyle["borderRightWidth"] = "1px";
      customStyle["height"] = "100%";
    }
    return __spreadValues$10({
      borderColor: brand ? "neutral.on.brand.30" : "neutral.30",
      borderStyle: "solid",
      borderWidth: "none",
      margin: 0,
      position: "relative"
    }, customStyle);
  };

  var __defProp$$ = Object.defineProperty;
  var __defProps$H = Object.defineProperties;
  var __getOwnPropDescs$H = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$$ = Object.getOwnPropertySymbols;
  var __hasOwnProp$$ = Object.prototype.hasOwnProperty;
  var __propIsEnum$$ = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$$ = (obj, key, value) => key in obj ? __defProp$$(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$$ = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$$.call(b, prop))
        __defNormalProp$$(a, prop, b[prop]);
    if (__getOwnPropSymbols$$)
      for (var prop of __getOwnPropSymbols$$(b)) {
        if (__propIsEnum$$.call(b, prop))
          __defNormalProp$$(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$H = (a, b) => __defProps$H(a, __getOwnPropDescs$H(b));
  var __objRest$L = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$$.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$$)
      for (var prop of __getOwnPropSymbols$$(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$$.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Divider = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, sx, variant = "horizontal" } = _b, props = __objRest$L(_b, ["brand", "sx", "variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$H(__spreadValues$$({
      sx: __spreadValues$$(__spreadValues$$({}, getDividerStyle(brand, variant)), sx)
    }, props), {
      ref
    }));
  });

  var __defProp$_ = Object.defineProperty;
  var __getOwnPropSymbols$_ = Object.getOwnPropertySymbols;
  var __hasOwnProp$_ = Object.prototype.hasOwnProperty;
  var __propIsEnum$_ = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$_ = (obj, key, value) => key in obj ? __defProp$_(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$_ = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$_.call(b, prop))
        __defNormalProp$_(a, prop, b[prop]);
    if (__getOwnPropSymbols$_)
      for (var prop of __getOwnPropSymbols$_(b)) {
        if (__propIsEnum$_.call(b, prop))
          __defNormalProp$_(a, prop, b[prop]);
      }
    return a;
  };
  const Spacer = (props) => /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$_({
    mx: "auto",
    p: 0
  }, props));

  function _isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
  }

  /**
   * Optimized internal one-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */

  function _curry1(fn) {
    return function f1(a) {
      if (arguments.length === 0 || _isPlaceholder(a)) {
        return f1;
      } else {
        return fn.apply(this, arguments);
      }
    };
  }

  /**
   * Optimized internal two-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */

  function _curry2(fn) {
    return function f2(a, b) {
      switch (arguments.length) {
        case 0:
          return f2;

        case 1:
          return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
            return fn(a, _b);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b);
          }) : fn(a, b);
      }
    };
  }

  function _arity(n, fn) {
    /* eslint-disable no-unused-vars */
    switch (n) {
      case 0:
        return function () {
          return fn.apply(this, arguments);
        };

      case 1:
        return function (a0) {
          return fn.apply(this, arguments);
        };

      case 2:
        return function (a0, a1) {
          return fn.apply(this, arguments);
        };

      case 3:
        return function (a0, a1, a2) {
          return fn.apply(this, arguments);
        };

      case 4:
        return function (a0, a1, a2, a3) {
          return fn.apply(this, arguments);
        };

      case 5:
        return function (a0, a1, a2, a3, a4) {
          return fn.apply(this, arguments);
        };

      case 6:
        return function (a0, a1, a2, a3, a4, a5) {
          return fn.apply(this, arguments);
        };

      case 7:
        return function (a0, a1, a2, a3, a4, a5, a6) {
          return fn.apply(this, arguments);
        };

      case 8:
        return function (a0, a1, a2, a3, a4, a5, a6, a7) {
          return fn.apply(this, arguments);
        };

      case 9:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
          return fn.apply(this, arguments);
        };

      case 10:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
          return fn.apply(this, arguments);
        };

      default:
        throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
  }

  /**
   * Optimized internal three-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */

  function _curry3(fn) {
    return function f3(a, b, c) {
      switch (arguments.length) {
        case 0:
          return f3;

        case 1:
          return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          });

        case 2:
          return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _curry1(function (_c) {
            return fn(a, b, _c);
          });

        default:
          return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
            return fn(_a, _b, c);
          }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _isPlaceholder(a) ? _curry1(function (_a) {
            return fn(_a, b, c);
          }) : _isPlaceholder(b) ? _curry1(function (_b) {
            return fn(a, _b, c);
          }) : _isPlaceholder(c) ? _curry1(function (_c) {
            return fn(a, b, _c);
          }) : fn(a, b, c);
      }
    };
  }

  /**
   * Tests whether or not an object is an array.
   *
   * @private
   * @param {*} val The object to test.
   * @return {Boolean} `true` if `val` is an array, `false` otherwise.
   * @example
   *
   *      _isArray([]); //=> true
   *      _isArray(null); //=> false
   *      _isArray({}); //=> false
   */
  var _isArray = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
  };

  function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
  }

  /**
   * Tests whether or not an object is similar to an array.
   *
   * @private
   * @category Type
   * @category List
   * @sig * -> Boolean
   * @param {*} x The object to test.
   * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
   * @example
   *
   *      _isArrayLike([]); //=> true
   *      _isArrayLike(true); //=> false
   *      _isArrayLike({}); //=> false
   *      _isArrayLike({length: 10}); //=> false
   *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
   *      _isArrayLike({nodeType: 1, length: 1}) // => false
   */

  var _isArrayLike =
  /*#__PURE__*/
  _curry1(function isArrayLike(x) {
    if (_isArray(x)) {
      return true;
    }

    if (!x) {
      return false;
    }

    if (typeof x !== 'object') {
      return false;
    }

    if (_isString(x)) {
      return false;
    }

    if (x.length === 0) {
      return true;
    }

    if (x.length > 0) {
      return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    }

    return false;
  });

  var XWrap =
  /*#__PURE__*/
  function () {
    function XWrap(fn) {
      this.f = fn;
    }

    XWrap.prototype['@@transducer/init'] = function () {
      throw new Error('init not implemented on XWrap');
    };

    XWrap.prototype['@@transducer/result'] = function (acc) {
      return acc;
    };

    XWrap.prototype['@@transducer/step'] = function (acc, x) {
      return this.f(acc, x);
    };

    return XWrap;
  }();

  function _xwrap(fn) {
    return new XWrap(fn);
  }

  /**
   * Creates a function that is bound to a context.
   * Note: `R.bind` does not provide the additional argument-binding capabilities of
   * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Function
   * @category Object
   * @sig (* -> *) -> {*} -> (* -> *)
   * @param {Function} fn The function to bind to context
   * @param {Object} thisObj The context to bind `fn` to
   * @return {Function} A function that will execute in the context of `thisObj`.
   * @see R.partial
   * @example
   *
   *      const log = R.bind(console.log, console);
   *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
   *      // logs {a: 2}
   * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
   */

  var bind =
  /*#__PURE__*/
  _curry2(function bind(fn, thisObj) {
    return _arity(fn.length, function () {
      return fn.apply(thisObj, arguments);
    });
  });

  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      idx += 1;
    }

    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();

    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      step = iter.next();
    }

    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
  function _reduce(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }

    if (_isArrayLike(list)) {
      return _arrayReduce(fn, acc, list);
    }

    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }

    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }

    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }

    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  }

  /**
   * Returns a single item by iterating through the list, successively calling
   * the iterator function and passing it an accumulator value and the current
   * value from the array, and then passing the result to the next call.
   *
   * The iterator function receives two values: *(acc, value)*. It may use
   * [`R.reduced`](#reduced) to shortcut the iteration.
   *
   * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
   * is *(value, acc)*.
   *
   * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
   * arrays), unlike the native `Array.prototype.reduce` method. For more details
   * on this behavior, see:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
   *
   * Dispatches to the `reduce` method of the third argument, if present. When
   * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
   * shortcuting, as this is not implemented by `reduce`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig ((a, b) -> a) -> a -> [b] -> a
   * @param {Function} fn The iterator function. Receives two values, the accumulator and the
   *        current element from the array.
   * @param {*} acc The accumulator value.
   * @param {Array} list The list to iterate over.
   * @return {*} The final, accumulated value.
   * @see R.reduced, R.addIndex, R.reduceRight
   * @example
   *
   *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
   *      //          -               -10
   *      //         / \              / \
   *      //        -   4           -6   4
   *      //       / \              / \
   *      //      -   3   ==>     -3   3
   *      //     / \              / \
   *      //    -   2           -1   2
   *      //   / \              / \
   *      //  0   1            0   1
   *
   * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
   */

  var reduce =
  /*#__PURE__*/
  _curry3(_reduce);

  var reduce$1 = reduce;

  function _pipe(f, g) {
    return function () {
      return g.call(this, f.apply(this, arguments));
    };
  }

  /**
   * This checks whether a function has a [methodname] function. If it isn't an
   * array it will execute that function otherwise it will default to the ramda
   * implementation.
   *
   * @private
   * @param {Function} fn ramda implementation
   * @param {String} methodname property to check for a custom implementation
   * @return {Object} Whatever the return value of the method is.
   */

  function _checkForMethod(methodname, fn) {
    return function () {
      var length = arguments.length;

      if (length === 0) {
        return fn();
      }

      var obj = arguments[length - 1];
      return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
  }

  /**
   * Returns the elements of the given list or string (or object with a `slice`
   * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
   *
   * Dispatches to the `slice` method of the third argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.4
   * @category List
   * @sig Number -> Number -> [a] -> [a]
   * @sig Number -> Number -> String -> String
   * @param {Number} fromIndex The start index (inclusive).
   * @param {Number} toIndex The end index (exclusive).
   * @param {*} list
   * @return {*}
   * @example
   *
   *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
   *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
   *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
   *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
   *      R.slice(0, 3, 'ramda');                     //=> 'ram'
   */

  var slice =
  /*#__PURE__*/
  _curry3(
  /*#__PURE__*/
  _checkForMethod('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  }));

  /**
   * Returns all but the first element of the given list or string (or object
   * with a `tail` method).
   *
   * Dispatches to the `slice` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a]
   * @sig String -> String
   * @param {*} list
   * @return {*}
   * @see R.head, R.init, R.last
   * @example
   *
   *      R.tail([1, 2, 3]);  //=> [2, 3]
   *      R.tail([1, 2]);     //=> [2]
   *      R.tail([1]);        //=> []
   *      R.tail([]);         //=> []
   *
   *      R.tail('abc');  //=> 'bc'
   *      R.tail('ab');   //=> 'b'
   *      R.tail('a');    //=> ''
   *      R.tail('');     //=> ''
   */

  var tail =
  /*#__PURE__*/
  _curry1(
  /*#__PURE__*/
  _checkForMethod('tail',
  /*#__PURE__*/
  slice(1, Infinity)));

  var tail$1 = tail;

  /**
   * Performs left-to-right function composition. The first argument may have
   * any arity; the remaining arguments must be unary.
   *
   * In some libraries this function is named `sequence`.
   *
   * **Note:** The result of pipe is not automatically curried.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
   * @param {...Function} functions
   * @return {Function}
   * @see R.compose
   * @example
   *
   *      const f = R.pipe(Math.pow, R.negate, R.inc);
   *
   *      f(3, 4); // -(3^4) + 1
   * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
   * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
   */

  function pipe() {
    if (arguments.length === 0) {
      throw new Error('pipe requires at least one argument');
    }

    return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
  }

  function _isNumber(x) {
    return Object.prototype.toString.call(x) === '[object Number]';
  }

  /**
   * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Number -> Number -> [Number]
   * @param {Number} from The first number in the list.
   * @param {Number} to One more than the last number in the list.
   * @return {Array} The list of numbers in the set `[a, b)`.
   * @example
   *
   *      R.range(1, 5);    //=> [1, 2, 3, 4]
   *      R.range(50, 53);  //=> [50, 51, 52]
   */

  var range =
  /*#__PURE__*/
  _curry2(function range(from, to) {
    if (!(_isNumber(from) && _isNumber(to))) {
      throw new TypeError('Both arguments to range must be numbers');
    }

    var result = [];
    var n = from;

    while (n < to) {
      result.push(n);
      n += 1;
    }

    return result;
  });

  var range$1 = range;

  const getIconColor$1 = ({ variant, brand, disabled }) => {
    const blnd07 = "interaction.inverse.blend.07";
    if (disabled) {
      return brand ? blnd07 : "interaction.blend.06";
    }
    switch (variant) {
      case "invalid":
        return brand ? blnd07 : "feedback.error.shape";
      case "valid":
        return brand ? "interaction.inverse.blend.08" : "feedback.success.shape";
      default:
        return brand ? blnd07 : "neutral.inverse.10";
    }
  };
  const getTextColor$1 = ({ variant, brand, disabled }) => {
    if (brand) {
      return "interaction.inverse.blend.07";
    }
    if (disabled) {
      return "interaction.blend.06";
    }
    switch (variant) {
      case "invalid":
        return "feedback.error.text";
      case "valid":
        return "feedback.success.text";
      default:
        return "typeface.smooth";
    }
  };

  var __defProp$Z = Object.defineProperty;
  var __getOwnPropSymbols$Z = Object.getOwnPropertySymbols;
  var __hasOwnProp$Z = Object.prototype.hasOwnProperty;
  var __propIsEnum$Z = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$Z = (obj, key, value) => key in obj ? __defProp$Z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$Z = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$Z.call(b, prop))
        __defNormalProp$Z(a, prop, b[prop]);
    if (__getOwnPropSymbols$Z)
      for (var prop of __getOwnPropSymbols$Z(b)) {
        if (__propIsEnum$Z.call(b, prop))
          __defNormalProp$Z(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$K = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$Z.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$Z)
      for (var prop of __getOwnPropSymbols$Z(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$Z.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Caption = React__default["default"].forwardRef((_a, ref) => {
    var props = __objRest$K(_a, []);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues$Z({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: "xxxs",
      letterSpacing: "standard",
      lineHeight: "distant",
      ref
    }, props));
  });

  const getFlexStyle = ({ fullWidth, width, align, basis, direction, grow, justify, shrink, wrap }) => ({
    alignItems: align,
    display: "flex",
    flexBasis: basis,
    flexDirection: direction,
    flexGrow: grow,
    flexShrink: shrink,
    flexWrap: wrap,
    justifyContent: justify,
    width: fullWidth ? "100%" : width
  });

  var __defProp$Y = Object.defineProperty;
  var __defProps$G = Object.defineProperties;
  var __getOwnPropDescs$G = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$Y = Object.getOwnPropertySymbols;
  var __hasOwnProp$Y = Object.prototype.hasOwnProperty;
  var __propIsEnum$Y = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$Y = (obj, key, value) => key in obj ? __defProp$Y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$Y = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$Y.call(b, prop))
        __defNormalProp$Y(a, prop, b[prop]);
    if (__getOwnPropSymbols$Y)
      for (var prop of __getOwnPropSymbols$Y(b)) {
        if (__propIsEnum$Y.call(b, prop))
          __defNormalProp$Y(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$G = (a, b) => __defProps$G(a, __getOwnPropDescs$G(b));
  var __objRest$J = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$Y.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$Y)
      for (var prop of __getOwnPropSymbols$Y(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$Y.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Flex = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { sx } = _b, props = __objRest$J(_b, ["sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$G(__spreadValues$Y({
      display: "flex",
      flex: "none",
      sx: __spreadValues$Y(__spreadValues$Y({}, getFlexStyle(props)), sx)
    }, props), {
      ref
    }));
  });

  var __defProp$X = Object.defineProperty;
  var __defProps$F = Object.defineProperties;
  var __getOwnPropDescs$F = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$X = Object.getOwnPropertySymbols;
  var __hasOwnProp$X = Object.prototype.hasOwnProperty;
  var __propIsEnum$X = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$X = (obj, key, value) => key in obj ? __defProp$X(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$X = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$X.call(b, prop))
        __defNormalProp$X(a, prop, b[prop]);
    if (__getOwnPropSymbols$X)
      for (var prop of __getOwnPropSymbols$X(b)) {
        if (__propIsEnum$X.call(b, prop))
          __defNormalProp$X(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$F = (a, b) => __defProps$F(a, __getOwnPropDescs$F(b));
  const renderIcon = (props) => {
    const { disabled, variant, icon } = props;
    let iconToRender = null;
    if (disabled) {
      iconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.Lock, null);
    } else {
      switch (variant) {
        case "valid":
          iconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.CheckRound, null);
          break;
        case "invalid":
          iconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.WarningRound, null);
          break;
        case "custom":
          if (icon) {
            iconToRender = icon;
          }
          break;
      }
    }
    if (iconToRender) {
      return /* @__PURE__ */ React__default["default"].createElement(Icon, {
        color: getIconColor$1(props),
        size: "sm"
      }, iconToRender);
    }
    return null;
  };
  const SupportMessage = (props) => {
    const { value, brand, disabled } = props;
    return /* @__PURE__ */ React__default["default"].createElement(Flex, __spreadProps$F(__spreadValues$X({
      "aria-disabled": disabled,
      minHeight: "1em"
    }, props), {
      alignItems: "center"
    }), renderIcon(props), /* @__PURE__ */ React__default["default"].createElement(Caption, {
      brand,
      color: getTextColor$1(props),
      pl: "inline.quark"
    }, value));
  };

  var __defProp$W = Object.defineProperty;
  var __defProps$E = Object.defineProperties;
  var __getOwnPropDescs$E = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$W = Object.getOwnPropertySymbols;
  var __hasOwnProp$W = Object.prototype.hasOwnProperty;
  var __propIsEnum$W = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$W = (obj, key, value) => key in obj ? __defProp$W(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$W = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$W.call(b, prop))
        __defNormalProp$W(a, prop, b[prop]);
    if (__getOwnPropSymbols$W)
      for (var prop of __getOwnPropSymbols$W(b)) {
        if (__propIsEnum$W.call(b, prop))
          __defNormalProp$W(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$E = (a, b) => __defProps$E(a, __getOwnPropDescs$E(b));
  var __objRest$I = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$W.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$W)
      for (var prop of __getOwnPropSymbols$W(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$W.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const StyledContainer$1 = (_a) => {
    var _b = _a, { width = 320, height = "auto", sx } = _b, props = __objRest$I(_b, ["width", "height", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$W({
      sx: __spreadValues$W({
        height,
        minWidth: 72,
        position: "relative",
        width
      }, sx)
    }, props));
  };
  const StyledInputLabelContainer = ({ color, children, variantSize, focused, brand, height, disabled }) => {
    const getBgHoverInput = () => {
      if (disabled) {
        return "";
      }
      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };
    return /* @__PURE__ */ React__default["default"].createElement(Flex, {
      flex: "none",
      sx: {
        "&:disabled": {
          cursor: "not-allowed"
        },
        "&:focus-visible": {
          outline: "none"
        },
        "&:hover": {
          bg: getBgHoverInput()
        },
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        border: "none",
        borderBottomColor: `${color}`,
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        borderBottomStyle: "solid",
        borderBottomWidth: focused ? "thin" : "hairline",
        borderTopLeftRadius: "xs",
        borderTopRightRadius: "xs",
        height: height || (variantSize === "lg" ? 56 : 32),
        minHeight: variantSize === "lg" ? 56 : 32
      }
    }, children);
  };
  const activeLabelStyle$1 = {
    mt: "inline.xxxs",
    overflow: "hidden",
    pt: 0,
    transform: "translateY(-0.625rem)",
    width: "auto"
  };
  const StyledLabel$1 = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { color, isActive, label, variant, variantSize, leadingIcon } = _d, props = __objRest$I(_d, ["color", "isActive", "label", "variant", "variantSize", "leadingIcon"]);
    const activeStyle = isActive && variantSize === "lg" ? activeLabelStyle$1 : "";
    const isSmall = variantSize === "sm";
    const labelPaddingLeft = () => {
      if (isSmall) {
        if (leadingIcon) {
          return "inline.sm";
        }
        return "inline.nano";
      }
      return "";
    };
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, __spreadProps$E(__spreadValues$W({
      color,
      pt: "inline.xxxs",
      sx: __spreadProps$E(__spreadValues$W({
        alignItems: "center",
        flex: "none",
        left: leadingIcon ? "inline.lg" : "inline.xxxs",
        pl: labelPaddingLeft(),
        pointerEvents: "none",
        position: isSmall ? "static" : "absolute",
        pt: isSmall ? 0 : "",
        transition: "all 200ms",
        whiteSpace: "nowrap"
      }, activeStyle), {
        "& > p": {
          fontSize: isActive ? "xxxs" : "",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        maxWidth: leadingIcon ? `calc(100% - ${defaultTheme$1.space.inline.lg} - 4px)` : `calc(100% - ${defaultTheme$1.space.inline.xxxs} - 4px)`
      })
    }, props), {
      ref
    }), /* @__PURE__ */ React__default["default"].createElement(Body, {
      color: "inherit",
      variant: variantSize
    }, label));
  });
  const StyledInput = React__default["default"].forwardRef((_e, ref) => {
    var _f = _e, { name, trailingIcon, leadingIcon, variantSize, brand, height } = _f, props = __objRest$I(_f, ["name", "trailingIcon", "leadingIcon", "variantSize", "brand", "height"]);
    const isSmall = variantSize === "sm";
    const paddingRightInput = () => {
      if (trailingIcon) {
        if (isSmall) {
          return "inline.sm";
        }
        return "inline.xxxs";
      }
      if (trailingIcon) {
        return "inline.lg";
      }
      return "inline.xxxs";
    };
    const paddingLeftInput = () => {
      if (leadingIcon) {
        if (isSmall) {
          return "inline.xxxs";
        }
        return "inline.lg";
      }
      return "inline.xxxs";
    };
    const variantSizeHeight = variantSize === "lg" ? 56 : 32;
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Input, __spreadProps$E(__spreadValues$W({
      name,
      sx: {
        "&:disabled": {
          color: brand ? "typeface.on.brand.pure" : "typeface.meld",
          cursor: "not-allowed"
        },
        '&[type="password"]': {
          font: "small-caption",
          fontSize: "xs"
        },
        border: "none",
        color: brand ? "typeface.on.brand.pure" : "typeface.smooth",
        fontFamily: "base",
        height: height || variantSizeHeight,
        minHeight: variantSizeHeight,
        minWidth: "72px",
        pl: paddingLeftInput(),
        pr: paddingRightInput(),
        pt: variantSize === "sm" ? "" : "inline.xxs"
      }
    }, props), {
      ref
    }));
  });
  const getColorInputToken$1 = (type, variant) => `feedback.${variant}.${type}`;
  const getInputColors = ({
    variant,
    disabled,
    active,
    brand
  }) => {
    const isNotDefaultVariant = variant !== "default";
    const defaultToken = "interaction.select.default";
    const activeColor = !disabled && active && "interaction.select.active";
    const disabledTypoToken = disabled && "typeface.meld";
    const brandShapeColor = brand ? "interaction.on.brand.select.default" : "";
    const brandLabelColor = brand ? "typeface.on.brand.pure" : "";
    const variantColorShape = isNotDefaultVariant && getColorInputToken$1("shape", variant);
    const variantColorLabel = isNotDefaultVariant && getColorInputToken$1("text", variant);
    const colorShape = brandShapeColor || disabledTypoToken || variantColorShape || activeColor || defaultToken;
    const colorLabel = brandLabelColor || disabledTypoToken || variantColorLabel || activeColor || defaultToken;
    return { colorLabel, colorShape };
  };

  const getWrapStyle = ({ spacing }) => ({
    "& > *:not(style)": {
      margin: spacing
    },
    flexWrap: "wrap"
  });
  const wrapItemStyle = {
    alignItems: "flex-start",
    display: "flex",
    flexWrap: "wrap"
  };

  var __defProp$V = Object.defineProperty;
  var __defProps$D = Object.defineProperties;
  var __getOwnPropDescs$D = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$V = Object.getOwnPropertySymbols;
  var __hasOwnProp$V = Object.prototype.hasOwnProperty;
  var __propIsEnum$V = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$V = (obj, key, value) => key in obj ? __defProp$V(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$V = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$V.call(b, prop))
        __defNormalProp$V(a, prop, b[prop]);
    if (__getOwnPropSymbols$V)
      for (var prop of __getOwnPropSymbols$V(b)) {
        if (__propIsEnum$V.call(b, prop))
          __defNormalProp$V(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$D = (a, b) => __defProps$D(a, __getOwnPropDescs$D(b));
  var __objRest$H = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$V.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$V)
      for (var prop of __getOwnPropSymbols$V(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$V.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Wrap = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { spacing = 10 } = _b, props = __objRest$H(_b, ["spacing"]);
    return /* @__PURE__ */ React__default["default"].createElement(Flex, __spreadProps$D(__spreadValues$V({
      as: "ul",
      flexWrap: "wrap",
      sx: getWrapStyle(__spreadProps$D(__spreadValues$V({}, props), { spacing }))
    }, props), {
      ref
    }));
  });
  const WrapItem = React__default["default"].forwardRef((props, ref) => /* @__PURE__ */ React__default["default"].createElement(Wrap, __spreadProps$D(__spreadValues$V({
    as: "li",
    sx: wrapItemStyle
  }, props), {
    ref
  })));

  const StyledIcon = ({ children, disabled, variantSize, direction = "left" }) => /* @__PURE__ */ React__default["default"].createElement(Box, {
    sx: {
      cursor: disabled ? "not-allowed" : "pointer",
      [direction]: "inline.nano",
      mx: variantSize === "lg" ? "inline.nano" : "inline.quark",
      pointerEvents: "none",
      position: "absolute",
      top: variantSize === "lg" ? "inline.xxxs" : "inline.nano"
    }
  }, children);

  var __defProp$U = Object.defineProperty;
  var __defProps$C = Object.defineProperties;
  var __getOwnPropDescs$C = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$U = Object.getOwnPropertySymbols;
  var __hasOwnProp$U = Object.prototype.hasOwnProperty;
  var __propIsEnum$U = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$U = (obj, key, value) => key in obj ? __defProp$U(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$U = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$U.call(b, prop))
        __defNormalProp$U(a, prop, b[prop]);
    if (__getOwnPropSymbols$U)
      for (var prop of __getOwnPropSymbols$U(b)) {
        if (__propIsEnum$U.call(b, prop))
          __defNormalProp$U(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$C = (a, b) => __defProps$C(a, __getOwnPropDescs$C(b));
  var __objRest$G = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$U.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$U)
      for (var prop of __getOwnPropSymbols$U(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$U.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const getSpacingValue = (type, { size, variant }) => {
    if (type === "bottom") {
      if (variant === "horizontal") {
        return `stack.${size}`;
      }
      return "0";
    } else if (type === "right") {
      if (variant === "vertical") {
        return `inline.${size}`;
      }
      return "0";
    }
    return "0";
  };
  const Spacing = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { size = "quark", sx, variant = "horizontal" } = _b, props = __objRest$G(_b, ["size", "sx", "variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$C(__spreadValues$U({}, props), {
      ref,
      sx: __spreadValues$U(__spreadValues$U({}, {
        paddingBottom: mapResponsive(size, (propSize) => getSpacingValue("bottom", { size: propSize, variant })),
        paddingRight: mapResponsive(size, (propSize) => getSpacingValue("right", { size: propSize, variant })),
        position: "relative"
      }), sx)
    }));
  });

  var __defProp$T = Object.defineProperty;
  var __getOwnPropSymbols$T = Object.getOwnPropertySymbols;
  var __hasOwnProp$T = Object.prototype.hasOwnProperty;
  var __propIsEnum$T = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$T = (obj, key, value) => key in obj ? __defProp$T(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$T = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$T.call(b, prop))
        __defNormalProp$T(a, prop, b[prop]);
    if (__getOwnPropSymbols$T)
      for (var prop of __getOwnPropSymbols$T(b)) {
        if (__propIsEnum$T.call(b, prop))
          __defNormalProp$T(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$F = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$T.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$T)
      for (var prop of __getOwnPropSymbols$T(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$T.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const InputIcon = (_a) => {
    var _b = _a, {
      iconClick,
      leadingIcon,
      trailingIcon,
      variantSize,
      color,
      disabled,
      brand
    } = _b, props = __objRest$F(_b, [
      "iconClick",
      "leadingIcon",
      "trailingIcon",
      "variantSize",
      "color",
      "disabled",
      "brand"
    ]);
    return iconClick && trailingIcon ? /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
      brand,
      color,
      disabled,
      leadingIcon: trailingIcon,
      onClick: iconClick,
      size: variantSize,
      sx: { alignSelf: "center" },
      type: "button"
    }), /* @__PURE__ */ React__default["default"].createElement(Spacing, {
      size: "quark",
      variant: "vertical"
    })) : /* @__PURE__ */ React__default["default"].createElement(StyledIcon, __spreadValues$T({
      direction: leadingIcon ? "left" : "right",
      disabled,
      variantSize
    }, props), /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color,
      size: variantSize === "sm" ? "xs" : "md",
      sx: { pointerEvents: "none" }
    }, trailingIcon || leadingIcon));
  };

  var __defProp$S = Object.defineProperty;
  var __defProps$B = Object.defineProperties;
  var __getOwnPropDescs$B = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$S = Object.getOwnPropertySymbols;
  var __hasOwnProp$S = Object.prototype.hasOwnProperty;
  var __propIsEnum$S = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$S = (obj, key, value) => key in obj ? __defProp$S(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$S = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$S.call(b, prop))
        __defNormalProp$S(a, prop, b[prop]);
    if (__getOwnPropSymbols$S)
      for (var prop of __getOwnPropSymbols$S(b)) {
        if (__propIsEnum$S.call(b, prop))
          __defNormalProp$S(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$B = (a, b) => __defProps$B(a, __getOwnPropDescs$B(b));
  var __objRest$E = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$S.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$S)
      for (var prop of __getOwnPropSymbols$S(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$S.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Input = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variantSize = "lg", onFocus, onChange, onBlur, width, height, sx, value } = _b, rest = __objRest$E(_b, ["variantSize", "onFocus", "onChange", "onBlur", "width", "height", "sx", "value"]);
    var _a2;
    const {
      label,
      disabled,
      supportMessage,
      variant = "default",
      leadingIcon,
      trailingIcon,
      placeholder,
      id,
      iconColor,
      triggerFocus: triggerActive,
      brand,
      iconClick,
      right
    } = rest;
    const sharedInputRef = React__default["default"].useRef(null);
    const [active, setActive] = React.useState(false);
    const [controlValue, setControlValue] = React__default["default"].useState(value);
    React__default["default"].useEffect(() => {
      if (value !== void 0 && value !== controlValue) {
        setControlValue(value);
      }
    }, [value, controlValue]);
    const handleOnChange = (e) => {
      if (value !== void 0) {
        setControlValue(e.target.value);
      }
    };
    React__default["default"].useEffect(() => {
      var _a3;
      if (value === void 0 && ((_a3 = sharedInputRef.current) == null ? void 0 : _a3.value)) {
        setActive(true);
      }
    }, [value]);
    const isActiveLabel = triggerActive || active || !!controlValue || !!((_a2 = sharedInputRef.current) == null ? void 0 : _a2.value) || !!placeholder;
    const supportVariants = {
      error: "invalid",
      success: "valid"
    };
    const inputColors = getInputColors({
      active,
      brand,
      disabled,
      variant
    });
    return /* @__PURE__ */ React__default["default"].createElement(StyledContainer$1, {
      height,
      sx,
      width
    }, /* @__PURE__ */ React__default["default"].createElement(StyledInputLabelContainer, {
      brand,
      color: inputColors.colorShape,
      disabled,
      focused: active,
      height,
      variantSize
    }, /* @__PURE__ */ React__default["default"].createElement(InputIcon, {
      color: iconColor || inputColors.colorShape,
      disabled,
      iconClick,
      leadingIcon,
      variant,
      variantSize
    }), /* @__PURE__ */ React__default["default"].createElement(StyledLabel$1, {
      color: inputColors.colorLabel,
      htmlFor: id,
      isActive: isActiveLabel,
      label,
      leadingIcon,
      variant,
      variantSize
    }), /* @__PURE__ */ React__default["default"].createElement(StyledInput, __spreadProps$B(__spreadValues$S({
      "aria-disabled": disabled,
      "aria-invalid": variant === "error",
      "aria-placeholder": placeholder,
      "aria-readonly": "true",
      autoCapitalize: "none",
      autoComplete: "off",
      color: inputColors.colorShape,
      disabled,
      height,
      id,
      role: "textbox",
      type: "text",
      value,
      variant,
      variantSize
    }, rest), {
      onBlur: (e) => pipe(() => setActive(false), () => onBlur && onBlur(e))(),
      onChange: (e) => pipe(() => handleOnChange(e), () => onChange && onChange(e))(),
      onFocus: (e) => pipe(() => setActive(true), () => onFocus && onFocus(e))(),
      ref: (e) => {
        if (ref) {
          if (typeof ref === "object") {
            ref.current = e;
          } else if (typeof ref === "function") {
            ref(e);
          }
        }
        sharedInputRef.current = e;
      }
    })), right && !trailingIcon ? right : /* @__PURE__ */ React__default["default"].createElement(InputIcon, {
      brand,
      color: iconColor || inputColors.colorShape,
      disabled,
      iconClick,
      trailingIcon,
      variant,
      variantSize
    })), /* @__PURE__ */ React__default["default"].createElement(Wrap, null, typeof supportMessage === "string" ? /* @__PURE__ */ React__default["default"].createElement(SupportMessage, {
      brand,
      disabled,
      value: supportMessage,
      variant: supportVariants[variant]
    }) : supportMessage == null ? void 0 : supportMessage.map((suptMsg, i) => /* @__PURE__ */ React__default["default"].createElement(WrapItem, {
      key: i,
      mb: "inline.quark",
      mr: "inline.nano"
    }, /* @__PURE__ */ React__default["default"].createElement(SupportMessage, {
      brand,
      disabled,
      tabIndex: i,
      value: suptMsg,
      variant: supportVariants[variant]
    })))));
  });

  var __defProp$R = Object.defineProperty;
  var __defProps$A = Object.defineProperties;
  var __getOwnPropDescs$A = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$R = Object.getOwnPropertySymbols;
  var __hasOwnProp$R = Object.prototype.hasOwnProperty;
  var __propIsEnum$R = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$R = (obj, key, value) => key in obj ? __defProp$R(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$R = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$R.call(b, prop))
        __defNormalProp$R(a, prop, b[prop]);
    if (__getOwnPropSymbols$R)
      for (var prop of __getOwnPropSymbols$R(b)) {
        if (__propIsEnum$R.call(b, prop))
          __defNormalProp$R(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$A = (a, b) => __defProps$A(a, __getOwnPropDescs$A(b));
  var __objRest$D = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$R.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$R)
      for (var prop of __getOwnPropSymbols$R(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$R.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const InputPassword = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variantSize, disabled, brand } = _b, props = __objRest$D(_b, ["variantSize", "disabled", "brand"]);
    const [passwordShown, setPasswordShown] = React.useState(true);
    function toggleVisibility() {
      setPasswordShown(!passwordShown);
    }
    function renderIcon(showPassword) {
      if (showPassword) {
        return /* @__PURE__ */ React__default["default"].createElement(almaIcons.ViewOn, null);
      }
      return /* @__PURE__ */ React__default["default"].createElement(almaIcons.ViewOff, null);
    }
    function getInputType(showPassword) {
      if (showPassword) {
        return "password";
      }
      return "text";
    }
    function getInputRole(showPassword) {
      if (showPassword) {
        return void 0;
      }
      return "textbox";
    }
    return /* @__PURE__ */ React__default["default"].createElement(Input, __spreadProps$A(__spreadValues$R({
      brand,
      disabled,
      right: /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
        brand,
        disabled,
        leadingIcon: renderIcon(passwordShown),
        onClick: toggleVisibility,
        size: variantSize,
        sx: { alignSelf: "center" },
        type: "button"
      }), /* @__PURE__ */ React__default["default"].createElement(Spacing, {
        size: "quark",
        variant: "vertical"
      })),
      role: getInputRole(passwordShown),
      variantSize
    }, props), {
      ref,
      type: getInputType(passwordShown)
    }));
  });

  var __defProp$Q = Object.defineProperty;
  var __defProps$z = Object.defineProperties;
  var __getOwnPropDescs$z = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$Q = Object.getOwnPropertySymbols;
  var __hasOwnProp$Q = Object.prototype.hasOwnProperty;
  var __propIsEnum$Q = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$Q = (obj, key, value) => key in obj ? __defProp$Q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$Q = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$Q.call(b, prop))
        __defNormalProp$Q(a, prop, b[prop]);
    if (__getOwnPropSymbols$Q)
      for (var prop of __getOwnPropSymbols$Q(b)) {
        if (__propIsEnum$Q.call(b, prop))
          __defNormalProp$Q(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$z = (a, b) => __defProps$z(a, __getOwnPropDescs$z(b));
  const interactionAcessibleElementBaseStyle = {
    bg: "interaction.blend.02",
    borderRadius: "circle",
    display: "block",
    height: "40px",
    position: "absolute",
    transform: "translateX(-8px)",
    transition: "background-color 0.12s ease-in",
    width: "40px",
    zIndex: 1
  };
  const getTextColor = ({ brand, disabled }) => {
    if (brand) {
      if (!disabled) {
        return {
          color: "typeface.on.brand.pure"
        };
      }
      return {
        color: "typeface.on.brand.meld"
      };
    } else if (disabled) {
      return {
        color: "typeface.meld"
      };
    }
    return {
      color: "typeface.pure"
    };
  };
  const radioStyle = ({ brand, disabled }) => {
    const getHoverBackground = () => {
      if (disabled) {
        return "transparent";
      }
      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };
    const getActiveBackground = () => {
      if (disabled) {
        return "transparent";
      }
      return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
    };
    return {
      "&:active": {
        span: __spreadProps$z(__spreadValues$Q({}, interactionAcessibleElementBaseStyle), {
          bg: getActiveBackground(),
          borderStyle: "none"
        })
      },
      "&:focus, &:focus-visible": {
        span: __spreadProps$z(__spreadValues$Q({}, interactionAcessibleElementBaseStyle), {
          bg: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderColor: brand ? "interaction.on.brand.blend.04" : "interaction.blend.05",
          borderStyle: "solid",
          borderWidth: "thin",
          transform: "translateX(-10px)"
        })
      },
      "&:hover": {
        span: __spreadProps$z(__spreadValues$Q({}, interactionAcessibleElementBaseStyle), {
          bg: getHoverBackground(),
          fill: brand ? "interaction.select.focus" : "interaction.on.brand.select.focus"
        })
      },
      alignItems: "center",
      input: {
        "&:checked": {
          "~ svg": {
            color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
          }
        },
        "&:disabled": {
          "~ svg": {
            color: brand ? "interaction.on.brand.blend.04" : "interaction.blend.04"
          }
        },
        "&:focus": {
          "~ svg": {
            bg: "transparent"
          }
        },
        "~ svg": {
          color: brand ? "interaction.on.brand.select.default" : "interaction.select.default"
        }
      },
      position: "relative"
    };
  };

  var __defProp$P = Object.defineProperty;
  var __defProps$y = Object.defineProperties;
  var __getOwnPropDescs$y = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$P = Object.getOwnPropertySymbols;
  var __hasOwnProp$P = Object.prototype.hasOwnProperty;
  var __propIsEnum$P = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$P = (obj, key, value) => key in obj ? __defProp$P(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$P = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$P.call(b, prop))
        __defNormalProp$P(a, prop, b[prop]);
    if (__getOwnPropSymbols$P)
      for (var prop of __getOwnPropSymbols$P(b)) {
        if (__propIsEnum$P.call(b, prop))
          __defNormalProp$P(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$y = (a, b) => __defProps$y(a, __getOwnPropDescs$y(b));
  var __objRest$C = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$P.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$P)
      for (var prop of __getOwnPropSymbols$P(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$P.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Radio = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { sx } = _b, props = __objRest$C(_b, ["sx"]);
    const _a2 = props, { label, value, disabled } = _a2, rest = __objRest$C(_a2, ["label", "value", "disabled"]);
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, {
      sx: __spreadValues$P(__spreadValues$P({}, radioStyle(props)), sx)
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      as: "span"
    }), /* @__PURE__ */ React__default["default"].createElement(themeUi.Radio, __spreadProps$y(__spreadValues$P({
      disabled,
      value,
      width: 24
    }, rest), {
      ref
    })), /* @__PURE__ */ React__default["default"].createElement(Body, {
      ml: "inline.nano",
      sx: __spreadValues$P({}, getTextColor(props))
    }, label));
  });

  var __defProp$O = Object.defineProperty;
  var __defProps$x = Object.defineProperties;
  var __getOwnPropDescs$x = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$O = Object.getOwnPropertySymbols;
  var __hasOwnProp$O = Object.prototype.hasOwnProperty;
  var __propIsEnum$O = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$O = (obj, key, value) => key in obj ? __defProp$O(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$O = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$O.call(b, prop))
        __defNormalProp$O(a, prop, b[prop]);
    if (__getOwnPropSymbols$O)
      for (var prop of __getOwnPropSymbols$O(b)) {
        if (__propIsEnum$O.call(b, prop))
          __defNormalProp$O(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$x = (a, b) => __defProps$x(a, __getOwnPropDescs$x(b));
  const getInputBoxStyle = (brand) => ({
    "::-webkit-search-decoration, ::-webkit-search-cancel-button, ::-webkit-search-results-button, ::-webkit-search-results-decoration": {
      MozAppearance: "none",
      WebkitAppearance: "none",
      appearance: "none",
      display: "none"
    },
    ":disabled": {
      cursor: "not-allowed"
    },
    ":focus": {
      backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02",
      borderBottomWidth: "thin",
      borderColor: brand ? "interaction.inverse.blend.08" : "interaction.select.active",
      borderLeftWidth: "none",
      borderRightWidth: "none",
      borderTopWidth: "none"
    },
    ":hover:enabled": {
      backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02"
    },
    backgroundColor: brand ? "interaction.inverse.blend.02" : "interaction.blend.01",
    borderBottomLeftRadius: "none",
    borderBottomRightRadius: "none",
    borderBottomWidth: "hairline",
    borderColor: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
    borderLeftWidth: "none",
    borderRightWidth: "none",
    borderStyle: "solid",
    borderTopLeftRadius: "xs",
    borderTopRightRadius: "xs",
    borderTopWidth: "none",
    width: "100%"
  });
  const getMagnifierIconSize = (variantSize) => variantSize === "lg" ? 26 : 20;
  const getCustomStyle = (variantSize) => {
    const baseObject = {
      padding: getVerticalSpacing(variantSize).string,
      paddingLeft: `${parseInt(getVerticalSpacing(variantSize).themeUi, 10) * 2 + getMagnifierIconSize(variantSize)}px`,
      paddingRight: `${parseInt(getVerticalSpacing(variantSize).themeUi, 10) * 2 + 18}px`
    };
    if (variantSize === "lg") {
      baseObject["height"] = "56px";
    } else {
      baseObject["height"] = "32px";
    }
    return baseObject;
  };
  const getVerticalSpacing = (variantSize) => {
    if (variantSize === "lg") {
      return {
        string: "xxxs",
        themeUi: defaultTheme$1.space.inline.xxxs
      };
    }
    return {
      string: "nano",
      themeUi: defaultTheme$1.space.inline.nano
    };
  };
  const getFontStyle = ({ variantSize, brand }) => {
    const fontStyleObject = {
      "::placeholder": {
        color: brand ? "typeface.on.brand.pure" : "typeface.smooth"
      },
      "::selection": {
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.subtle.02"
      },
      color: brand ? "typeface.on.brand.pure" : "typeface.smooth",
      fontFamily: "base",
      fontStyle: "normal",
      fontWeight: "normal"
    };
    if (variantSize === "lg") {
      return __spreadProps$x(__spreadValues$O({}, fontStyleObject), {
        fontSize: "xs"
      });
    }
    return __spreadProps$x(__spreadValues$O({}, fontStyleObject), {
      fontSize: "xxs"
    });
  };
  const getSearchStyle = ({ variantSize, brand }) => __spreadValues$O(__spreadValues$O(__spreadValues$O({}, getInputBoxStyle(brand)), getFontStyle({ brand, variantSize })), getCustomStyle(variantSize));
  const getMagnifierIconStyle = ({ variantSize, focused, hovered, brand }) => {
    let iconColor;
    if (focused) {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.08" : "interaction.select.active"
        }
      };
    } else if (hovered) {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.07" : "interaction.select.focus"
        }
      };
    } else {
      iconColor = {
        "& > svg > path": {
          fill: brand ? "interaction.inverse.blend.07" : "interaction.select.default"
        }
      };
    }
    return __spreadValues$O({
      "& > svg": {
        height: "100%",
        width: "100%"
      },
      height: `${getMagnifierIconSize(variantSize)}px`,
      left: getVerticalSpacing(variantSize).themeUi,
      pointerEvents: "none",
      position: "absolute",
      top: `calc(50% - ${getMagnifierIconSize(variantSize) / 2}px)`,
      width: `${getMagnifierIconSize(variantSize)}px`
    }, iconColor);
  };
  const getClearIconStyle = ({ brand, variantSize }) => ({
    cursor: "pointer",
    position: "absolute",
    right: getVerticalSpacing(variantSize).themeUi
  });

  var __defProp$N = Object.defineProperty;
  var __defProps$w = Object.defineProperties;
  var __getOwnPropDescs$w = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$N = Object.getOwnPropertySymbols;
  var __hasOwnProp$N = Object.prototype.hasOwnProperty;
  var __propIsEnum$N = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$N = (obj, key, value) => key in obj ? __defProp$N(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$N = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$N.call(b, prop))
        __defNormalProp$N(a, prop, b[prop]);
    if (__getOwnPropSymbols$N)
      for (var prop of __getOwnPropSymbols$N(b)) {
        if (__propIsEnum$N.call(b, prop))
          __defNormalProp$N(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$w = (a, b) => __defProps$w(a, __getOwnPropDescs$w(b));
  var __objRest$B = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$N.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$N)
      for (var prop of __getOwnPropSymbols$N(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$N.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Search = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, {
      brand,
      value,
      defaultValue,
      disabled,
      placeholder,
      variantSize = "lg",
      onBlur,
      onFocus,
      onChange,
      onMouseEnter,
      onMouseLeave,
      onClear,
      sx
    } = _b, otherProps = __objRest$B(_b, [
      "brand",
      "value",
      "defaultValue",
      "disabled",
      "placeholder",
      "variantSize",
      "onBlur",
      "onFocus",
      "onChange",
      "onMouseEnter",
      "onMouseLeave",
      "onClear",
      "sx"
    ]);
    const [focused, setFocused] = React.useState(false);
    const [hovered, setHovered] = React.useState(false);
    const [controlValue, setValue] = React.useState(defaultValue || value);
    React.useEffect(() => {
      if (value) {
        setValue(value);
      }
    }, [value]);
    return /* @__PURE__ */ React__default["default"].createElement(Center, {
      sx: __spreadValues$N(__spreadValues$N({}, { opacity: disabled ? defaultTheme$1.opacities["07"] : 1, position: "relative" }), sx)
    }, /* @__PURE__ */ React__default["default"].createElement(Icon, {
      sx: getMagnifierIconStyle({ brand, focused, hovered, variantSize })
    }, /* @__PURE__ */ React__default["default"].createElement(almaIcons.Search, null)), /* @__PURE__ */ React__default["default"].createElement(themeUi.Input, __spreadProps$w(__spreadValues$N({
      autoComplete: "off",
      dir: "auto",
      disabled,
      placeholder,
      role: "combobox",
      spellCheck: "false",
      sx: getSearchStyle({ brand, variantSize }),
      type: "search",
      value: controlValue || ""
    }, otherProps), {
      onBlur: (e) => {
        if (!disabled) {
          setFocused(false);
        }
        if (onBlur) {
          onBlur(e);
        }
      },
      onChange: (e) => {
        setValue(e.target.value);
        if (onChange) {
          onChange(e);
        }
      },
      onFocus: (e) => {
        if (!disabled) {
          setFocused(true);
        }
        if (onFocus) {
          onFocus(e);
        }
      },
      onMouseEnter: (e) => {
        if (!disabled) {
          setHovered(true);
        }
        if (onMouseEnter) {
          onMouseEnter(e);
        }
      },
      onMouseLeave: (e) => {
        if (!disabled) {
          setHovered(false);
        }
        if (onMouseLeave) {
          onMouseLeave(e);
        }
      },
      ref
    })), !disabled && controlValue && /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
      id: "search-element-id",
      leadingIcon: /* @__PURE__ */ React__default["default"].createElement(almaIcons.Close, null),
      onClick: () => {
        setValue("");
        if (onClear) {
          onClear();
        }
      },
      size: "sm",
      sx: getClearIconStyle({ brand, focused, hovered, variantSize }),
      type: "button"
    }));
  });

  const titleStyle = {
    color: "typeface.strong",
    fontFamily: "base",
    fontSize: "xs",
    fontWeight: "bold",
    letterSpacing: "standard",
    lineHeight: "superdistant",
    padding: "inset.quark",
    width: `calc(100% - ${parseInt(defaultTheme$1.space.inset.md, 10)}px)`
  };
  const getMessageStyle$1 = (linkProps) => {
    const baseObject = {
      margin: 0,
      paddingLeft: "inset.quark",
      paddingRight: "inset.quark",
      whiteSpace: "pre-wrap",
      width: `calc(100% - ${parseInt(defaultTheme$1.space.inset.md, 10)}px)`
    };
    if (linkProps) {
      baseObject["marginBottom"] = "stack.nano";
    }
    return baseObject;
  };
  const linkStyle = {
    alignItems: "center",
    display: "flex",
    marginTop: "stack.nano",
    paddingLeft: "inset.quark",
    paddingRight: "inset.quark",
    textDecoration: "none",
    width: `calc(100% - ${parseInt(defaultTheme$1.space.inset.md, 10)}px)`
  };
  const iconTypeStyle$1 = {
    height: "inset.md",
    left: "inset.xs",
    position: "absolute",
    top: "inset.xs",
    width: "inset.md"
  };
  const closeButtonStyle = {
    position: "absolute",
    right: "inset.xs",
    top: "inset.xs"
  };
  const getContentStyle$1 = (variant, open, bottomDistance) => {
    const containerStyle = {
      alignItems: "flex-start",
      backgroundColor: "neutral.00",
      borderColor: "neutral.30",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      bottom: open ? bottomDistance : -100,
      boxShadow: defaultTheme$1.shadows["02"],
      flexDirection: "column",
      padding: "inset.xs",
      pointerEvents: "auto",
      position: "relative",
      transition: "bottom 0.3s ease-in",
      width: "320px"
    };
    if (variant !== "simple") {
      containerStyle["paddingLeft"] = `${parseInt(defaultTheme$1.space.inset.xs, 10) + parseInt(defaultTheme$1.space.inset.md, 10)}px`;
    }
    return containerStyle;
  };
  const getContainerStyle$3 = (zIndex) => ({
    "&.show": {
      visibility: "visible"
    },
    alignItems: "flex-end",
    bottom: 0,
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    visibility: "hidden",
    width: "100%",
    zIndex
  });

  var __defProp$M = Object.defineProperty;
  var __defProps$v = Object.defineProperties;
  var __getOwnPropDescs$v = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$M = Object.getOwnPropertySymbols;
  var __hasOwnProp$M = Object.prototype.hasOwnProperty;
  var __propIsEnum$M = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$M = (obj, key, value) => key in obj ? __defProp$M(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$M = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$M.call(b, prop))
        __defNormalProp$M(a, prop, b[prop]);
    if (__getOwnPropSymbols$M)
      for (var prop of __getOwnPropSymbols$M(b)) {
        if (__propIsEnum$M.call(b, prop))
          __defNormalProp$M(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$v = (a, b) => __defProps$v(a, __getOwnPropDescs$v(b));
  var __objRest$A = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$M.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$M)
      for (var prop of __getOwnPropSymbols$M(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$M.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const isSmallProp$1 = (variant) => variant === "sm";
  const LinkInline = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant = "lg" } = _b, props = __objRest$A(_b, ["variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadProps$v(__spreadValues$M({
      as: "a",
      color: getColorTypfaceTokenByProp(props, "pure"),
      css: { textDecoration: "underline" },
      fontFamily: "base",
      fontSize: isSmallProp$1(variant) ? "xxs" : "xs",
      letterSpacing: "standard",
      lineHeight: isSmallProp$1(variant) ? "huge" : "superdistant"
    }, props), {
      ref
    }));
  });

  var __defProp$L = Object.defineProperty;
  var __getOwnPropSymbols$L = Object.getOwnPropertySymbols;
  var __hasOwnProp$L = Object.prototype.hasOwnProperty;
  var __propIsEnum$L = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$L = (obj, key, value) => key in obj ? __defProp$L(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$L = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$L.call(b, prop))
        __defNormalProp$L(a, prop, b[prop]);
    if (__getOwnPropSymbols$L)
      for (var prop of __getOwnPropSymbols$L(b)) {
        if (__propIsEnum$L.call(b, prop))
          __defNormalProp$L(a, prop, b[prop]);
      }
    return a;
  };
  const getCustomAttributes = (variant) => {
    const customAttributes = {};
    switch (variant) {
      case "lg":
        customAttributes["fontSize"] = "xs";
        customAttributes["height"] = "32px";
        customAttributes["lineHeight"] = "medium";
        break;
      case "sm":
        customAttributes["fontSize"] = "xxs";
        customAttributes["height"] = "24px";
        customAttributes["lineHeight"] = "standard";
        break;
    }
    return customAttributes;
  };
  const getContainerStyle$2 = (brand, variant) => {
    const getInteractionAttributes = (defaultColor, brandColor) => ({
      "& > p": {
        borderBottomColor: brand ? brandColor : defaultColor,
        borderBottomStyle: "solid",
        borderBottomWidth: "thin",
        color: "inherit"
      }
    });
    return __spreadValues$L({
      "& > p": {
        borderBottomColor: "transparent",
        borderBottomStyle: "solid",
        borderBottomWidth: "thin",
        color: "inherit",
        fontSize: "inherit",
        lineHeight: "inherit",
        paddingTop: "1px"
      },
      ":active": __spreadValues$L({
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.active"
      }, getInteractionAttributes("interaction.select.active", "interaction.inverse.blend.08")),
      ":focus:not(:active)": __spreadValues$L({
        borderColor: brand ? "interaction.inverse.blend.08" : "interaction.select.focus",
        borderStyle: "solid",
        borderWidth: "thin",
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
      }, getInteractionAttributes("interaction.select.focus", "interaction.inverse.blend.08")),
      ":hover:not(:active)": __spreadValues$L({
        color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
      }, getInteractionAttributes("interaction.select.focus", "interaction.inverse.blend.08")),
      alignItems: "center",
      borderColor: "transparent",
      borderStyle: "solid",
      borderWidth: "thin",
      boxSizing: "border-box",
      color: brand ? "interaction.inverse.blend.07" : "interaction.select.default",
      display: "inline-flex",
      margin: 0,
      padding: "inline.quark",
      textDecoration: "none"
    }, getCustomAttributes(variant));
  };
  const getDisabledContainerStyle = (brand, variant) => __spreadValues$L({
    "& > p": {
      borderBottomColor: "transparent",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin",
      color: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      paddingTop: "1px"
    },
    alignItems: "center",
    color: brand ? "interaction.inverse.blend.05" : "typeface.meld",
    display: "inline-flex",
    margin: 0,
    padding: "inline.quark",
    textDecoration: "none"
  }, getCustomAttributes(variant));

  var __defProp$K = Object.defineProperty;
  var __defProps$u = Object.defineProperties;
  var __getOwnPropDescs$u = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$K = Object.getOwnPropertySymbols;
  var __hasOwnProp$K = Object.prototype.hasOwnProperty;
  var __propIsEnum$K = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$K = (obj, key, value) => key in obj ? __defProp$K(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$K = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$K.call(b, prop))
        __defNormalProp$K(a, prop, b[prop]);
    if (__getOwnPropSymbols$K)
      for (var prop of __getOwnPropSymbols$K(b)) {
        if (__propIsEnum$K.call(b, prop))
          __defNormalProp$K(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$u = (a, b) => __defProps$u(a, __getOwnPropDescs$u(b));
  var __objRest$z = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$K.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$K)
      for (var prop of __getOwnPropSymbols$K(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$K.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const LinkStandalone = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, disabled, href, leadingIcon, trailingIcon, label, target, sx, variant } = _b, props = __objRest$z(_b, ["brand", "disabled", "href", "leadingIcon", "trailingIcon", "label", "target", "sx", "variant"]);
    const getIconSize = () => {
      switch (variant) {
        case "lg":
          return "md";
        case "sm":
          return "xs";
        default:
          return "md";
      }
    };
    const renderContent = () => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      size: getIconSize(),
      sx: { marginRight: "10px" }
    }, leadingIcon), /* @__PURE__ */ React__default["default"].createElement(Body, null, label), trailingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      size: getIconSize(),
      sx: { marginLeft: "10px" }
    }, trailingIcon));
    if (disabled) {
      return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$u(__spreadValues$K({}, props), {
        ref,
        sx: __spreadValues$K(__spreadValues$K({}, getDisabledContainerStyle(brand, variant)), sx),
        tabIndex: 0
      }), renderContent());
    }
    return /* @__PURE__ */ React__default["default"].createElement(LinkInline, __spreadProps$u(__spreadValues$K({}, props), {
      href,
      onMouseUp: (evt) => {
        evt.currentTarget.blur();
        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref,
      sx: __spreadValues$K(__spreadValues$K({}, getContainerStyle$2(brand, variant)), sx),
      tabIndex: 0,
      target,
      variant
    }), renderContent());
  });

  var __defProp$J = Object.defineProperty;
  var __defProps$t = Object.defineProperties;
  var __getOwnPropDescs$t = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$J = Object.getOwnPropertySymbols;
  var __hasOwnProp$J = Object.prototype.hasOwnProperty;
  var __propIsEnum$J = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$J = (obj, key, value) => key in obj ? __defProp$J(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$J = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$J.call(b, prop))
        __defNormalProp$J(a, prop, b[prop]);
    if (__getOwnPropSymbols$J)
      for (var prop of __getOwnPropSymbols$J(b)) {
        if (__propIsEnum$J.call(b, prop))
          __defNormalProp$J(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$t = (a, b) => __defProps$t(a, __getOwnPropDescs$t(b));
  var __objRest$y = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$J.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$J)
      for (var prop of __getOwnPropSymbols$J(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$J.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Toast = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, {
      bottomDistance = 100,
      className,
      duration = 3e3,
      onClose,
      variant = "simple",
      supportIcon,
      linkProps,
      message,
      open,
      sx,
      title,
      zIndex
    } = _b, otherProps = __objRest$y(_b, [
      "bottomDistance",
      "className",
      "duration",
      "onClose",
      "variant",
      "supportIcon",
      "linkProps",
      "message",
      "open",
      "sx",
      "title",
      "zIndex"
    ]);
    const renderToastTypeIcon = () => {
      let iconColor = "";
      let IconToRender = null;
      switch (variant) {
        case "success":
          iconColor = "feedback.success.shape";
          IconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.CheckRound, null);
          break;
        case "error":
          iconColor = "feedback.error.shape";
          IconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.WarningRound, null);
          break;
        case "custom":
          IconToRender = supportIcon ? supportIcon : /* @__PURE__ */ React__default["default"].createElement(almaIcons.App, null);
          break;
      }
      if (IconToRender) {
        return /* @__PURE__ */ React__default["default"].createElement(Icon, {
          color: iconColor,
          size: "md",
          sx: iconTypeStyle$1
        }, IconToRender);
      }
      return null;
    };
    const openRef = React.useRef(false);
    React.useEffect(() => {
      if (duration) {
        let openTimeout;
        if (!openRef.current && open) {
          openTimeout = window.setTimeout(() => {
            onClose && onClose(false);
          }, duration);
        }
        if (openRef.current !== open) {
          openRef.current = open;
        }
        return () => clearTimeout(openTimeout);
      }
      return;
    });
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$t(__spreadValues$J({}, otherProps), {
      className: `${className ? className : ""} ${open ? "show" : ""}`,
      ref,
      sx: __spreadValues$J(__spreadValues$J({}, getContainerStyle$3(zIndex)), sx)
    }), /* @__PURE__ */ React__default["default"].createElement(Center, {
      ref,
      sx: getContentStyle$1(variant, open, bottomDistance)
    }, renderToastTypeIcon(), title && /* @__PURE__ */ React__default["default"].createElement(themeUi.Heading, {
      as: "h3",
      sx: titleStyle
    }, title), message && /* @__PURE__ */ React__default["default"].createElement(Body, {
      sx: getMessageStyle$1(linkProps),
      variant: "sm"
    }, message), /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */ React__default["default"].createElement(almaIcons.Close, null),
      onClick: () => onClose && onClose(false),
      size: "sm",
      sx: closeButtonStyle
    }), linkProps && /* @__PURE__ */ React__default["default"].createElement(LinkStandalone, {
      href: linkProps.href,
      label: linkProps.label,
      sx: linkStyle,
      target: linkProps.target,
      trailingIcon: linkProps.icon,
      variant: "sm"
    })));
  });

  var __defProp$I = Object.defineProperty;
  var __getOwnPropSymbols$I = Object.getOwnPropertySymbols;
  var __hasOwnProp$I = Object.prototype.hasOwnProperty;
  var __propIsEnum$I = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$I = (obj, key, value) => key in obj ? __defProp$I(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$I = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$I.call(b, prop))
        __defNormalProp$I(a, prop, b[prop]);
    if (__getOwnPropSymbols$I)
      for (var prop of __getOwnPropSymbols$I(b)) {
        if (__propIsEnum$I.call(b, prop))
          __defNormalProp$I(a, prop, b[prop]);
      }
    return a;
  };
  const getMessageStyle = (actionButton) => {
    const baseObject = {
      margin: 0,
      maxHeight: "96px",
      overflow: "auto",
      paddingY: "stack.quark",
      position: "relative"
    };
    if (actionButton) {
      baseObject["marginRight"] = "inline.xxxs";
    }
    return baseObject;
  };
  const iconTypeStyle = {
    marginRight: "inline.xxxs"
  };
  const getAnchorOrigin = (anchorOrigin, bottomDistance, horizontalDistance, open) => {
    if (anchorOrigin) {
      return __spreadValues$I(__spreadValues$I(__spreadValues$I(__spreadValues$I({}, (anchorOrigin == null ? void 0 : anchorOrigin.vertical) === "top" ? { alignSelf: "start", top: open ? bottomDistance : -100, transition: "top 0.3s ease-in" } : { alignSelf: "end", bottom: open ? bottomDistance : -100, transition: "bottom 0.3s ease-in" }), (anchorOrigin == null ? void 0 : anchorOrigin.horizontal) === "left" && { left: horizontalDistance, marginRight: "auto" }), (anchorOrigin == null ? void 0 : anchorOrigin.horizontal) === "center" && { marginLeft: "auto", marginRight: "auto" }), (anchorOrigin == null ? void 0 : anchorOrigin.horizontal) === "right" && { marginLeft: "auto", right: horizontalDistance });
    }
    return {
      bottom: open ? bottomDistance : -100,
      transition: "bottom 0.3s ease-in"
    };
  };
  const getContentStyle = (anchorOrigin, bottomDistance, horizontalDistance, open) => __spreadValues$I({
    alignItems: "center",
    backgroundColor: "neutral.00",
    borderColor: "neutral.30",
    borderRadius: "xs",
    borderStyle: "solid",
    borderWidth: "hairline",
    boxShadow: defaultTheme$1.shadows["02"],
    display: "flex",
    padding: "squish.nano",
    pointerEvents: "auto",
    position: "relative"
  }, getAnchorOrigin(anchorOrigin, bottomDistance, horizontalDistance, open));
  const getContainerStyle$1 = (zIndex) => ({
    "&.show": {
      visibility: "visible"
    },
    alignItems: "flex-end",
    bottom: 0,
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    visibility: "hidden",
    width: "100%",
    zIndex
  });

  var __defProp$H = Object.defineProperty;
  var __defProps$s = Object.defineProperties;
  var __getOwnPropDescs$s = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$H = Object.getOwnPropertySymbols;
  var __hasOwnProp$H = Object.prototype.hasOwnProperty;
  var __propIsEnum$H = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$H = (obj, key, value) => key in obj ? __defProp$H(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$H = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$H.call(b, prop))
        __defNormalProp$H(a, prop, b[prop]);
    if (__getOwnPropSymbols$H)
      for (var prop of __getOwnPropSymbols$H(b)) {
        if (__propIsEnum$H.call(b, prop))
          __defNormalProp$H(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$s = (a, b) => __defProps$s(a, __getOwnPropDescs$s(b));
  var __objRest$x = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$H.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$H)
      for (var prop of __getOwnPropSymbols$H(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$H.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Snackbar = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, {
      actionButton,
      anchorOrigin,
      bottomDistance = 8,
      horizontalDistance = 8,
      duration = 3e3,
      message,
      onClose,
      open,
      sx,
      variant = "simple",
      supportIcon,
      zIndex
    } = _b, otherProps = __objRest$x(_b, [
      "actionButton",
      "anchorOrigin",
      "bottomDistance",
      "horizontalDistance",
      "duration",
      "message",
      "onClose",
      "open",
      "sx",
      "variant",
      "supportIcon",
      "zIndex"
    ]);
    const renderSnackbarTypeIcon = () => {
      let iconColor = "";
      let IconToRender = null;
      switch (variant) {
        case "success":
          iconColor = "feedback.success.shape";
          IconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.CheckRound, null);
          break;
        case "error":
          iconColor = "feedback.error.shape";
          IconToRender = /* @__PURE__ */ React__default["default"].createElement(almaIcons.WarningRound, null);
          break;
        case "custom":
          IconToRender = supportIcon ? supportIcon : /* @__PURE__ */ React__default["default"].createElement(almaIcons.App, null);
          break;
      }
      if (IconToRender) {
        return /* @__PURE__ */ React__default["default"].createElement(Icon, {
          color: iconColor,
          sx: iconTypeStyle
        }, IconToRender);
      }
      return null;
    };
    const openRef = React.useRef(false);
    React.useEffect(() => {
      let openTimeout;
      if (!openRef.current && open) {
        openTimeout = window.setTimeout(() => {
          onClose && onClose(false);
        }, duration);
      }
      if (openRef.current !== open) {
        openRef.current = open;
      }
      return () => clearTimeout(openTimeout);
    });
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$s(__spreadValues$H({
      sx: __spreadValues$H(__spreadValues$H({}, getContainerStyle$1(zIndex)), sx)
    }, otherProps), {
      className: open ? "show" : "",
      ref
    }), /* @__PURE__ */ React__default["default"].createElement(Center, {
      sx: getContentStyle(anchorOrigin, bottomDistance, horizontalDistance, open)
    }, renderSnackbarTypeIcon(), /* @__PURE__ */ React__default["default"].createElement(Body, {
      sx: getMessageStyle(actionButton),
      variant: "sm"
    }, message), actionButton && /* @__PURE__ */ React__default["default"].createElement(Button, {
      onClick: () => actionButton.onClick && actionButton.onClick(),
      size: "sm",
      variant: "tertiary"
    }, actionButton.label)));
  });

  var __defProp$G = Object.defineProperty;
  var __defProps$r = Object.defineProperties;
  var __getOwnPropDescs$r = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$G = Object.getOwnPropertySymbols;
  var __hasOwnProp$G = Object.prototype.hasOwnProperty;
  var __propIsEnum$G = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$G = (obj, key, value) => key in obj ? __defProp$G(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$G = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$G.call(b, prop))
        __defNormalProp$G(a, prop, b[prop]);
    if (__getOwnPropSymbols$G)
      for (var prop of __getOwnPropSymbols$G(b)) {
        if (__propIsEnum$G.call(b, prop))
          __defNormalProp$G(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$r = (a, b) => __defProps$r(a, __getOwnPropDescs$r(b));
  var __objRest$w = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$G.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$G)
      for (var prop of __getOwnPropSymbols$G(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$G.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const headingVariantStyle = {
    lg: {
      fontSize: "xs"
    },
    md: {
      fontSize: "xxs",
      lineHeight: "tiny"
    },
    sm: {
      fontSize: "xxxs",
      letterSpacing: "standard",
      lineHeight: "distant"
    }
  };
  const TextInteraction = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, variant = "lg" } = _b, props = __objRest$w(_b, ["brand", "variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadProps$r(__spreadValues$G({
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      fontFamily: "base",
      fontWeight: "medium",
      letterSpacing: "standard",
      lineHeight: "superdistant",
      ref
    }, props), {
      sx: __spreadValues$G(__spreadValues$G({}, headingVariantStyle[variant]), props.sx)
    }));
  });

  var __defProp$F = Object.defineProperty;
  var __getOwnPropSymbols$F = Object.getOwnPropertySymbols;
  var __hasOwnProp$F = Object.prototype.hasOwnProperty;
  var __propIsEnum$F = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$F = (obj, key, value) => key in obj ? __defProp$F(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$F = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$F.call(b, prop))
        __defNormalProp$F(a, prop, b[prop]);
    if (__getOwnPropSymbols$F)
      for (var prop of __getOwnPropSymbols$F(b)) {
        if (__propIsEnum$F.call(b, prop))
          __defNormalProp$F(a, prop, b[prop]);
      }
    return a;
  };
  const getTabStyle = (brand, disabled, active) => {
    const getActiveStyle = (isActive) => {
      if (isActive) {
        return {
          borderBottomColor: brand ? "interaction.on.brand.select.active" : "interaction.select.active",
          borderBottomWidth: "thin",
          color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
        };
      }
      return {};
    };
    const getDisabledStyle = () => {
      if (disabled) {
        return {
          borderBottomColor: "transparent",
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          borderTopColor: "transparent",
          borderTopStyle: "solid",
          borderTopWidth: "thin",
          color: brand ? "typeface.on.brand.meld" : "typeface.meld",
          cursor: "not-allowed"
        };
      }
      return {
        ":active": __spreadValues$F({}, getActiveStyle(true)),
        ":focus:not(:active)": {
          borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderStyle: "solid",
          borderWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          margin: -2
        },
        ":hover:not(:active)": {
          borderBottomColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderBottomWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus"
        }
      };
    };
    return __spreadValues$F(__spreadValues$F({
      borderBottomColor: brand ? "interaction.on.brand.blend.04" : "interaction.blend.04",
      borderBottomStyle: "solid",
      borderBottomWidth: "hairline",
      borderTopColor: "transparent",
      borderTopStyle: "solid",
      borderTopWidth: "thin",
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      cursor: "pointer",
      display: "inline-block",
      margin: 0,
      padding: "inset.xs",
      textAlign: "center"
    }, getActiveStyle(active)), getDisabledStyle());
  };
  const getTabContained = (brand, disabled, active) => {
    const getActiveStyle = (isActive) => {
      if (isActive) {
        return {
          backgroundColor: "transparent",
          borderTopColor: brand ? "interaction.on.brand.select.active" : "interaction.select.active",
          borderTopWidth: "thin",
          color: brand ? "interaction.on.brand.select.active" : "interaction.select.active"
        };
      }
      return {};
    };
    const getDisabledStyle = () => {
      if (disabled) {
        return {
          backgroundColor: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
          borderBottomColor: "transparent",
          borderBottomStyle: "solid",
          borderBottomWidth: "thin",
          borderTopColor: "transparent",
          borderTopStyle: "solid",
          borderTopWidth: "thin",
          color: brand ? "interaction.inverse.blend.05" : "typeface.meld",
          cursor: "not-allowed"
        };
      }
      return {
        ":active": __spreadValues$F({}, getActiveStyle(true)),
        ":focus:not(:active)": {
          backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          borderStyle: "solid",
          borderWidth: "thin",
          color: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          margin: -2
        },
        ":hover:not(:active)": {
          backgroundColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02",
          borderTopColor: brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
          color: brand ? "interaction.inverse.blend.08" : "interaction.select.focus"
        }
      };
    };
    return __spreadValues$F(__spreadValues$F({
      backgroundColor: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
      borderBottomColor: "transparent",
      borderBottomStyle: "solid",
      borderBottomWidth: "thin",
      borderTopColor: "transparent",
      borderTopStyle: "solid",
      borderTopWidth: "thin",
      color: brand ? "interaction.on.brand.select.default" : "interaction.select.default",
      cursor: "pointer",
      display: "inline-block",
      margin: 0,
      padding: "inset.xs",
      textAlign: "center"
    }, getActiveStyle(active)), getDisabledStyle());
  };
  const getTabContainerStyle = (position) => {
    const getPosition = () => {
      switch (position) {
        case "left":
          return "flex-start";
        case "right":
          return "flex-end";
        case "center":
          return "center";
        default:
          return "center";
      }
    };
    return {
      alignItems: "center",
      display: "flex",
      justifyContent: getPosition()
    };
  };

  var __defProp$E = Object.defineProperty;
  var __defProps$q = Object.defineProperties;
  var __getOwnPropDescs$q = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$E = Object.getOwnPropertySymbols;
  var __hasOwnProp$E = Object.prototype.hasOwnProperty;
  var __propIsEnum$E = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$E = (obj, key, value) => key in obj ? __defProp$E(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$E = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$E.call(b, prop))
        __defNormalProp$E(a, prop, b[prop]);
    if (__getOwnPropSymbols$E)
      for (var prop of __getOwnPropSymbols$E(b)) {
        if (__propIsEnum$E.call(b, prop))
          __defNormalProp$E(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$q = (a, b) => __defProps$q(a, __getOwnPropDescs$q(b));
  var __objRest$v = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$E.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$E)
      for (var prop of __getOwnPropSymbols$E(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$E.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Tab = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { active, brand, contained, sx, disabled, label, handleClick, tabName } = _b, props = __objRest$v(_b, ["active", "brand", "contained", "sx", "disabled", "label", "handleClick", "tabName"]);
    const tabStyle = contained ? __spreadValues$E({}, getTabContained(brand, disabled, active)) : __spreadValues$E({}, getTabStyle(brand, disabled, active));
    const setActive = (evt) => {
      evt.preventDefault();
      if (tabName && handleClick && !disabled) {
        handleClick(tabName, evt);
        return evt.currentTarget.blur();
      }
    };
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$q(__spreadValues$E({}, props), {
      ref
    }), /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      "aria-controls": String(tabName),
      "aria-selected": active,
      brand,
      onClick: setActive,
      sx: __spreadValues$E(__spreadValues$E({}, tabStyle), sx),
      tabIndex: 0,
      variant: "md"
    }, label));
  });
  const TabContainer = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { position } = _d, props = __objRest$v(_d, ["position"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$q(__spreadValues$E({}, props), {
      ref,
      sx: getTabContainerStyle(position)
    }));
  });
  const TabPanesContainer = React__default["default"].forwardRef(({ activeTab = "", children }, ref) => {
    const childWithProps = React__default["default"].Children.map(children, (child) => {
      var _a;
      if (!React__default["default"].isValidElement(child)) {
        return child;
      }
      const isTabSelected = Boolean(activeTab) && activeTab === ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.tabName);
      return React__default["default"].cloneElement(child, {
        ref,
        selected: isTabSelected
      });
    });
    return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
  });
  const TabPane = React__default["default"].forwardRef((_e, ref) => {
    var _f = _e, { selected = false, forceRerender = false, tabName } = _f, props = __objRest$v(_f, ["selected", "forceRerender", "tabName"]);
    const [wasSelected, setSelectedSituation] = React.useState(false);
    React.useLayoutEffect(() => {
      if (!wasSelected && selected) {
        setSelectedSituation(selected);
      }
    }, [wasSelected, selected, forceRerender]);
    const shouldRender = forceRerender ? selected : wasSelected;
    if (!shouldRender) {
      return null;
    }
    return selected ? /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$E({
      "aria-labelledby": tabName,
      ref,
      role: "tabpanel",
      tabIndex: 0
    }, props)) : null;
  });

  var __defProp$D = Object.defineProperty;
  var __defProps$p = Object.defineProperties;
  var __getOwnPropDescs$p = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
  var __hasOwnProp$D = Object.prototype.hasOwnProperty;
  var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$D = (obj, key, value) => key in obj ? __defProp$D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$D = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$D.call(b, prop))
        __defNormalProp$D(a, prop, b[prop]);
    if (__getOwnPropSymbols$D)
      for (var prop of __getOwnPropSymbols$D(b)) {
        if (__propIsEnum$D.call(b, prop))
          __defNormalProp$D(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$p = (a, b) => __defProps$p(a, __getOwnPropDescs$p(b));
  var __objRest$u = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$D.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$D)
      for (var prop of __getOwnPropSymbols$D(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$D.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const StyledContainer = (_a) => {
    var _b = _a, { width = "328px", height = "120px", sx } = _b, props = __objRest$u(_b, ["width", "height", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$D({
      sx: __spreadValues$D({
        height,
        minWidth: 72,
        position: "relative",
        width
      }, sx)
    }, props));
  };
  const StyledTextAreaLabelContainer = ({ color, children, focused, brand, disabled }) => {
    const getBgHoverInput = () => {
      if (disabled) {
        return "";
      }
      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };
    return /* @__PURE__ */ React__default["default"].createElement(Flex, {
      flex: "none",
      sx: {
        "&:disabled": {
          cursor: "not-allowed"
        },
        "&:focus-visible": {
          outline: "none"
        },
        "&:hover": {
          bg: getBgHoverInput()
        },
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        border: "none",
        borderBottomColor: `${color}`,
        borderBottomLeftRadius: "none",
        borderBottomRightRadius: "none",
        borderBottomStyle: "solid",
        borderBottomWidth: focused ? "thin" : "hairline",
        borderTopLeftRadius: "xs",
        borderTopRightRadius: "xs",
        height: "100%",
        minHeight: "120px",
        minWidth: "328px"
      }
    }, children);
  };
  const getColorInputToken = (type, variant) => `feedback.${variant}.${type}`;
  const getTextAreaColors = ({
    variant,
    disabled,
    brand,
    active
  }) => {
    const isNotDefaultVariant = variant !== "default";
    const defaultToken = "interaction.select.default";
    const activeColor = !disabled && active && "interaction.select.active";
    const disabledTypoToken = disabled && "typeface.meld";
    const brandShapeColor = brand ? "interaction.on.brand.select.default" : "";
    const brandLabelColor = brand ? "typeface.on.brand.pure" : "";
    const variantColorShape = isNotDefaultVariant && getColorInputToken("shape", variant);
    const variantColorLabel = isNotDefaultVariant && getColorInputToken("text", variant);
    const colorShape = brandShapeColor || disabledTypoToken || variantColorShape || activeColor || defaultToken;
    const colorLabel = brandLabelColor || disabledTypoToken || variantColorLabel || activeColor || defaultToken;
    return { colorLabel, colorShape };
  };
  const activeLabelStyle = {
    mt: "inline.xxxs",
    overflow: "hidden",
    pt: 0,
    transform: "translateY(-0.625rem)",
    width: "auto"
  };
  const StyledLabel = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { color, isActive, label, variant, leadingIcon } = _d, props = __objRest$u(_d, ["color", "isActive", "label", "variant", "leadingIcon"]);
    const activeStyle = isActive ? activeLabelStyle : "";
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, __spreadProps$p(__spreadValues$D({
      color,
      pt: "inline.xxxs",
      sx: __spreadValues$D({
        "& > p": {
          fontSize: isActive ? "xxxs" : "",
          overflow: "hidden",
          textOverflow: "ellipsis"
        },
        alignItems: "center",
        flex: "none",
        left: leadingIcon ? "inline.sm" : "inline.xxxs",
        pl: "inline.nano",
        pointerEvents: "none",
        position: "absolute",
        pt: "",
        transition: "all 200ms",
        whiteSpace: "nowrap"
      }, activeStyle)
    }, props), {
      ref
    }), /* @__PURE__ */ React__default["default"].createElement(Body, {
      color: "inherit",
      variant: "lg"
    }, label));
  });
  const StyledTextArea = React__default["default"].forwardRef((_e, ref) => {
    var _f = _e, { leadingIcon, brand, height, rows } = _f, props = __objRest$u(_f, ["leadingIcon", "brand", "height", "rows"]);
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Textarea, __spreadProps$p(__spreadValues$D({
      sx: {
        "&:disabled": {
          color: brand ? "typeface.on.brand.meld" : "typeface.meld",
          cursor: "not-allowed"
        },
        '&[type="password"]': {
          font: "small-caption",
          fontSize: "xs"
        },
        border: "none",
        color: brand ? "typeface.on.brand.smooth" : "typeface.smooth",
        fontFamily: "base",
        paddingRight: "inline.xxs",
        resize: "none"
      }
    }, props), {
      ref,
      rows
    }));
  });

  var __defProp$C = Object.defineProperty;
  var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
  var __hasOwnProp$C = Object.prototype.hasOwnProperty;
  var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$C = (obj, key, value) => key in obj ? __defProp$C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$C = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$C.call(b, prop))
        __defNormalProp$C(a, prop, b[prop]);
    if (__getOwnPropSymbols$C)
      for (var prop of __getOwnPropSymbols$C(b)) {
        if (__propIsEnum$C.call(b, prop))
          __defNormalProp$C(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$t = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$C)
      for (var prop of __getOwnPropSymbols$C(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const TextArea = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, {
      defaultValue,
      height,
      sx,
      width,
      brand,
      forceActiveLabel,
      leadingIcon,
      triggerFocus,
      supportMessage,
      maxCharacterCount = 500,
      variantCharactereCount = "comparator",
      rows = 5
    } = _b, rest = __objRest$t(_b, [
      "defaultValue",
      "height",
      "sx",
      "width",
      "brand",
      "forceActiveLabel",
      "leadingIcon",
      "triggerFocus",
      "supportMessage",
      "maxCharacterCount",
      "variantCharactereCount",
      "rows"
    ]);
    const { label, disabled, variant = "default", placeholder, id, value: valueProp } = rest;
    const [valueState, updateValue] = React.useState(defaultValue || "");
    const useControllableProp = (prop, state) => {
      const isControlled2 = prop !== void 0;
      const value2 = isControlled2 && typeof prop !== "undefined" ? prop : state;
      return [isControlled2, value2];
    };
    const [isControlled, value] = useControllableProp(valueProp, valueState);
    const isEmpty = (isEmptyValue2) => {
      if (isEmptyValue2 === null || isEmptyValue2 === "" || isEmptyValue2 === void 0) {
        return true;
      }
      return false;
    };
    const isEmptyValue = isEmpty(value);
    const [isFocused, setIsFocused] = React__default["default"].useState(!isEmptyValue || false);
    const [characterCount, setCharacterCount] = React__default["default"].useState("");
    const handleCharactereCount = (e) => {
      setCharacterCount(e.target.value);
    };
    React__default["default"].useEffect(() => {
      if (value && !forceActiveLabel) {
        setIsFocused(true);
      }
    }, [value, forceActiveLabel]);
    const textAreaColors = getTextAreaColors({
      active: !!isFocused,
      brand,
      disabled,
      variant
    });
    const handleBlur = () => {
      if (!isEmptyValue) {
        return;
      }
      if (!forceActiveLabel) {
        if (triggerFocus) {
          setIsFocused(true);
          return;
        }
        setIsFocused(false);
      }
    };
    const handleChange = (e) => {
      if (!isControlled) {
        updateValue(e.target.value);
        return;
      }
      if (isEmptyValue) {
        updateValue("");
        return;
      }
    };
    const handleFocus = () => {
      !forceActiveLabel && setIsFocused(true);
    };
    const supportVariants = {
      error: "invalid",
      success: "valid"
    };
    const getCounterVariant = () => {
      switch (variantCharactereCount) {
        case "comparator":
          return `${characterCount.length}/${maxCharacterCount}`;
        case "progressive":
          return `${characterCount.length}`;
        case "regressive":
          return maxCharacterCount - characterCount.length;
      }
    };
    const callOnChangeHandlers = (e) => {
      handleChange(e);
      handleCharactereCount(e);
    };
    return /* @__PURE__ */ React__default["default"].createElement(StyledContainer, {
      height,
      sx,
      width
    }, /* @__PURE__ */ React__default["default"].createElement(StyledTextAreaLabelContainer, {
      brand,
      color: textAreaColors.colorShape,
      disabled,
      focused: isFocused
    }, /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: textAreaColors.colorShape,
      disabled,
      size: "md",
      sx: {
        cursor: disabled ? "not-allowed" : "pointer",
        mx: leadingIcon ? "inline.nano" : "",
        pointerEvents: "none",
        position: "relative",
        top: "inline.xxxs"
      }
    }, leadingIcon), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { width: "100%" }
    }, /* @__PURE__ */ React__default["default"].createElement(StyledLabel, {
      color: textAreaColors.colorLabel,
      htmlFor: id,
      isActive: forceActiveLabel || isFocused,
      label,
      leadingIcon,
      variant
    }), /* @__PURE__ */ React__default["default"].createElement(Spacing, {
      size: "xxs"
    }), /* @__PURE__ */ React__default["default"].createElement(StyledTextArea, __spreadValues$C({
      "aria-disabled": disabled,
      "aria-invalid": variant === "error",
      "aria-placeholder": placeholder,
      "aria-readonly": "true",
      autoCapitalize: "none",
      autoComplete: "off",
      brand,
      color: brand ? "typeface.on.brand.pure" : "interaction.select.default",
      disabled,
      height,
      id,
      leadingIcon,
      onBlur: handleBlur,
      onChange: callOnChangeHandlers,
      onFocus: handleFocus,
      ref,
      role: "textbox",
      rows,
      value,
      variant
    }, rest)))), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { display: "flex" }
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { width: "100%" }
    }, /* @__PURE__ */ React__default["default"].createElement(Wrap, null, typeof supportMessage === "string" ? /* @__PURE__ */ React__default["default"].createElement(SupportMessage, {
      brand,
      disabled,
      value: supportMessage,
      variant: supportVariants[variant]
    }) : supportMessage == null ? void 0 : supportMessage.map((suptMsg, i) => /* @__PURE__ */ React__default["default"].createElement(WrapItem, {
      key: i,
      mb: "inline.quark",
      mr: "inline.nano"
    }, /* @__PURE__ */ React__default["default"].createElement(SupportMessage, {
      brand,
      disabled,
      tabIndex: i,
      value: suptMsg,
      variant: supportVariants[variant]
    }))))), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { width: "100%" }
    }, /* @__PURE__ */ React__default["default"].createElement(Wrap, {
      justifyContent: "flex-end"
    }, /* @__PURE__ */ React__default["default"].createElement(Body, {
      brand,
      sx: { color: textAreaColors.colorLabel, fontSize: "xxxs" }
    }, getCounterVariant())))));
  });

  const getIconColor = ({ brand, disabled }, suffix) => {
    if (disabled) {
      return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
    }
    return brand ? `support.on.brand.${suffix}` : `support.${suffix}`;
  };
  const getContainerStyle = (props) => {
    const { brand, disabled } = props;
    return {
      "& > *": {
        cursor: disabled ? "not-allowed" : "auto"
      },
      "&:active": {
        bg: brand ? "interaction.on.brand.blend.02" : "interaction.blend.02"
      },
      "&:focus:not(:active)": {
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        borderColor: brand ? "interaction.on.brand.blend.02" : "interaction.blend.08",
        borderStyle: "solid",
        borderWidth: "thin"
      },
      "&:hover:not(:active)": {
        bg: brand ? "interaction.on.brand.blend.01" : "interaction.blend.01",
        "div span > svg": {
          color: getIconColor(props, "02")
        }
      },
      display: "flex",
      "div span > svg": {
        color: getIconColor(props, "01")
      },
      flexDirection: "column",
      minWidth: 320,
      transition: "all 300ms ease-in-out"
    };
  };
  const wrapperStyle = {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    lineHeight: "20%",
    width: "100%"
  };
  const getTextDisabledColor = ({ brand, disabled }) => {
    if (disabled) {
      return { color: brand ? "typeface.on.brand.meld" : "typeface.meld" };
    }
    return { color: "" };
  };

  var __defProp$B = Object.defineProperty;
  var __defProps$o = Object.defineProperties;
  var __getOwnPropDescs$o = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
  var __hasOwnProp$B = Object.prototype.hasOwnProperty;
  var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$B = (obj, key, value) => key in obj ? __defProp$B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$B = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$B.call(b, prop))
        __defNormalProp$B(a, prop, b[prop]);
    if (__getOwnPropSymbols$B)
      for (var prop of __getOwnPropSymbols$B(b)) {
        if (__propIsEnum$B.call(b, prop))
          __defNormalProp$B(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$o = (a, b) => __defProps$o(a, __getOwnPropDescs$o(b));
  var __objRest$s = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$B.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$B)
      for (var prop of __getOwnPropSymbols$B(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$B.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const renderLabel = (props) => {
    const { brand, center, children, labelText } = props;
    return /* @__PURE__ */ React__default["default"].createElement(Action, {
      brand,
      fontWeight: "medium",
      lineHeight: "superdistant",
      sx: getTextDisabledColor(props)
    }, center || children, labelText);
  };
  const renderDate = (props) => {
    const { brand, dateText } = props;
    return dateText ? /* @__PURE__ */ React__default["default"].createElement(Body, {
      brand,
      lineHeight: 0,
      sx: getTextDisabledColor(props),
      variant: "sm"
    }, dateText) : null;
  };
  const renderBodyText = (props) => {
    const { brand, bodyText, leadingIcon } = props;
    return bodyText ? /* @__PURE__ */ React__default["default"].createElement(Box, {
      p: 0,
      pl: leadingIcon ? "inline.xs" : "",
      pt: "inline.nano"
    }, /* @__PURE__ */ React__default["default"].createElement(Body, {
      brand,
      sx: getTextDisabledColor(props),
      variant: "sm"
    }, bodyText)) : null;
  };
  const ListItem = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { sx } = _b, props = __objRest$s(_b, ["sx"]);
    const _a2 = props, {
      dividerColor,
      left,
      leadingIcon,
      bodyText,
      brand,
      labelText,
      dateText,
      noDivider,
      insetSpace = "inset.xs",
      disabled
    } = _a2, rest = __objRest$s(_a2, [
      "dividerColor",
      "left",
      "leadingIcon",
      "bodyText",
      "brand",
      "labelText",
      "dateText",
      "noDivider",
      "insetSpace",
      "disabled"
    ]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$B({
      as: "li",
      p: 0,
      sx: __spreadProps$o(__spreadValues$B({}, getContainerStyle(props)), { sx })
    }, rest), /* @__PURE__ */ React__default["default"].createElement(Box, {
      p: insetSpace,
      ref
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: wrapperStyle
    }, left || leadingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      mr: "inline.nano"
    }, leadingIcon), renderLabel(props), /* @__PURE__ */ React__default["default"].createElement(Spacer, null), renderDate(props)), renderBodyText(props)), !noDivider && /* @__PURE__ */ React__default["default"].createElement(Divider, {
      brand,
      sx: dividerColor ? { bg: dividerColor } : void 0
    }));
  });

  var __defProp$A = Object.defineProperty;
  var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
  var __hasOwnProp$A = Object.prototype.hasOwnProperty;
  var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$A = (obj, key, value) => key in obj ? __defProp$A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$A = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$A.call(b, prop))
        __defNormalProp$A(a, prop, b[prop]);
    if (__getOwnPropSymbols$A)
      for (var prop of __getOwnPropSymbols$A(b)) {
        if (__propIsEnum$A.call(b, prop))
          __defNormalProp$A(a, prop, b[prop]);
      }
    return a;
  };
  const getLabelStyle = (brand, disabled) => {
    const getFontColor = () => {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }
      return "";
    };
    return {
      color: getFontColor(),
      margin: 0,
      paddingLeft: "inline.nano",
      textAlign: "left"
    };
  };
  const getCheckboxStyle = (brand, checked, disabled) => {
    const getBackgroundColor = () => {
      if (disabled) {
        return brand ? "interaction.inverse.blend.04" : "interaction.blend.03";
      } else if (checked) {
        return brand ? "interaction.inverse.blend.07" : "interaction.select.active";
      }
      return brand ? "interaction.inverse.blend.07" : "interaction.select.default";
    };
    const getStateBackgroundColor = () => {
      if (checked) {
        return brand ? "interaction.inverse.blend.08" : "interaction.select.active";
      }
      return brand ? "interaction.inverse.blend.08" : "interaction.select.focus";
    };
    return {
      ":active:not(:disabled), :focus:not(:disabled), :hover:not(:disabled)": {
        backgroundColor: getStateBackgroundColor()
      },
      backgroundColor: getBackgroundColor(),
      border: "none",
      borderRadius: "pill",
      height: "100%",
      position: "relative",
      width: "100%"
    };
  };
  const getSliderStyle = (brand, checked, hovered, focused, active, disabled) => {
    const getPositionStyle = () => {
      if (checked) {
        return {
          left: "auto",
          right: "inset.quark"
        };
      }
      return {
        left: "inset.quark",
        right: "auto"
      };
    };
    const getStatusStyle = () => {
      if (active) {
        return {
          backgroundColor: brand ? "interaction.inverse.blend.04" : "interaction.blend.03"
        };
      } else if (focused) {
        return {
          borderColor: brand ? "interaction.inverse.blend.05" : "interaction.blend.05"
        };
      }
      return {};
    };
    const getBackgroundColor = () => {
      if (disabled) {
        return brand ? "neutral.inverse.on.brand.30" : "interaction.inverse.blend.07";
      }
      return brand ? "interaction.accent.01" : "neutral.00";
    };
    return __spreadValues$A({
      "::before": __spreadValues$A({
        backgroundColor: brand ? "interaction.inverse.blend.03" : "interaction.blend.02",
        borderColor: "transparent",
        borderRadius: "circle",
        borderStyle: "solid",
        borderWidth: "thin",
        content: hovered || focused ? "''" : void 0,
        height: 40,
        left: "calc(50% - 22px)",
        position: "absolute",
        top: "calc(50% - 22px)",
        width: 40,
        zIndex: -1
      }, getStatusStyle()),
      backgroundColor: getBackgroundColor(),
      borderRadius: "circle",
      bottom: "inset.quark",
      boxShadow: "01",
      height: 16,
      pointerEvents: "none",
      position: "absolute",
      top: "inset.quark",
      width: 16
    }, getPositionStyle());
  };

  var __defProp$z = Object.defineProperty;
  var __defProps$n = Object.defineProperties;
  var __getOwnPropDescs$n = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
  var __hasOwnProp$z = Object.prototype.hasOwnProperty;
  var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$z = (obj, key, value) => key in obj ? __defProp$z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$z = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$z.call(b, prop))
        __defNormalProp$z(a, prop, b[prop]);
    if (__getOwnPropSymbols$z)
      for (var prop of __getOwnPropSymbols$z(b)) {
        if (__propIsEnum$z.call(b, prop))
          __defNormalProp$z(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$n = (a, b) => __defProps$n(a, __getOwnPropDescs$n(b));
  var __objRest$r = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$z.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$z)
      for (var prop of __getOwnPropSymbols$z(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$z.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Switch = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, checked, defaultChecked, disabled = false, id, label = "", onChange, onBlur, onFocus, sx } = _b, props = __objRest$r(_b, ["brand", "checked", "defaultChecked", "disabled", "id", "label", "onChange", "onBlur", "onFocus", "sx"]);
    const [hovered, setHovered] = React__default["default"].useState(false);
    const [focused, setFocused] = React__default["default"].useState(false);
    const [active, setActive] = React__default["default"].useState(false);
    const getControlledCheckedInitial = () => {
      if (typeof defaultChecked === "boolean") {
        return defaultChecked;
      } else if (typeof checked === "boolean") {
        return checked;
      }
      return false;
    };
    const [controlledChecked, setControlledChecked] = React__default["default"].useState(getControlledCheckedInitial());
    React__default["default"].useEffect(() => {
      if (typeof checked === "boolean" && checked !== controlledChecked) {
        setControlledChecked(checked);
      }
    }, [checked, controlledChecked]);
    return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, {
      htmlFor: id,
      onMouseDown: () => !disabled && setActive(true),
      onMouseEnter: () => !disabled && setHovered(true),
      onMouseLeave: () => !disabled && setHovered(false),
      onMouseUp: () => !disabled && setActive(false),
      sx: __spreadValues$z({ display: "flex" }, sx),
      tabIndex: -1
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { height: 24, position: "relative", width: 48 }
    }, /* @__PURE__ */ React__default["default"].createElement(themeUi.Input, __spreadProps$n(__spreadValues$z({}, props), {
      "aria-checked": !!checked,
      "aria-readonly": disabled,
      checked,
      defaultChecked,
      disabled,
      id,
      onBlur: (evt) => {
        if (onBlur) {
          onBlur(evt);
        }
        !disabled && setFocused(false);
      },
      onChange: (evt) => {
        if (onChange) {
          onChange(evt);
        }
        setControlledChecked(evt.target.checked);
      },
      onFocus: (evt) => {
        if (onFocus) {
          onFocus(evt);
        }
        !disabled && setFocused(true);
      },
      ref,
      role: "switch",
      sx: getCheckboxStyle(brand, controlledChecked, disabled),
      tabIndex: 0,
      type: "checkbox"
    })), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: getSliderStyle(brand, controlledChecked, hovered, focused, active, disabled)
    })), /* @__PURE__ */ React__default["default"].createElement(Body, {
      brand,
      sx: getLabelStyle(brand, disabled),
      variant: "lg"
    }, label));
  });

  function objectFilter(object, fn) {
    const result = {};
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const shouldPass = fn(value, key, object);
      if (shouldPass) {
        result[key] = value;
      }
    });
    return result;
  }
  const filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);

  const StyledGrid = styled__default["default"](themeUi.Grid)`
    ${GRID}
    ${COMMON}
`;
  const getGridStyle = () => ({
    height: "100%",
    position: "relative",
    width: "100%"
  });
  const getSpan = (value) => mapResponsive(value, (prop) => prop === "auto" ? "auto" : `span ${prop}/span ${prop}`);
  const getGridItemStyle = (props) => filterUndefined({
    gridColumn: getSpan(props.colSpan),
    gridColumnEnd: props.colEnd,
    gridColumnStart: props.colStart,
    gridRow: getSpan(props.rowSpan),
    gridRowEnd: props.rowEnd,
    gridRowStart: props.rowStart
  });

  var __defProp$y = Object.defineProperty;
  var __defProps$m = Object.defineProperties;
  var __getOwnPropDescs$m = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
  var __hasOwnProp$y = Object.prototype.hasOwnProperty;
  var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$y = (obj, key, value) => key in obj ? __defProp$y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$y = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$y.call(b, prop))
        __defNormalProp$y(a, prop, b[prop]);
    if (__getOwnPropSymbols$y)
      for (var prop of __getOwnPropSymbols$y(b)) {
        if (__propIsEnum$y.call(b, prop))
          __defNormalProp$y(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$m = (a, b) => __defProps$m(a, __getOwnPropDescs$m(b));
  var __objRest$q = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$y.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$y)
      for (var prop of __getOwnPropSymbols$y(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$y.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Grid = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { children } = _b, props = __objRest$q(_b, ["children"]);
    return /* @__PURE__ */ React__default["default"].createElement(StyledGrid, __spreadProps$m(__spreadValues$y({
      columns: [6, 8, 8, 12],
      gap: ["inline.nano", "inline.xxxs", "inline.xxs", "inline.xxs"],
      paddingX: ["inline.xxxs", "inline.xxxs", "inline.xxs", "inline.xxs"]
    }, props), {
      ref,
      sx: __spreadValues$y(__spreadValues$y({}, getGridStyle()), props.sx)
    }), children);
  });
  const GridItem = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { colSpan, rowSpan, colStart, colEnd, rowStart, rowEnd, children } = _d, props = __objRest$q(_d, ["colSpan", "rowSpan", "colStart", "colEnd", "rowStart", "rowEnd", "children"]);
    return /* @__PURE__ */ React__default["default"].createElement(StyledGrid, __spreadProps$m(__spreadValues$y({}, props), {
      ref,
      sx: __spreadValues$y(__spreadValues$y({}, getGridItemStyle({ colEnd, colSpan, colStart, rowEnd, rowSpan, rowStart })), props.sx)
    }), children);
  });

  const getBreadcrumbStyle = (onClick) => ({
    cursor: onClick ? "pointer" : "default",
    margin: 0,
    padding: "inset.quark"
  });

  var __defProp$x = Object.defineProperty;
  var __defProps$l = Object.defineProperties;
  var __getOwnPropDescs$l = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
  var __hasOwnProp$x = Object.prototype.hasOwnProperty;
  var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$x = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$x.call(b, prop))
        __defNormalProp$x(a, prop, b[prop]);
    if (__getOwnPropSymbols$x)
      for (var prop of __getOwnPropSymbols$x(b)) {
        if (__propIsEnum$x.call(b, prop))
          __defNormalProp$x(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$l = (a, b) => __defProps$l(a, __getOwnPropDescs$l(b));
  var __objRest$p = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$x.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$x)
      for (var prop of __getOwnPropSymbols$x(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$x.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Breadcrumb = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, index, isCurrentIndex, label, handleClick, sx } = _b, props = __objRest$p(_b, ["brand", "index", "isCurrentIndex", "label", "handleClick", "sx"]);
    const setActive = () => {
      handleClick && handleClick(index);
    };
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$l(__spreadValues$x({}, props), {
      onClick: (e) => {
        setActive();
        if (props.onClick) {
          props.onClick(e);
        }
      },
      sx: __spreadValues$x(__spreadValues$x({}, getBreadcrumbStyle(!!handleClick)), sx)
    }), /* @__PURE__ */ React__default["default"].createElement(LinkStandalone, {
      "aria-current": isCurrentIndex,
      "aria-label": label,
      brand,
      label,
      ref,
      variant: "sm"
    }));
  });
  const BreadcrumbContainer = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { activeIndex, brand, children } = _d, props = __objRest$p(_d, ["activeIndex", "brand", "children"]);
    const renderChildrens = () => {
      if (Array.isArray(children)) {
        const renderSeparator = (canRender, idx) => canRender && /* @__PURE__ */ React__default["default"].createElement(Box, {
          height: 16,
          key: `${idx}-s`,
          ml: "inline.nano",
          mr: "inline.nano"
        }, /* @__PURE__ */ React__default["default"].createElement(Divider, {
          brand,
          variant: "vertical"
        }));
        return children.map((ChildrenItem, idx) => {
          if (idx > activeIndex) {
            return null;
          }
          return [renderSeparator(idx > 0, idx), ChildrenItem];
        });
      }
      return children;
    };
    return /* @__PURE__ */ React__default["default"].createElement(Flex, __spreadProps$l(__spreadValues$x({
      alignItems: "center",
      justifyContent: "center",
      tabIndex: 0
    }, props), {
      ref
    }), renderChildrens());
  });

  var __defProp$w = Object.defineProperty;
  var __defProps$k = Object.defineProperties;
  var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
  var __hasOwnProp$w = Object.prototype.hasOwnProperty;
  var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$w = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$w.call(b, prop))
        __defNormalProp$w(a, prop, b[prop]);
    if (__getOwnPropSymbols$w)
      for (var prop of __getOwnPropSymbols$w(b)) {
        if (__propIsEnum$w.call(b, prop))
          __defNormalProp$w(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$k = (a, b) => __defProps$k(a, __getOwnPropDescs$k(b));
  var __objRest$o = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$w)
      for (var prop of __getOwnPropSymbols$w(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const PaginationArrow = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { arrowWay = "left", brand, disabled } = _b, props = __objRest$o(_b, ["arrowWay", "brand", "disabled"]);
    const getIconColor = () => {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }
      return brand ? "interaction.on.brand.select.default" : "interaction.select.default";
    };
    return /* @__PURE__ */ React__default["default"].createElement(Flex, {
      alignItems: "center",
      as: "li"
    }, /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, __spreadProps$k(__spreadValues$w({
      brand,
      color: getIconColor(),
      disabled,
      leadingIcon: arrowWay === "left" ? /* @__PURE__ */ React__default["default"].createElement(almaIcons.ChevronLeftSm, null) : /* @__PURE__ */ React__default["default"].createElement(almaIcons.ChevronRightSm, null),
      size: "sm"
    }, props), {
      ref
    })));
  });

  const getValueColor = (brand, selected, disabled) => {
    if (disabled) {
      return brand ? "typeface.on.brand.meld" : "typeface.meld";
    }
    if (selected) {
      return brand ? "interaction.select.active" : "interaction.on.brand.select.active";
    }
    return brand ? "interaction.on.brand.select.default" : "interaction.select.default";
  };
  const getTextStyle$1 = (brand, selected, disabled) => {
    const getColorOnInteraction = () => {
      if (!selected) {
        return brand ? "interaction.inverse.blend.08" : "interaction.select.focus";
      }
      return "";
    };
    return {
      "&:focus, &:hover": {
        color: getColorOnInteraction()
      },
      color: getValueColor(brand, selected, disabled)
    };
  };

  var __defProp$v = Object.defineProperty;
  var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
  var __hasOwnProp$v = Object.prototype.hasOwnProperty;
  var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$v = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$v.call(b, prop))
        __defNormalProp$v(a, prop, b[prop]);
    if (__getOwnPropSymbols$v)
      for (var prop of __getOwnPropSymbols$v(b)) {
        if (__propIsEnum$v.call(b, prop))
          __defNormalProp$v(a, prop, b[prop]);
      }
    return a;
  };
  const PaginationItem = React__default["default"].forwardRef((props, ref) => {
    const { selected = false, brand, disabled, value } = props;
    const getBackgroundColor = () => {
      if (selected) {
        return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
      }
      return "transparent";
    };
    const getHoverBackgroundColor = () => {
      if (!selected) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }
      return getBackgroundColor();
    };
    return /* @__PURE__ */ React__default["default"].createElement(Flex, {
      alignItems: "center",
      as: "li"
    }, /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, __spreadValues$v({
      "aria-current": selected,
      "aria-label": selected ? `Current Page, Page ${value}` : `Goto Page ${value}`,
      disabled,
      ref,
      size: "sm",
      sx: {
        "&": {
          bg: getBackgroundColor()
        },
        "&:hover:enabled:not(:active), &:active:enabled, &:focus:enabled:not(:active)": {
          bg: getHoverBackgroundColor()
        }
      }
    }, props), /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      sx: getTextStyle$1(brand, selected, disabled)
    }, value)));
  });

  var __defProp$u = Object.defineProperty;
  var __defProps$j = Object.defineProperties;
  var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
  var __hasOwnProp$u = Object.prototype.hasOwnProperty;
  var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$u = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$u.call(b, prop))
        __defNormalProp$u(a, prop, b[prop]);
    if (__getOwnPropSymbols$u)
      for (var prop of __getOwnPropSymbols$u(b)) {
        if (__propIsEnum$u.call(b, prop))
          __defNormalProp$u(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$j = (a, b) => __defProps$j(a, __getOwnPropDescs$j(b));
  var __objRest$n = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$u.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$u)
      for (var prop of __getOwnPropSymbols$u(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$u.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Pagination = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { disabled, boundaryCount = 1, brand, count = 1, page, onChange, siblingCount = 1 } = _b, props = __objRest$n(_b, ["disabled", "boundaryCount", "brand", "count", "page", "onChange", "siblingCount"]);
    const commonProps = {
      brand,
      disabled
    };
    const [selectedPage, setSelectedPage] = React.useState(0);
    React__default["default"].useEffect(() => {
      if (page) {
        setSelectedPage(page - 1);
      }
    }, [page]);
    const handleSelectedPage = (idx) => {
      setSelectedPage(idx);
      if (onChange) {
        onChange(idx);
      }
    };
    const handleArrowClick = (arrowWay) => {
      if (arrowWay === "left") {
        if (selectedPage === 0) {
          return;
        }
        setSelectedPage(selectedPage - 1);
        if (onChange) {
          onChange(selectedPage - 1);
        }
      } else {
        if (selectedPage === count - 1) {
          return;
        }
        setSelectedPage(selectedPage + 1);
        if (onChange) {
          onChange(selectedPage + 1);
        }
      }
    };
    const renderItems = () => {
      const itemsArray = [];
      const pushItem = (idx, isGap) => {
        if (isGap) {
          return itemsArray.push(/* @__PURE__ */ React__default["default"].createElement(Flex, {
            alignItems: "center",
            "aria-hidden": "true",
            as: "li",
            color: getValueColor(brand, false, false),
            height: 32,
            justifyContent: "center",
            key: idx,
            width: 32
          }, "..."));
        }
        return itemsArray.push(/* @__PURE__ */ React__default["default"].createElement(PaginationItem, __spreadValues$u({
          key: idx,
          onClick: () => handleSelectedPage(idx),
          selected: selectedPage === idx,
          value: idx + 1
        }, commonProps)));
      };
      for (let idx = 0; idx < count; idx++) {
        const isSibling = idx >= selectedPage - siblingCount && idx <= selectedPage + siblingCount;
        const isBoundary = idx <= boundaryCount - 1 || idx >= count - boundaryCount;
        if (siblingCount > 0) {
          if (isSibling || isBoundary) {
            pushItem(idx, false);
            continue;
          } else if (idx >= selectedPage - (siblingCount + 1) && idx <= selectedPage + (siblingCount + 1)) {
            pushItem(idx, true);
            continue;
          } else {
            continue;
          }
        } else {
          if (selectedPage === idx || isBoundary) {
            pushItem(idx, false);
            continue;
          } else if (idx >= selectedPage - (siblingCount + 1) && idx <= selectedPage + (siblingCount + 1)) {
            pushItem(idx, true);
            continue;
          }
        }
      }
      return itemsArray;
    };
    const currentPage = selectedPage + 1;
    return /* @__PURE__ */ React__default["default"].createElement(Flex, __spreadValues$u({
      alignItems: "center",
      "aria-label": "Pagination Navigation",
      as: "nav",
      role: "navigation"
    }, props), /* @__PURE__ */ React__default["default"].createElement(Flex, {
      alignItems: "center",
      as: "ul"
    }, /* @__PURE__ */ React__default["default"].createElement(PaginationArrow, __spreadProps$j(__spreadValues$u({
      "aria-label": "Previous page",
      arrowWay: "left",
      id: "pagination-arrow-left-id",
      onClick: () => handleArrowClick("left")
    }, commonProps), {
      disabled: currentPage === 1
    })), renderItems(), /* @__PURE__ */ React__default["default"].createElement(PaginationArrow, __spreadProps$j(__spreadValues$u({
      "aria-label": "Next page",
      arrowWay: "right",
      id: "pagination-arrow-right-id",
      onClick: () => handleArrowClick("right")
    }, commonProps), {
      disabled: currentPage === count
    }))));
  });

  const getStepperStyle = (active, brand) => {
    const getBackgroundColor = () => {
      if (active) {
        return brand ? "interaction.on.brand.accent.01" : "interaction.accent.01";
      }
      return brand ? "interaction.on.brand.blend.06" : "interaction.blend.06";
    };
    return {
      backgroundColor: getBackgroundColor(),
      borderRadius: active ? "pill" : "circle",
      cursor: active ? "default" : "pointer",
      height: 8,
      transition: "width 0.2s ease-in, border-radius 0.2s ease-in",
      width: active ? 24 : 8
    };
  };

  var __defProp$t = Object.defineProperty;
  var __defProps$i = Object.defineProperties;
  var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
  var __hasOwnProp$t = Object.prototype.hasOwnProperty;
  var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$t = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$t.call(b, prop))
        __defNormalProp$t(a, prop, b[prop]);
    if (__getOwnPropSymbols$t)
      for (var prop of __getOwnPropSymbols$t(b)) {
        if (__propIsEnum$t.call(b, prop))
          __defNormalProp$t(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$i = (a, b) => __defProps$i(a, __getOwnPropDescs$i(b));
  var __objRest$m = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$t)
      for (var prop of __getOwnPropSymbols$t(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Stepper = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { active, brand, index, sx } = _b, props = __objRest$m(_b, ["active", "brand", "index", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$i(__spreadValues$t({}, props), {
      "aria-expanded": active,
      ref,
      sx: __spreadValues$t({ cursor: active ? "default" : "pointer", padding: "inline.quark" }, sx)
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: __spreadValues$t(__spreadValues$t({}, getStepperStyle(active, brand)), sx)
    }));
  });
  const StepperContainer = React__default["default"].forwardRef(({ children }, ref) => /* @__PURE__ */ React__default["default"].createElement(Flex, {
    alignItems: "center",
    justifyContent: "center",
    ref
  }, children));

  const getOverlayStyle = (variant, zIndex) => ({
    backgroundColor: "interaction.blend.05",
    height: variant === "screen" ? "100vh" : "100%",
    left: 0,
    position: variant === "screen" ? "fixed" : "absolute",
    top: 0,
    width: variant === "screen" ? "100vw" : "100%",
    zIndex
  });

  var __defProp$s = Object.defineProperty;
  var __defProps$h = Object.defineProperties;
  var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
  var __hasOwnProp$s = Object.prototype.hasOwnProperty;
  var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$s = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$s.call(b, prop))
        __defNormalProp$s(a, prop, b[prop]);
    if (__getOwnPropSymbols$s)
      for (var prop of __getOwnPropSymbols$s(b)) {
        if (__propIsEnum$s.call(b, prop))
          __defNormalProp$s(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$h = (a, b) => __defProps$h(a, __getOwnPropDescs$h(b));
  var __objRest$l = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$s)
      for (var prop of __getOwnPropSymbols$s(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Overlay = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant = "screen", zIndex = 1 } = _b, props = __objRest$l(_b, ["variant", "zIndex"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$h(__spreadValues$s({}, props), {
      ref,
      sx: __spreadValues$s(__spreadValues$s({}, getOverlayStyle(variant, zIndex)), props.sx)
    }));
  });

  const getBasicChipStyle = (variant) => ({
    alignItems: "center",
    borderRadius: "pill",
    borderStyle: "solid",
    cursor: "pointer",
    display: "flex",
    height: variant === "lg" ? 32 : 24,
    paddingLeft: "inline.nano",
    position: "relative",
    width: "max-content"
  });
  const getChipTextStyle = (staticText) => ({
    color: "inherit",
    paddingBottom: staticText ? "inline.quark" : "stack.nano",
    paddingLeft: staticText ? void 0 : "inline.quark",
    paddingRight: staticText ? void 0 : "inline.quark",
    paddingTop: staticText ? "inline.quark" : "stack.nano"
  });

  var __defProp$r = Object.defineProperty;
  var __defProps$g = Object.defineProperties;
  var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
  var __hasOwnProp$r = Object.prototype.hasOwnProperty;
  var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$r = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$r.call(b, prop))
        __defNormalProp$r(a, prop, b[prop]);
    if (__getOwnPropSymbols$r)
      for (var prop of __getOwnPropSymbols$r(b)) {
        if (__propIsEnum$r.call(b, prop))
          __defNormalProp$r(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$g = (a, b) => __defProps$g(a, __getOwnPropDescs$g(b));
  const getChipInputContainerStyle = (props) => {
    const getBackgroundColor = () => {
      if (props.disabled) {
        return props.brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      } else if (props.active) {
        return props.brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (props.hover || props.focus) {
        return props.brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }
      return props.brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
    };
    const getColor = () => {
      if (props.disabled) {
        return props.brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (props.hover || props.focus || props.trailingFocus) {
        return props.brand ? "typeface.on.brand.strong" : "typeface.strong";
      }
      return props.brand ? "typeface.on.brand.pure" : "typeface.pure";
    };
    return __spreadProps$g(__spreadValues$r({}, getBasicChipStyle(props.variant)), {
      backgroundColor: getBackgroundColor(),
      borderColor: props.brand ? "interaction.on.brand.select.focus" : "interaction.select.focus",
      borderWidth: props.focus ? "thin" : void 0,
      color: getColor(),
      paddingRight: props.variant === "lg" ? 32 : 24,
      pointerEvents: props.disabled ? "none" : void 0
    });
  };
  const getChipTrailingStyle = (brand, variant, hover, focus, active, disabled) => {
    const getBackgroundColor = () => {
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }
      return "transparent";
    };
    const getBorderColor = () => {
      if (focus) {
        return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
      }
      return "transparent";
    };
    return {
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderRadius: "circle",
      borderStyle: "solid",
      borderWidth: "thin",
      height: variant === "lg" ? 32 : 24,
      margin: 0,
      pointerEvents: disabled ? "none" : void 0,
      position: "absolute",
      right: 0,
      top: 0,
      width: variant === "lg" ? 32 : 24
    };
  };

  var __defProp$q = Object.defineProperty;
  var __defProps$f = Object.defineProperties;
  var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
  var __hasOwnProp$q = Object.prototype.hasOwnProperty;
  var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$q = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$q.call(b, prop))
        __defNormalProp$q(a, prop, b[prop]);
    if (__getOwnPropSymbols$q)
      for (var prop of __getOwnPropSymbols$q(b)) {
        if (__propIsEnum$q.call(b, prop))
          __defNormalProp$q(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$f = (a, b) => __defProps$f(a, __getOwnPropDescs$f(b));
  var __objRest$k = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$q.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$q)
      for (var prop of __getOwnPropSymbols$q(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$q.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const ChipInput = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, children, closeProps, disabled, leadingIcon, label = "", onClose, variant = "lg" } = _b, props = __objRest$k(_b, ["brand", "children", "closeProps", "disabled", "leadingIcon", "label", "onClose", "variant"]);
    const [containerHover, setContainerHover] = React.useState(false);
    const [trailingHover, setTrailingHover] = React.useState(false);
    const [containerFocus, setContainerFocus] = React.useState(false);
    const [trailingFocus, setTrailingFocus] = React.useState(false);
    const [containerActive, setContainerActive] = React.useState(false);
    const [trailingActive, setTrailingActive] = React.useState(false);
    const getIconColor = () => {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      } else if (containerHover || containerFocus) {
        return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
      }
      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };
    return /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { position: "relative" }
    }, /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$f(__spreadValues$q({
      "aria-label": `Deletar ${label}`,
      role: "button",
      tabIndex: 0
    }, props), {
      onBlur: (evt) => {
        !disabled && setContainerFocus(false);
        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onFocus: (evt) => {
        if (!disabled && !trailingFocus && !trailingActive && !containerActive) {
          setContainerFocus(true);
        }
        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: (evt) => {
        if (!disabled && !trailingActive) {
          setContainerActive(true);
        }
        if (props.onMouseDown) {
          props.onMouseDown(evt);
        }
      },
      onMouseEnter: (evt) => {
        !disabled && setContainerHover(true);
        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: (evt) => {
        !disabled && setContainerHover(false);
        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: (evt) => {
        if (!disabled) {
          setContainerFocus(false);
          setTrailingFocus(false);
          setContainerActive(false);
        }
        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref,
      sx: __spreadValues$q(__spreadValues$q({}, getChipInputContainerStyle({
        active: containerActive && !trailingActive,
        brand,
        disabled,
        focus: containerFocus && !trailingFocus,
        hover: containerHover && !trailingHover,
        trailingFocus,
        variant
      })), props.sx)
    }), children ? children : /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, leadingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: getIconColor(),
      size: variant === "lg" ? "md" : "xs",
      sx: { margin: 0, marginBottom: "stack.quark", marginTop: "stack.quark", padding: 0 }
    }, leadingIcon), /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      sx: getChipTextStyle(),
      variant: variant === "lg" ? "md" : "sm"
    }, label))), /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, __spreadProps$f(__spreadValues$q({
      color: getIconColor(),
      disabled,
      id: "chip-input-close",
      leadingIcon: /* @__PURE__ */ React__default["default"].createElement(almaIcons.Close, null),
      leadingIconSize: variant === "lg" ? "md" : "xs",
      size: variant,
      tabIndex: 0,
      type: "button"
    }, closeProps), {
      onBlur: (evt) => {
        !disabled && setTrailingFocus(false);
        if (closeProps == null ? void 0 : closeProps.onBlur) {
          closeProps.onBlur(evt);
        }
      },
      onClick: (evt) => {
        if (!disabled && onClose) {
          onClose(evt);
        }
        if (closeProps == null ? void 0 : closeProps.onClick) {
          closeProps.onClick(evt);
        }
      },
      onFocus: (evt) => {
        if (!disabled && !trailingActive) {
          setContainerFocus(false);
          setTrailingFocus(true);
        }
        if (closeProps == null ? void 0 : closeProps.onFocus) {
          closeProps.onFocus(evt);
        }
      },
      onMouseDown: (evt) => {
        !disabled && setTrailingActive(true);
        if (closeProps == null ? void 0 : closeProps.onMouseDown) {
          closeProps.onMouseDown(evt);
        }
      },
      onMouseEnter: (evt) => {
        !disabled && setTrailingHover(true);
        if (closeProps == null ? void 0 : closeProps.onMouseEnter) {
          closeProps.onMouseEnter(evt);
        }
      },
      onMouseLeave: (evt) => {
        !disabled && setTrailingHover(false);
        if (closeProps == null ? void 0 : closeProps.onMouseLeave) {
          closeProps.onMouseLeave(evt);
        }
      },
      onMouseUp: (evt) => {
        if (!disabled) {
          setContainerFocus(false);
          setTrailingFocus(false);
          setTrailingActive(false);
        }
        if (closeProps == null ? void 0 : closeProps.onMouseUp) {
          closeProps.onMouseUp(evt);
        }
      },
      sx: __spreadValues$q(__spreadValues$q({}, getChipTrailingStyle(brand, variant, trailingHover, trailingFocus, trailingActive, disabled)), closeProps == null ? void 0 : closeProps.sx)
    })));
  });

  var __defProp$p = Object.defineProperty;
  var __defProps$e = Object.defineProperties;
  var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
  var __hasOwnProp$p = Object.prototype.hasOwnProperty;
  var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$p = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$p.call(b, prop))
        __defNormalProp$p(a, prop, b[prop]);
    if (__getOwnPropSymbols$p)
      for (var prop of __getOwnPropSymbols$p(b)) {
        if (__propIsEnum$p.call(b, prop))
          __defNormalProp$p(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
  const getChipToggleStyle = ({
    active,
    brand,
    disabled,
    focus,
    hover,
    selected,
    variant
  }) => {
    const getBackgroundColor = () => {
      if (selected) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
        } else if (active) {
          return brand ? "interaction.on.brand.subtle.03" : "interaction.subtle.03";
        } else if (hover || focus) {
          return brand ? "interaction.on.brand.subtle.02" : "interaction.subtle.02";
        }
        return brand ? "interaction.on.brand.subtle.01" : "interaction.subtle.01";
      }
      if (active) {
        return brand ? "interaction.on.brand.blend.03" : "interaction.blend.03";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      }
      return "transparent";
    };
    const getBorderColor = () => {
      if (selected) {
        if (disabled) {
          return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
        }
        return brand ? "interaction.on.brand.select.active" : "interaction.select.active";
      } else if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }
      return brand ? "interaction.on.brand.select.default" : "interaction.select.default";
    };
    const getColor = () => {
      if (selected) {
        if (disabled) {
          return brand ? "typeface.on.brand.meld" : "typeface.meld";
        }
        return brand ? "interaction.on.brand.select.default" : "interaction.select.active";
      } else if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (hover || focus) {
        return brand ? "typeface.on.brand.strong" : "typeface.strong";
      }
      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };
    return __spreadProps$e(__spreadValues$p({}, getBasicChipStyle(variant)), {
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderWidth: focus ? "thin" : "hairline",
      color: getColor(),
      cursor: disabled ? "default" : "pointer",
      paddingRight: "inline.nano"
    });
  };

  var __defProp$o = Object.defineProperty;
  var __defProps$d = Object.defineProperties;
  var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
  var __hasOwnProp$o = Object.prototype.hasOwnProperty;
  var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$o = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$o.call(b, prop))
        __defNormalProp$o(a, prop, b[prop]);
    if (__getOwnPropSymbols$o)
      for (var prop of __getOwnPropSymbols$o(b)) {
        if (__propIsEnum$o.call(b, prop))
          __defNormalProp$o(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
  var __objRest$j = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$o)
      for (var prop of __getOwnPropSymbols$o(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const ChipToggle = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, children, disabled, label = "", selected, sx, variant = "lg", onClick } = _b, props = __objRest$j(_b, ["brand", "children", "disabled", "label", "selected", "sx", "variant", "onClick"]);
    const [hover, setHover] = React.useState(false);
    const [focus, setFocus] = React.useState(false);
    const [active, setActive] = React.useState(false);
    const getIconColor = () => {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.08" : "interaction.blend.08";
      }
      return brand ? "interaction.on.brand.select.default" : "interaction.select.active";
    };
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$d(__spreadValues$o({
      "aria-disabled": disabled,
      "aria-label": label,
      onClick: (e) => !disabled && onClick && onClick(e),
      role: "button",
      tabIndex: 0
    }, props), {
      onBlur: (evt) => {
        !disabled && setFocus(false);
        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onFocus: (evt) => {
        if (!active) {
          !disabled && setFocus(true);
        }
        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: (evt) => {
        !disabled && setActive(true);
        if (props.onMouseDown) {
          props.onMouseDown(evt);
        }
      },
      onMouseEnter: (evt) => {
        !disabled && setHover(true);
        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: (evt) => {
        !disabled && setHover(false);
        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: (evt) => {
        !disabled && setFocus(false);
        !disabled && setActive(false);
        if (props.onMouseUp) {
          props.onMouseUp(evt);
        }
      },
      ref,
      sx: __spreadValues$o(__spreadValues$o({}, getChipToggleStyle({ active, brand, disabled, focus, hover, selected, variant })), sx)
    }), children ? children : /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, selected && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: getIconColor(),
      id: "chip-toggle-id",
      size: variant === "lg" ? "md" : "xs",
      sx: { margin: 0, marginBottom: "stack.quark", marginTop: "stack.quark", padding: 0 }
    }, /* @__PURE__ */ React__default["default"].createElement(almaIcons.Check, null)), /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      sx: getChipTextStyle(),
      variant: variant === "lg" ? "md" : "sm"
    }, label)));
  });

  var __defProp$n = Object.defineProperty;
  var __defProps$c = Object.defineProperties;
  var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
  var __hasOwnProp$n = Object.prototype.hasOwnProperty;
  var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$n = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$n.call(b, prop))
        __defNormalProp$n(a, prop, b[prop]);
    if (__getOwnPropSymbols$n)
      for (var prop of __getOwnPropSymbols$n(b)) {
        if (__propIsEnum$n.call(b, prop))
          __defNormalProp$n(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
  const getChipStaticStyle = (brand, disabled) => {
    const getBackgroundColor = () => {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      }
      return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
    };
    const getColor = () => {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }
      return brand ? "typeface.on.brand.pure" : "typeface.pure";
    };
    return __spreadProps$c(__spreadValues$n({}, getBasicChipStyle("sm")), {
      backgroundColor: getBackgroundColor(),
      color: getColor(),
      cursor: "default",
      paddingRight: "inline.nano"
    });
  };

  var __defProp$m = Object.defineProperty;
  var __defProps$b = Object.defineProperties;
  var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
  var __hasOwnProp$m = Object.prototype.hasOwnProperty;
  var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$m = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$m.call(b, prop))
        __defNormalProp$m(a, prop, b[prop]);
    if (__getOwnPropSymbols$m)
      for (var prop of __getOwnPropSymbols$m(b)) {
        if (__propIsEnum$m.call(b, prop))
          __defNormalProp$m(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
  var __objRest$i = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$m)
      for (var prop of __getOwnPropSymbols$m(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const ChipStatic = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, children, disabled, label = "", sx } = _b, props = __objRest$i(_b, ["brand", "children", "disabled", "label", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$b(__spreadValues$m({
      "aria-label": label,
      role: "button"
    }, props), {
      ref,
      sx: __spreadValues$m(__spreadValues$m({}, getChipStaticStyle(brand, disabled)), sx)
    }), children ? children : /* @__PURE__ */ React__default["default"].createElement(Caption, {
      sx: getChipTextStyle(true)
    }, label));
  });

  var __defProp$l = Object.defineProperty;
  var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
  var __hasOwnProp$l = Object.prototype.hasOwnProperty;
  var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$l = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$l.call(b, prop))
        __defNormalProp$l(a, prop, b[prop]);
    if (__getOwnPropSymbols$l)
      for (var prop of __getOwnPropSymbols$l(b)) {
        if (__propIsEnum$l.call(b, prop))
          __defNormalProp$l(a, prop, b[prop]);
      }
    return a;
  };
  const transitionParams = {
    transitionDuration: "0.3s",
    transitionTimingFunction: "ease-in"
  };
  const getAccordionContainerStyle = (brand, open, hover, focus, active) => {
    const getBackgroundColor = () => {
      if (active) {
        return brand ? "interaction.on.brand.blend.02" : "interaction.blend.02";
      } else if (hover || focus) {
        return brand ? "interaction.on.brand.blend.01" : "interaction.blend.01";
      }
      return "transparent";
    };
    const getBorderColor = () => {
      if (focus) {
        return brand ? "interaction.on.brand.select.focus" : "interaction.select.focus";
      }
      return "transparent";
    };
    return __spreadValues$l({
      backgroundColor: getBackgroundColor(),
      borderColor: getBorderColor(),
      borderStyle: "solid",
      borderWidth: "thin",
      overflow: "hidden",
      transitionProperty: "max-height"
    }, transitionParams);
  };
  const accordionLabelContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
    width: "100%"
  };
  const accordionLabelStyle = {
    paddingRight: "inline.nano",
    position: "relative"
  };
  const getAccordionTrailingIconStyle = (open) => __spreadValues$l({
    transform: open ? "rotate(180deg)" : "rotate(0)",
    transitionProperty: "transform"
  }, transitionParams);
  const getAccordionTextStyle = (open, leadingIcon) => __spreadValues$l({
    opacity: open ? 1 : 0,
    paddingLeft: leadingIcon ? "inline.xs" : void 0,
    paddingTop: "stack.nano",
    transitionProperty: "opacity, visibility",
    visibility: open ? "visible" : "hidden"
  }, transitionParams);

  var __defProp$k = Object.defineProperty;
  var __defProps$a = Object.defineProperties;
  var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
  var __hasOwnProp$k = Object.prototype.hasOwnProperty;
  var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$k = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$k.call(b, prop))
        __defNormalProp$k(a, prop, b[prop]);
    if (__getOwnPropSymbols$k)
      for (var prop of __getOwnPropSymbols$k(b)) {
        if (__propIsEnum$k.call(b, prop))
          __defNormalProp$k(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
  var __objRest$h = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$k)
      for (var prop of __getOwnPropSymbols$k(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Accordion = React__default["default"].memo(React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, disabled, label, leadingIcon, text, noOfLines } = _b, props = __objRest$h(_b, ["brand", "disabled", "label", "leadingIcon", "text", "noOfLines"]);
    const [open, setOpen] = React.useState(false);
    const [hover, setHover] = React.useState(false);
    const [focus, setFocus] = React.useState(false);
    const [active, setActive] = React.useState(false);
    const getLeadingIconColor = () => {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      } else if (hover || focus || active) {
        return brand ? "support.on.brand.02" : "support.02";
      }
      return brand ? "support.on.brand.01" : "support.01";
    };
    const getTrailingIconColor = () => {
      if (disabled) {
        return brand ? "interaction.on.brand.blend.04" : "interaction.blend.04";
      }
      return brand ? "interaction.on.brand.blend.07" : "interaction.blend.07";
    };
    const getLabelColor = () => {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }
      return brand ? "typeface.on.brand.strong" : "typeface.pure";
    };
    const getTextColor = () => {
      if (disabled) {
        return brand ? "typeface.on.brand.meld" : "typeface.meld";
      }
      return brand ? "typeface.on.brand.pure" : "typeface.smooth";
    };
    return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$a(__spreadValues$k({}, props), {
      "aria-disabled": disabled,
      "aria-expanded": open,
      onBlur: (evt) => {
        !disabled && setFocus(false);
        if (props.onBlur) {
          props.onBlur(evt);
        }
      },
      onClick: (evt) => {
        !disabled && setOpen(!open);
        if (props.onClick) {
          props.onClick(evt);
        }
      },
      onFocus: (evt) => {
        if (!active) {
          !disabled && setFocus(true);
        }
        if (props.onFocus) {
          props.onFocus(evt);
        }
      },
      onMouseDown: () => !disabled && setActive(true),
      onMouseEnter: (evt) => {
        !disabled && setHover(true);
        if (props.onMouseEnter) {
          props.onMouseEnter(evt);
        }
      },
      onMouseLeave: (evt) => {
        !disabled && setHover(false);
        if (props.onMouseLeave) {
          props.onMouseLeave(evt);
        }
      },
      onMouseUp: () => {
        !disabled && setFocus(false);
        !disabled && setActive(false);
      },
      ref,
      sx: __spreadValues$k({ cursor: disabled ? "default" : "pointer", position: "relative", width: "100%" }, props.sx)
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      p: "inset.xs",
      sx: getAccordionContainerStyle(brand, open, hover, focus, active),
      tabIndex: disabled ? -1 : 0
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: accordionLabelContainerStyle
    }, /* @__PURE__ */ React__default["default"].createElement(Center, {
      sx: { alignItems: "flex-start" }
    }, leadingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: getLeadingIconColor(),
      mr: "inline.nano",
      size: "md"
    }, leadingIcon), /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      color: getLabelColor(),
      noOfLines,
      sx: accordionLabelStyle,
      variant: "lg"
    }, label)), /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: getTrailingIconColor(),
      size: "md",
      sx: getAccordionTrailingIconStyle(open)
    }, /* @__PURE__ */ React__default["default"].createElement(almaIcons.ChevronDownSm, null))), /* @__PURE__ */ React__default["default"].createElement(Body, {
      color: getTextColor(),
      display: open ? "block" : "none",
      sx: getAccordionTextStyle(open, leadingIcon),
      variant: "sm"
    }, text))), /* @__PURE__ */ React__default["default"].createElement(Divider, {
      brand,
      variant: "horizontal"
    }));
  }));
  Accordion.displayName = "Accordion";
  styled__default$1["default"](Accordion);

  var __defProp$j = Object.defineProperty;
  var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
  var __hasOwnProp$j = Object.prototype.hasOwnProperty;
  var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$j = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$j.call(b, prop))
        __defNormalProp$j(a, prop, b[prop]);
    if (__getOwnPropSymbols$j)
      for (var prop of __getOwnPropSymbols$j(b)) {
        if (__propIsEnum$j.call(b, prop))
          __defNormalProp$j(a, prop, b[prop]);
      }
    return a;
  };
  const getBannerStyle = (variant, zIndex, open) => {
    const getPositionStyle = () => {
      if (variant === "top") {
        return {
          borderBottomColor: "interaction.blend.02",
          borderBottomWidth: "hairline",
          top: open ? 0 : -150
        };
      }
      return {
        borderTopColor: "interaction.blend.02",
        borderTopWidth: "hairline",
        bottom: open ? 0 : -150
      };
    };
    return __spreadValues$j({
      alignItems: "center",
      backgroundColor: "neutral.00",
      borderStyle: "solid",
      display: "flex",
      justifyContent: "space-between",
      left: 0,
      maxHeight: 128,
      minHeight: 64,
      paddingBottom: "stack.xxxs",
      paddingLeft: "inline.xxs",
      paddingRight: "inline.xxs",
      paddingTop: "stack.xxxs",
      position: "absolute",
      transition: "all 300ms ease-in-out",
      width: "100%",
      zIndex
    }, getPositionStyle());
  };
  const bannerMessageStyle = {
    maxHeight: `calc(128px - ${parseInt(defaultTheme$1.space.stack.xxxs, 10) * 2}px)`,
    overflow: "auto",
    paddingBottom: "stack.quark",
    paddingRight: "inline.xxxs",
    paddingTop: "stack.quark",
    position: "relative"
  };
  const bannerButtonsContainerStyle = {
    alignItems: "center",
    display: "flex",
    minWidth: "min-content"
  };

  var __defProp$i = Object.defineProperty;
  var __defProps$9 = Object.defineProperties;
  var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
  var __hasOwnProp$i = Object.prototype.hasOwnProperty;
  var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$i = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$i.call(b, prop))
        __defNormalProp$i(a, prop, b[prop]);
    if (__getOwnPropSymbols$i)
      for (var prop of __getOwnPropSymbols$i(b)) {
        if (__propIsEnum$i.call(b, prop))
          __defNormalProp$i(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
  var __objRest$g = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$i.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$i)
      for (var prop of __getOwnPropSymbols$i(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$i.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Banner = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { actionButton, children, onClose, open = false, sx, variant = "bottom", zIndex = 1 } = _b, props = __objRest$g(_b, ["actionButton", "children", "onClose", "open", "sx", "variant", "zIndex"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { height: "100%", overflow: "hidden", position: "relative", width: "100%" }
    }, /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$9(__spreadValues$i({
      sx: __spreadValues$i(__spreadValues$i({}, getBannerStyle(variant, zIndex, open)), sx)
    }, props), {
      ref,
      tabIndex: 0
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: bannerMessageStyle
    }, children), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: bannerButtonsContainerStyle
    }, actionButton && /* @__PURE__ */ React__default["default"].createElement(Button, {
      id: "banner-button-id",
      ml: "inline.nano",
      mr: "inline.nano",
      onClick: () => actionButton.onClick && actionButton.onClick(),
      size: "sm",
      variant: "primary"
    }, actionButton.label), /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
      leadingIcon: /* @__PURE__ */ React__default["default"].createElement(almaIcons.Close, null),
      onClick: () => onClose && onClose(),
      size: "sm"
    }))));
  });
  styled__default$1["default"](Banner);

  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }

    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }

    return node;
  }

  function isElement$1(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }

  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }

    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  }

  // and applies them to the HTMLElements such as popper and arrow

  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$2,
    requires: ['computeStyles']
  };

  function getBasePlacement$1(placement) {
    return placement.split('-')[0];
  }

  var max = Math.max;
  var min = Math.min;
  var round = Math.round;

  function getBoundingClientRect(element, includeScale) {
    if (includeScale === void 0) {
      includeScale = false;
    }

    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;

    if (isHTMLElement(element) && includeScale) {
      var offsetHeight = element.offsetHeight;
      var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
      // Fallback to 1 in case both values are `0`

      if (offsetWidth > 0) {
        scaleX = round(rect.width) / offsetWidth || 1;
      }

      if (offsetHeight > 0) {
        scaleY = round(rect.height) / offsetHeight || 1;
      }
    }

    return {
      width: rect.width / scaleX,
      height: rect.height / scaleY,
      top: rect.top / scaleY,
      right: rect.right / scaleX,
      bottom: rect.bottom / scaleY,
      left: rect.left / scaleX,
      x: rect.left / scaleX,
      y: rect.top / scaleY
    };
  }

  // means it doesn't take into account transforms.

  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }

    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }

    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
        var next = child;

        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe[prop-missing]: need a better way to handle this...


          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false


    return false;
  }

  function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || ( // DOM Element detected
      isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;

    if (isIE && isHTMLElement(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle(element);

      if (elementCss.position === 'fixed') {
        return null;
      }
    }

    var currentNode = getParentNode(element);

    while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }
  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement$1(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$1(_ref2) {
    var state = _ref2.state,
        options = _ref2.options;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    if (process.env.NODE_ENV !== "production") {
      if (!isHTMLElement(arrowElement)) {
        console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
      }
    }

    if (!contains(state.elements.popper, arrowElement)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
      }

      return;
    }

    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$1,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref) {
    var x = _ref.x,
        y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;

    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';

      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);

        if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


      offsetParent = offsetParent;

      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref4.x;
    y = _ref4.y;

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref5) {
    var state = _ref5.state,
        options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

    if (process.env.NODE_ENV !== "production") {
      var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

      if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
        return transitionProperty.indexOf(property) >= 0;
      })) {
        console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
      }
    }

    var commonStyles = {
      placement: getBasePlacement$1(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }

    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };

  var passive = {
    passive: true
  };

  function effect(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
  };

  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash = {
    start: 'end',
    end: 'start'
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
      // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
      // errors due to floating point numbers, so we need to check precision.
      // Safari returns a number <= 0, usually < -1 when pinch-zoomed
      // Feature detection fails in mobile emulation mode in Chrome.
      // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
      // 0.001
      // Fallback here: "Not Safari" userAgent

      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  }

  // of the `<html>` and `<body>` rect bounds if horizontally scrollable

  function getDocumentRect(element) {
    var _element$ownerDocumen;

    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle(body || html).direction === 'rtl') {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }

  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */

  function listScrollParents(element, list) {
    var _element$ownerDocumen;

    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

    if (!isElement$1(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement$1(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: 'absolute',
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });

    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;

      if (process.env.NODE_ENV !== "production") {
        console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
      }
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement$1(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement$1(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement$1(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement$1(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement$1(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: 'absolute',
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement$1(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis) {
      var _offsetModifierState$;

      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min$1 = offset + overflow[mainSide];
      var max$1 = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _offsetModifierState$2;

      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _len = altAxis === 'y' ? 'height' : 'width';

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.


  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce$1(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function format(str) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return [].concat(args).reduce(function (p, c) {
      return p.replace(/%s/, c);
    }, str);
  }

  var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
  var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
  var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
  function validateModifiers(modifiers) {
    modifiers.forEach(function (modifier) {
      [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
      .filter(function (value, index, self) {
        return self.indexOf(value) === index;
      }).forEach(function (key) {
        switch (key) {
          case 'name':
            if (typeof modifier.name !== 'string') {
              console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
            }

            break;

          case 'enabled':
            if (typeof modifier.enabled !== 'boolean') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
            }

            break;

          case 'phase':
            if (modifierPhases.indexOf(modifier.phase) < 0) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
            }

            break;

          case 'fn':
            if (typeof modifier.fn !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'effect':
            if (modifier.effect != null && typeof modifier.effect !== 'function') {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
            }

            break;

          case 'requires':
            if (modifier.requires != null && !Array.isArray(modifier.requires)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
            }

            break;

          case 'requiresIfExists':
            if (!Array.isArray(modifier.requiresIfExists)) {
              console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
            }

            break;

          case 'options':
          case 'data':
            break;

          default:
            console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
              return "\"" + s + "\"";
            }).join(', ') + "; but \"" + key + "\" was provided.");
        }

        modifier.requires && modifier.requires.forEach(function (requirement) {
          if (modifiers.find(function (mod) {
            return mod.name === requirement;
          }) == null) {
            console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
          }
        });
      });
    });
  }

  function uniqueBy(arr, fn) {
    var identifiers = new Set();
    return arr.filter(function (item) {
      var identifier = fn(item);

      if (!identifiers.has(identifier)) {
        identifiers.add(identifier);
        return true;
      }
    });
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
  var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          }); // Validate the provided modifiers so that the consumer will get warned
          // if one of the modifiers is invalid for any reason

          if (process.env.NODE_ENV !== "production") {
            var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
              var name = _ref.name;
              return name;
            });
            validateModifiers(modifiers);

            if (getBasePlacement$1(state.options.placement) === auto) {
              var flipModifier = state.orderedModifiers.find(function (_ref2) {
                var name = _ref2.name;
                return name === 'flip';
              });

              if (!flipModifier) {
                console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
              }
            }

            var _getComputedStyle = getComputedStyle(popper),
                marginTop = _getComputedStyle.marginTop,
                marginRight = _getComputedStyle.marginRight,
                marginBottom = _getComputedStyle.marginBottom,
                marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
            // cause bugs with positioning, so we'll warn the consumer


            if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
              return parseFloat(margin);
            })) {
              console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
            }
          }

          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            if (process.env.NODE_ENV !== "production") {
              console.error(INVALID_ELEMENT_ERROR);
            }

            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          var __debug_loops__ = 0;

          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (process.env.NODE_ENV !== "production") {
              __debug_loops__ += 1;

              if (__debug_loops__ > 100) {
                console.error(INFINITE_LOOP_ERROR);
                break;
              }
            }

            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce$1(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {
        if (process.env.NODE_ENV !== "production") {
          console.error(INVALID_ELEMENT_ERROR);
        }

        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref3) {
          var name = _ref3.name,
              _ref3$options = _ref3.options,
              options = _ref3$options === void 0 ? {} : _ref3$options,
              effect = _ref3.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  /**!
  * tippy.js v6.3.7
  * (c) 2017-2021 atomiks
  * MIT License
  */
  var BOX_CLASS = "tippy-box";
  var CONTENT_CLASS = "tippy-content";
  var BACKDROP_CLASS = "tippy-backdrop";
  var ARROW_CLASS = "tippy-arrow";
  var SVG_ARROW_CLASS = "tippy-svg-arrow";
  var TOUCH_OPTIONS = {
    passive: true,
    capture: true
  };
  var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
  };

  function hasOwnProperty(obj, key) {
    return {}.hasOwnProperty.call(obj, key);
  }
  function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
      var v = value[index];
      return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }

    return value;
  }
  function isType(value, type) {
    var str = {}.toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
  }
  function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
  }
  function debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) {
      return fn;
    }

    var timeout;
    return function (arg) {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn(arg);
      }, ms);
    };
  }
  function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function (key) {
      delete clone[key];
    });
    return clone;
  }
  function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
  }
  function normalizeToArray(value) {
    return [].concat(value);
  }
  function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) {
      arr.push(value);
    }
  }
  function unique(arr) {
    return arr.filter(function (item, index) {
      return arr.indexOf(item) === index;
    });
  }
  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }
  function arrayFrom(value) {
    return [].slice.call(value);
  }
  function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function (acc, key) {
      if (obj[key] !== undefined) {
        acc[key] = obj[key];
      }

      return acc;
    }, {});
  }

  function div() {
    return document.createElement('div');
  }
  function isElement(value) {
    return ['Element', 'Fragment'].some(function (type) {
      return isType(value, type);
    });
  }
  function isNodeList(value) {
    return isType(value, 'NodeList');
  }
  function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
  }
  function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
  }
  function getArrayOfElements(value) {
    if (isElement(value)) {
      return [value];
    }

    if (isNodeList(value)) {
      return arrayFrom(value);
    }

    if (Array.isArray(value)) {
      return value;
    }

    return arrayFrom(document.querySelectorAll(value));
  }
  function setTransitionDuration(els, value) {
    els.forEach(function (el) {
      if (el) {
        el.style.transitionDuration = value + "ms";
      }
    });
  }
  function setVisibilityState(els, state) {
    els.forEach(function (el) {
      if (el) {
        el.setAttribute('data-state', state);
      }
    });
  }
  function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;

    var _normalizeToArray = normalizeToArray(elementOrElements),
        element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
  }
  function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX,
        clientY = event.clientY;
    return popperTreeData.every(function (_ref) {
      var popperRect = _ref.popperRect,
          popperState = _ref.popperState,
          props = _ref.props;
      var interactiveBorder = props.interactiveBorder;
      var basePlacement = getBasePlacement(popperState.placement);
      var offsetData = popperState.modifiersData.offset;

      if (!offsetData) {
        return true;
      }

      var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
      var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
      var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
      var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
      var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
      var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
      var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
      var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
      return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
  }
  function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...

    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
      box[method](event, listener);
    });
  }
  /**
   * Compared to xxx.contains, this function works for dom structures with shadow
   * dom
   */

  function actualContains(parent, child) {
    var target = child;

    while (target) {
      var _target$getRootNode;

      if (parent.contains(target)) {
        return true;
      }

      target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }

    return false;
  }

  var currentInput = {
    isTouch: false
  };
  var lastMouseMoveTime = 0;
  /**
   * When a `touchstart` event is fired, it's assumed the user is using touch
   * input. We'll bind a `mousemove` event listener to listen for mouse input in
   * the future. This way, the `isTouch` property is fully dynamic and will handle
   * hybrid devices that use a mix of touch + mouse input.
   */

  function onDocumentTouchStart() {
    if (currentInput.isTouch) {
      return;
    }

    currentInput.isTouch = true;

    if (window.performance) {
      document.addEventListener('mousemove', onDocumentMouseMove);
    }
  }
  /**
   * When two `mousemove` event are fired consecutively within 20ms, it's assumed
   * the user is using mouse input again. `mousemove` can fire on touch devices as
   * well, but very rarely that quickly.
   */

  function onDocumentMouseMove() {
    var now = performance.now();

    if (now - lastMouseMoveTime < 20) {
      currentInput.isTouch = false;
      document.removeEventListener('mousemove', onDocumentMouseMove);
    }

    lastMouseMoveTime = now;
  }
  /**
   * When an element is in focus and has a tippy, leaving the tab/window and
   * returning causes it to show again. For mouse users this is unexpected, but
   * for keyboard use it makes sense.
   * TODO: find a better technique to solve this problem
   */

  function onWindowBlur() {
    var activeElement = document.activeElement;

    if (isReferenceElement(activeElement)) {
      var instance = activeElement._tippy;

      if (activeElement.blur && !instance.state.isVisible) {
        activeElement.blur();
      }
    }
  }
  function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
  }

  var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';
  var isIE11 = isBrowser$1 ? // @ts-ignore
  !!window.msCrypto : false;

  function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
  }
  function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
  }

  function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
  }

  function getFormattedMessage(message) {
    return [getDevMessage(message), // title
    'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
    'line-height: 1.5', // footer
    'color: #a6a095;'];
  } // Assume warnings and errors never have the same message

  var visitedMessages;

  if (process.env.NODE_ENV !== "production") {
    resetVisitedMessages();
  }

  function resetVisitedMessages() {
    visitedMessages = new Set();
  }
  function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console;

      visitedMessages.add(message);

      (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
  }
  function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
      var _console2;

      visitedMessages.add(message);

      (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
  }
  function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
    errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
  }

  var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
  };
  var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
  };
  var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
      content: 'auto',
      expanded: 'auto'
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [0, 10],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
  }, pluginProps, renderProps);
  var defaultKeys = Object.keys(defaultProps);
  var setDefaultProps = function setDefaultProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      validateProps(partialProps, []);
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (key) {
      defaultProps[key] = partialProps[key];
    });
  };
  function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function (acc, plugin) {
      var name = plugin.name,
          defaultValue = plugin.defaultValue;

      if (name) {
        var _name;

        acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
      }

      return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
  }
  function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
      plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function (acc, key) {
      var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

      if (!valueAsString) {
        return acc;
      }

      if (key === 'content') {
        acc[key] = valueAsString;
      } else {
        try {
          acc[key] = JSON.parse(valueAsString);
        } catch (e) {
          acc[key] = valueAsString;
        }
      }

      return acc;
    }, {});
    return props;
  }
  function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
      content: invokeWithArgsOrReturn(props.content, [reference])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, out.aria);
    out.aria = {
      expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
      content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
  }
  function validateProps(partialProps, plugins) {
    if (partialProps === void 0) {
      partialProps = {};
    }

    if (plugins === void 0) {
      plugins = [];
    }

    var keys = Object.keys(partialProps);
    keys.forEach(function (prop) {
      var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
      var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

      if (didPassUnknownProp) {
        didPassUnknownProp = plugins.filter(function (plugin) {
          return plugin.name === prop;
        }).length === 0;
      }

      warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
    });
  }

  var innerHTML = function innerHTML() {
    return 'innerHTML';
  };

  function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
  }

  function createArrowElement(value) {
    var arrow = div();

    if (value === true) {
      arrow.className = ARROW_CLASS;
    } else {
      arrow.className = SVG_ARROW_CLASS;

      if (isElement(value)) {
        arrow.appendChild(value);
      } else {
        dangerouslySetInnerHTML(arrow, value);
      }
    }

    return arrow;
  }

  function setContent(content, props) {
    if (isElement(props.content)) {
      dangerouslySetInnerHTML(content, '');
      content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
      if (props.allowHTML) {
        dangerouslySetInnerHTML(content, props.content);
      } else {
        content.textContent = props.content;
      }
    }
  }
  function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
      box: box,
      content: boxChildren.find(function (node) {
        return node.classList.contains(CONTENT_CLASS);
      }),
      arrow: boxChildren.find(function (node) {
        return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
      }),
      backdrop: boxChildren.find(function (node) {
        return node.classList.contains(BACKDROP_CLASS);
      })
    };
  }
  function render(instance) {
    var popper = div();
    var box = div();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);

    function onUpdate(prevProps, nextProps) {
      var _getChildren = getChildren(popper),
          box = _getChildren.box,
          content = _getChildren.content,
          arrow = _getChildren.arrow;

      if (nextProps.theme) {
        box.setAttribute('data-theme', nextProps.theme);
      } else {
        box.removeAttribute('data-theme');
      }

      if (typeof nextProps.animation === 'string') {
        box.setAttribute('data-animation', nextProps.animation);
      } else {
        box.removeAttribute('data-animation');
      }

      if (nextProps.inertia) {
        box.setAttribute('data-inertia', '');
      } else {
        box.removeAttribute('data-inertia');
      }

      box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

      if (nextProps.role) {
        box.setAttribute('role', nextProps.role);
      } else {
        box.removeAttribute('role');
      }

      if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
        setContent(content, instance.props);
      }

      if (nextProps.arrow) {
        if (!arrow) {
          box.appendChild(createArrowElement(nextProps.arrow));
        } else if (prevProps.arrow !== nextProps.arrow) {
          box.removeChild(arrow);
          box.appendChild(createArrowElement(nextProps.arrow));
        }
      } else if (arrow) {
        box.removeChild(arrow);
      }
    }

    return {
      popper: popper,
      onUpdate: onUpdate
    };
  } // Runtime check to identify if the render function is the default one; this
  // way we can apply default CSS transitions logic and it can be tree-shaken away

  render.$$tippy = true;

  var idCounter = 1;
  var mouseMoveListeners = []; // Used by `hideAll()`

  var mountedInstances = [];
  function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================

    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================

    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
      // Is the instance currently enabled?
      isEnabled: true,
      // Is the tippy currently showing and not transitioning out?
      isVisible: false,
      // Has the instance been destroyed?
      isDestroyed: false,
      // Is the tippy currently mounted to the DOM?
      isMounted: false,
      // Has the tippy finished transitioning in?
      isShown: false
    };
    var instance = {
      // properties
      id: id,
      reference: reference,
      popper: div(),
      popperInstance: popperInstance,
      props: props,
      state: state,
      plugins: plugins,
      // methods
      clearDelayTimeouts: clearDelayTimeouts,
      setProps: setProps,
      setContent: setContent,
      show: show,
      hide: hide,
      hideWithInteractivity: hideWithInteractivity,
      enable: enable,
      disable: disable,
      unmount: unmount,
      destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser

    /* istanbul ignore if */

    if (!props.render) {
      if (process.env.NODE_ENV !== "production") {
        errorWhen(true, 'render() function has not been supplied.');
      }

      return instance;
    } // ===========================================================================
    // Initial mutations
    // ===========================================================================


    var _props$render = props.render(instance),
        popper = _props$render.popper,
        onUpdate = _props$render.onUpdate;

    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function (plugin) {
      return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [instance]);

    if (props.showOnCreate) {
      scheduleShow();
    } // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding


    popper.addEventListener('mouseenter', function () {
      if (instance.props.interactive && instance.state.isVisible) {
        instance.clearDelayTimeouts();
      }
    });
    popper.addEventListener('mouseleave', function () {
      if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      }
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================

    function getNormalizedTouchSettings() {
      var touch = instance.props.touch;
      return Array.isArray(touch) ? touch : [touch, 0];
    }

    function getIsCustomTouchBehavior() {
      return getNormalizedTouchSettings()[0] === 'hold';
    }

    function getIsDefaultRenderFn() {
      var _instance$props$rende;

      // @ts-ignore
      return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }

    function getCurrentTarget() {
      return currentTarget || reference;
    }

    function getDocument() {
      var parent = getCurrentTarget().parentNode;
      return parent ? getOwnerDocument(parent) : document;
    }

    function getDefaultTemplateChildren() {
      return getChildren(popper);
    }

    function getDelay(isShow) {
      // For touch or keyboard input, force `0` delay for UX reasons
      // Also if the instance is mounted but not visible (transitioning out),
      // ignore delay
      if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
        return 0;
      }

      return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }

    function handleStyles(fromHide) {
      if (fromHide === void 0) {
        fromHide = false;
      }

      popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
      popper.style.zIndex = "" + instance.props.zIndex;
    }

    function invokeHook(hook, args, shouldInvokePropsHook) {
      if (shouldInvokePropsHook === void 0) {
        shouldInvokePropsHook = true;
      }

      pluginsHooks.forEach(function (pluginHooks) {
        if (pluginHooks[hook]) {
          pluginHooks[hook].apply(pluginHooks, args);
        }
      });

      if (shouldInvokePropsHook) {
        var _instance$props;

        (_instance$props = instance.props)[hook].apply(_instance$props, args);
      }
    }

    function handleAriaContentAttribute() {
      var aria = instance.props.aria;

      if (!aria.content) {
        return;
      }

      var attr = "aria-" + aria.content;
      var id = popper.id;
      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        var currentValue = node.getAttribute(attr);

        if (instance.state.isVisible) {
          node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
        } else {
          var nextValue = currentValue && currentValue.replace(id, '').trim();

          if (nextValue) {
            node.setAttribute(attr, nextValue);
          } else {
            node.removeAttribute(attr);
          }
        }
      });
    }

    function handleAriaExpandedAttribute() {
      if (hasAriaExpanded || !instance.props.aria.expanded) {
        return;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        if (instance.props.interactive) {
          node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
        } else {
          node.removeAttribute('aria-expanded');
        }
      });
    }

    function cleanupInteractiveMouseListeners() {
      getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
      mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
        return listener !== debouncedOnMouseMove;
      });
    }

    function onDocumentPress(event) {
      // Moved finger to scroll instead of an intentional tap outside
      if (currentInput.isTouch) {
        if (didTouchMove || event.type === 'mousedown') {
          return;
        }
      }

      var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

      if (instance.props.interactive && actualContains(popper, actualTarget)) {
        return;
      } // Clicked on the event listeners target


      if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
        return actualContains(el, actualTarget);
      })) {
        if (currentInput.isTouch) {
          return;
        }

        if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
          return;
        }
      } else {
        invokeHook('onClickOutside', [instance, event]);
      }

      if (instance.props.hideOnClick === true) {
        instance.clearDelayTimeouts();
        instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
        // currentTarget. This lets a tippy with `focus` trigger know that it
        // should not show

        didHideDueToDocumentMouseDown = true;
        setTimeout(function () {
          didHideDueToDocumentMouseDown = false;
        }); // The listener gets added in `scheduleShow()`, but this may be hiding it
        // before it shows, and hide()'s early bail-out behavior can prevent it
        // from being cleaned up

        if (!instance.state.isMounted) {
          removeDocumentPress();
        }
      }
    }

    function onTouchMove() {
      didTouchMove = true;
    }

    function onTouchStart() {
      didTouchMove = false;
    }

    function addDocumentPress() {
      var doc = getDocument();
      doc.addEventListener('mousedown', onDocumentPress, true);
      doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function removeDocumentPress() {
      var doc = getDocument();
      doc.removeEventListener('mousedown', onDocumentPress, true);
      doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
      doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
      doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }

    function onTransitionedOut(duration, callback) {
      onTransitionEnd(duration, function () {
        if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
          callback();
        }
      });
    }

    function onTransitionedIn(duration, callback) {
      onTransitionEnd(duration, callback);
    }

    function onTransitionEnd(duration, callback) {
      var box = getDefaultTemplateChildren().box;

      function listener(event) {
        if (event.target === box) {
          updateTransitionEndListener(box, 'remove', listener);
          callback();
        }
      } // Make callback synchronous if duration is 0
      // `transitionend` won't fire otherwise


      if (duration === 0) {
        return callback();
      }

      updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
      updateTransitionEndListener(box, 'add', listener);
      currentTransitionEndListener = listener;
    }

    function on(eventType, handler, options) {
      if (options === void 0) {
        options = false;
      }

      var nodes = normalizeToArray(instance.props.triggerTarget || reference);
      nodes.forEach(function (node) {
        node.addEventListener(eventType, handler, options);
        listeners.push({
          node: node,
          eventType: eventType,
          handler: handler,
          options: options
        });
      });
    }

    function addListeners() {
      if (getIsCustomTouchBehavior()) {
        on('touchstart', onTrigger, {
          passive: true
        });
        on('touchend', onMouseLeave, {
          passive: true
        });
      }

      splitBySpaces(instance.props.trigger).forEach(function (eventType) {
        if (eventType === 'manual') {
          return;
        }

        on(eventType, onTrigger);

        switch (eventType) {
          case 'mouseenter':
            on('mouseleave', onMouseLeave);
            break;

          case 'focus':
            on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
            break;

          case 'focusin':
            on('focusout', onBlurOrFocusOut);
            break;
        }
      });
    }

    function removeListeners() {
      listeners.forEach(function (_ref) {
        var node = _ref.node,
            eventType = _ref.eventType,
            handler = _ref.handler,
            options = _ref.options;
        node.removeEventListener(eventType, handler, options);
      });
      listeners = [];
    }

    function onTrigger(event) {
      var _lastTriggerEvent;

      var shouldScheduleClickHide = false;

      if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
        return;
      }

      var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
      lastTriggerEvent = event;
      currentTarget = event.currentTarget;
      handleAriaExpandedAttribute();

      if (!instance.state.isVisible && isMouseEvent(event)) {
        // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function (listener) {
          return listener(event);
        });
      } // Toggle show/hide when clicking click-triggered tooltips


      if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
        shouldScheduleClickHide = true;
      } else {
        scheduleShow(event);
      }

      if (event.type === 'click') {
        isVisibleFromClick = !shouldScheduleClickHide;
      }

      if (shouldScheduleClickHide && !wasFocused) {
        scheduleHide(event);
      }
    }

    function onMouseMove(event) {
      var target = event.target;
      var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

      if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
        return;
      }

      var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
        var _instance$popperInsta;

        var instance = popper._tippy;
        var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

        if (state) {
          return {
            popperRect: popper.getBoundingClientRect(),
            popperState: state,
            props: props
          };
        }

        return null;
      }).filter(Boolean);

      if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
        cleanupInteractiveMouseListeners();
        scheduleHide(event);
      }
    }

    function onMouseLeave(event) {
      var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

      if (shouldBail) {
        return;
      }

      if (instance.props.interactive) {
        instance.hideWithInteractivity(event);
        return;
      }

      scheduleHide(event);
    }

    function onBlurOrFocusOut(event) {
      if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
        return;
      } // If focus was moved to within the popper


      if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
        return;
      }

      scheduleHide(event);
    }

    function isEventListenerStopped(event) {
      return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }

    function createPopperInstance() {
      destroyPopperInstance();
      var _instance$props2 = instance.props,
          popperOptions = _instance$props2.popperOptions,
          placement = _instance$props2.placement,
          offset = _instance$props2.offset,
          getReferenceClientRect = _instance$props2.getReferenceClientRect,
          moveTransition = _instance$props2.moveTransition;
      var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
      var computedReference = getReferenceClientRect ? {
        getBoundingClientRect: getReferenceClientRect,
        contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
      } : reference;
      var tippyModifier = {
        name: '$$tippy',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: function fn(_ref2) {
          var state = _ref2.state;

          if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh = getDefaultTemplateChildren(),
                box = _getDefaultTemplateCh.box;

            ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
              if (attr === 'placement') {
                box.setAttribute('data-placement', state.placement);
              } else {
                if (state.attributes.popper["data-popper-" + attr]) {
                  box.setAttribute("data-" + attr, '');
                } else {
                  box.removeAttribute("data-" + attr);
                }
              }
            });
            state.attributes.popper = {};
          }
        }
      };
      var modifiers = [{
        name: 'offset',
        options: {
          offset: offset
        }
      }, {
        name: 'preventOverflow',
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: 'flip',
        options: {
          padding: 5
        }
      }, {
        name: 'computeStyles',
        options: {
          adaptive: !moveTransition
        }
      }, tippyModifier];

      if (getIsDefaultRenderFn() && arrow) {
        modifiers.push({
          name: 'arrow',
          options: {
            element: arrow,
            padding: 3
          }
        });
      }

      modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
      instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
        placement: placement,
        onFirstUpdate: onFirstUpdate,
        modifiers: modifiers
      }));
    }

    function destroyPopperInstance() {
      if (instance.popperInstance) {
        instance.popperInstance.destroy();
        instance.popperInstance = null;
      }
    }

    function mount() {
      var appendTo = instance.props.appendTo;
      var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
      // it's directly after the reference element so the elements inside the
      // tippy can be tabbed to
      // If there are clipping issues, the user can specify a different appendTo
      // and ensure focus management is handled correctly manually

      var node = getCurrentTarget();

      if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
        parentNode = node.parentNode;
      } else {
        parentNode = invokeWithArgsOrReturn(appendTo, [node]);
      } // The popper element needs to exist on the DOM before its position can be
      // updated as Popper needs to read its dimensions


      if (!parentNode.contains(popper)) {
        parentNode.appendChild(popper);
      }

      instance.state.isMounted = true;
      createPopperInstance();
      /* istanbul ignore else */

      if (process.env.NODE_ENV !== "production") {
        // Accessibility check
        warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
      }
    }

    function getNestedPopperTree() {
      return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }

    function scheduleShow(event) {
      instance.clearDelayTimeouts();

      if (event) {
        invokeHook('onTrigger', [instance, event]);
      }

      addDocumentPress();
      var delay = getDelay(true);

      var _getNormalizedTouchSe = getNormalizedTouchSettings(),
          touchValue = _getNormalizedTouchSe[0],
          touchDelay = _getNormalizedTouchSe[1];

      if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
        delay = touchDelay;
      }

      if (delay) {
        showTimeout = setTimeout(function () {
          instance.show();
        }, delay);
      } else {
        instance.show();
      }
    }

    function scheduleHide(event) {
      instance.clearDelayTimeouts();
      invokeHook('onUntrigger', [instance, event]);

      if (!instance.state.isVisible) {
        removeDocumentPress();
        return;
      } // For interactive tippies, scheduleHide is added to a document.body handler
      // from onMouseLeave so must intercept scheduled hides from mousemove/leave
      // events when trigger contains mouseenter and click, and the tip is
      // currently shown as a result of a click.


      if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
        return;
      }

      var delay = getDelay(false);

      if (delay) {
        hideTimeout = setTimeout(function () {
          if (instance.state.isVisible) {
            instance.hide();
          }
        }, delay);
      } else {
        // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function () {
          instance.hide();
        });
      }
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================


    function enable() {
      instance.state.isEnabled = true;
    }

    function disable() {
      // Disabling the instance should also hide it
      // https://github.com/atomiks/tippy.js-react/issues/106
      instance.hide();
      instance.state.isEnabled = false;
    }

    function clearDelayTimeouts() {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      cancelAnimationFrame(scheduleHideAnimationFrame);
    }

    function setProps(partialProps) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      invokeHook('onBeforeUpdate', [instance, partialProps]);
      removeListeners();
      var prevProps = instance.props;
      var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
        ignoreAttributes: true
      }));
      instance.props = nextProps;
      addListeners();

      if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
        cleanupInteractiveMouseListeners();
        debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
      } // Ensure stale aria-expanded attributes are removed


      if (prevProps.triggerTarget && !nextProps.triggerTarget) {
        normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
          node.removeAttribute('aria-expanded');
        });
      } else if (nextProps.triggerTarget) {
        reference.removeAttribute('aria-expanded');
      }

      handleAriaExpandedAttribute();
      handleStyles();

      if (onUpdate) {
        onUpdate(prevProps, nextProps);
      }

      if (instance.popperInstance) {
        createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
        // and the nested ones get re-rendered first.
        // https://github.com/atomiks/tippyjs-react/issues/177
        // TODO: find a cleaner / more efficient solution(!)

        getNestedPopperTree().forEach(function (nestedPopper) {
          // React (and other UI libs likely) requires a rAF wrapper as it flushes
          // its work in one
          requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
        });
      }

      invokeHook('onAfterUpdate', [instance, partialProps]);
    }

    function setContent(content) {
      instance.setProps({
        content: content
      });
    }

    function show() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
      } // Early bail-out


      var isAlreadyVisible = instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

      if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
        return;
      } // Normalize `disabled` behavior across browsers.
      // Firefox allows events on disabled elements, but Chrome doesn't.
      // Using a wrapper element (i.e. <span>) is recommended.


      if (getCurrentTarget().hasAttribute('disabled')) {
        return;
      }

      invokeHook('onShow', [instance], false);

      if (instance.props.onShow(instance) === false) {
        return;
      }

      instance.state.isVisible = true;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'visible';
      }

      handleStyles();
      addDocumentPress();

      if (!instance.state.isMounted) {
        popper.style.transition = 'none';
      } // If flipping to the opposite side after hiding at least once, the
      // animation will use the wrong placement without resetting the duration


      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh2.box,
            content = _getDefaultTemplateCh2.content;

        setTransitionDuration([box, content], 0);
      }

      onFirstUpdate = function onFirstUpdate() {
        var _instance$popperInsta2;

        if (!instance.state.isVisible || ignoreOnFirstUpdate) {
          return;
        }

        ignoreOnFirstUpdate = true; // reflow

        void popper.offsetHeight;
        popper.style.transition = instance.props.moveTransition;

        if (getIsDefaultRenderFn() && instance.props.animation) {
          var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
              _box = _getDefaultTemplateCh3.box,
              _content = _getDefaultTemplateCh3.content;

          setTransitionDuration([_box, _content], duration);
          setVisibilityState([_box, _content], 'visible');
        }

        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
        // popper has been positioned for the first time

        (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
        invokeHook('onMount', [instance]);

        if (instance.props.animation && getIsDefaultRenderFn()) {
          onTransitionedIn(duration, function () {
            instance.state.isShown = true;
            invokeHook('onShown', [instance]);
          });
        }
      };

      mount();
    }

    function hide() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
      } // Early bail-out


      var isAlreadyHidden = !instance.state.isVisible;
      var isDestroyed = instance.state.isDestroyed;
      var isDisabled = !instance.state.isEnabled;
      var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

      if (isAlreadyHidden || isDestroyed || isDisabled) {
        return;
      }

      invokeHook('onHide', [instance], false);

      if (instance.props.onHide(instance) === false) {
        return;
      }

      instance.state.isVisible = false;
      instance.state.isShown = false;
      ignoreOnFirstUpdate = false;
      isVisibleFromClick = false;

      if (getIsDefaultRenderFn()) {
        popper.style.visibility = 'hidden';
      }

      cleanupInteractiveMouseListeners();
      removeDocumentPress();
      handleStyles(true);

      if (getIsDefaultRenderFn()) {
        var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
            box = _getDefaultTemplateCh4.box,
            content = _getDefaultTemplateCh4.content;

        if (instance.props.animation) {
          setTransitionDuration([box, content], duration);
          setVisibilityState([box, content], 'hidden');
        }
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();

      if (instance.props.animation) {
        if (getIsDefaultRenderFn()) {
          onTransitionedOut(duration, instance.unmount);
        }
      } else {
        instance.unmount();
      }
    }

    function hideWithInteractivity(event) {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
      }

      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
      pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
      debouncedOnMouseMove(event);
    }

    function unmount() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
      }

      if (instance.state.isVisible) {
        instance.hide();
      }

      if (!instance.state.isMounted) {
        return;
      }

      destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
      // tree by default. This seems mainly for interactive tippies, but we should
      // find a workaround if possible

      getNestedPopperTree().forEach(function (nestedPopper) {
        nestedPopper._tippy.unmount();
      });

      if (popper.parentNode) {
        popper.parentNode.removeChild(popper);
      }

      mountedInstances = mountedInstances.filter(function (i) {
        return i !== instance;
      });
      instance.state.isMounted = false;
      invokeHook('onHidden', [instance]);
    }

    function destroy() {
      /* istanbul ignore else */
      if (process.env.NODE_ENV !== "production") {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
      }

      if (instance.state.isDestroyed) {
        return;
      }

      instance.clearDelayTimeouts();
      instance.unmount();
      removeListeners();
      delete reference._tippy;
      instance.state.isDestroyed = true;
      invokeHook('onDestroy', [instance]);
    }
  }

  function tippy(targets, optionalProps) {
    if (optionalProps === void 0) {
      optionalProps = {};
    }

    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      validateTargets(targets);
      validateProps(optionalProps, plugins);
    }

    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
      plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      var isSingleContentElement = isElement(passedProps.content);
      var isMoreThanOneReferenceElement = elements.length > 1;
      warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
    }

    var instances = elements.reduce(function (acc, reference) {
      var instance = reference && createTippy(reference, passedProps);

      if (instance) {
        acc.push(instance);
      }

      return acc;
    }, []);
    return isElement(targets) ? instances[0] : instances;
  }

  tippy.defaultProps = defaultProps;
  tippy.setDefaultProps = setDefaultProps;
  tippy.currentInput = currentInput;

  // every time the popper is destroyed (i.e. a new target), removing the styles
  // and causing transitions to break for singletons when the console is open, but
  // most notably for non-transform styles being used, `gpuAcceleration: false`.

  Object.assign({}, applyStyles$1, {
    effect: function effect(_ref) {
      var state = _ref.state;
      var initialStyles = {
        popper: {
          position: state.options.strategy,
          left: '0',
          top: '0',
          margin: '0'
        },
        arrow: {
          position: 'absolute'
        },
        reference: {}
      };
      Object.assign(state.elements.popper.style, initialStyles.popper);
      state.styles = initialStyles;

      if (state.elements.arrow) {
        Object.assign(state.elements.arrow.style, initialStyles.arrow);
      } // intentionally return no cleanup function
      // return () => { ... }

    }
  });

  tippy.setDefaultProps({
    render: render
  });

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
  function preserveRef(ref, node) {
    if (ref) {
      if (typeof ref === 'function') {
        ref(node);
      }

      if ({}.hasOwnProperty.call(ref, 'current')) {
        ref.current = node;
      }
    }
  }
  function ssrSafeCreateDiv() {
    return isBrowser && document.createElement('div');
  }
  function toDataAttributes(attrs) {
    var dataAttrs = {
      'data-placement': attrs.placement
    };

    if (attrs.referenceHidden) {
      dataAttrs['data-reference-hidden'] = '';
    }

    if (attrs.escaped) {
      dataAttrs['data-escaped'] = '';
    }

    return dataAttrs;
  }

  function deepEqual(x, y) {
    if (x === y) {
      return true;
    } else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
      if (Object.keys(x).length !== Object.keys(y).length) {
        return false;
      }

      for (var prop in x) {
        if (y.hasOwnProperty(prop)) {
          if (!deepEqual(x[prop], y[prop])) {
            return false;
          }
        } else {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }
  }

  function uniqueByShape(arr) {
    var output = [];
    arr.forEach(function (item) {
      if (!output.find(function (outputItem) {
        return deepEqual(item, outputItem);
      })) {
        output.push(item);
      }
    });
    return output;
  }
  function deepPreserveProps(instanceProps, componentProps) {
    var _instanceProps$popper, _componentProps$poppe;

    return Object.assign({}, componentProps, {
      popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
        modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
      })
    });
  }

  var useIsomorphicLayoutEffect = isBrowser ? React.useLayoutEffect : React.useEffect;
  function useMutableBox(initialValue) {
    // Using refs instead of state as it's recommended to not store imperative
    // values in state due to memory problems in React(?)
    var ref = React.useRef();

    if (!ref.current) {
      ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
    }

    return ref.current;
  }

  function updateClassName(box, action, classNames) {
    classNames.split(/\s+/).forEach(function (name) {
      if (name) {
        box.classList[action](name);
      }
    });
  }

  var classNamePlugin = {
    name: 'className',
    defaultValue: '',
    fn: function fn(instance) {
      var box = instance.popper.firstElementChild;

      var isDefaultRenderFn = function isDefaultRenderFn() {
        var _instance$props$rende;

        return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
      };

      function add() {
        if (instance.props.className && !isDefaultRenderFn()) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn(['@tippyjs/react: Cannot use `className` prop in conjunction with', '`render` prop. Place the className on the element you are', 'rendering.'].join(' '));
          }

          return;
        }

        updateClassName(box, 'add', instance.props.className);
      }

      function remove() {
        if (isDefaultRenderFn()) {
          updateClassName(box, 'remove', instance.props.className);
        }
      }

      return {
        onCreate: add,
        onBeforeUpdate: remove,
        onAfterUpdate: add
      };
    }
  };

  function TippyGenerator(tippy) {
    function Tippy(_ref) {
      var children = _ref.children,
          content = _ref.content,
          visible = _ref.visible,
          singleton = _ref.singleton,
          render = _ref.render,
          reference = _ref.reference,
          _ref$disabled = _ref.disabled,
          disabled = _ref$disabled === void 0 ? false : _ref$disabled,
          _ref$ignoreAttributes = _ref.ignoreAttributes,
          ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
          _ref.__source;
          _ref.__self;
          var restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

      var isControlledMode = visible !== undefined;
      var isSingletonMode = singleton !== undefined;

      var _useState = React.useState(false),
          mounted = _useState[0],
          setMounted = _useState[1];

      var _useState2 = React.useState({}),
          attrs = _useState2[0],
          setAttrs = _useState2[1];

      var _useState3 = React.useState(),
          singletonContent = _useState3[0],
          setSingletonContent = _useState3[1];

      var mutableBox = useMutableBox(function () {
        return {
          container: ssrSafeCreateDiv(),
          renders: 1
        };
      });
      var props = Object.assign({
        ignoreAttributes: ignoreAttributes
      }, restOfNativeProps, {
        content: mutableBox.container
      });

      if (isControlledMode) {
        if (process.env.NODE_ENV !== 'production') {
          ['trigger', 'hideOnClick', 'showOnCreate'].forEach(function (nativeStateProp) {
            if (props[nativeStateProp] !== undefined) {
              console.warn(["@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in", "controlled mode (`visible` prop)"].join(' '));
            }
          });
        }

        props.trigger = 'manual';
        props.hideOnClick = false;
      }

      if (isSingletonMode) {
        disabled = true;
      }

      var computedProps = props;
      var plugins = props.plugins || [];

      if (render) {
        computedProps = Object.assign({}, props, {
          plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [{
            fn: function fn() {
              return {
                onTrigger: function onTrigger(instance, event) {
                  var node = singleton.data.children.find(function (_ref2) {
                    var instance = _ref2.instance;
                    return instance.reference === event.currentTarget;
                  });
                  instance.state.$$activeSingletonInstance = node.instance;
                  setSingletonContent(node.content);
                }
              };
            }
          }]) : plugins,
          render: function render() {
            return {
              popper: mutableBox.container
            };
          }
        });
      }

      var deps = [reference].concat(children ? [children.type] : []); // CREATE

      useIsomorphicLayoutEffect(function () {
        var element = reference;

        if (reference && reference.hasOwnProperty('current')) {
          element = reference.current;
        }

        var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
          plugins: [classNamePlugin].concat(props.plugins || [])
        }));
        mutableBox.instance = instance;

        if (disabled) {
          instance.disable();
        }

        if (visible) {
          instance.show();
        }

        if (isSingletonMode) {
          singleton.hook({
            instance: instance,
            content: content,
            props: computedProps,
            setSingletonContent: setSingletonContent
          });
        }

        setMounted(true);
        return function () {
          instance.destroy();
          singleton == null ? void 0 : singleton.cleanup(instance);
        };
      }, deps); // UPDATE

      useIsomorphicLayoutEffect(function () {
        var _instance$popperInsta;

        // Prevent this effect from running on 1st render
        if (mutableBox.renders === 1) {
          mutableBox.renders++;
          return;
        }

        var instance = mutableBox.instance;
        instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264

        (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

        if (disabled) {
          instance.disable();
        } else {
          instance.enable();
        }

        if (isControlledMode) {
          if (visible) {
            instance.show();
          } else {
            instance.hide();
          }
        }

        if (isSingletonMode) {
          singleton.hook({
            instance: instance,
            content: content,
            props: computedProps,
            setSingletonContent: setSingletonContent
          });
        }
      });
      useIsomorphicLayoutEffect(function () {
        var _instance$props$poppe;

        if (!render) {
          return;
        }

        var instance = mutableBox.instance;
        instance.setProps({
          popperOptions: Object.assign({}, instance.props.popperOptions, {
            modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref3) {
              var name = _ref3.name;
              return name !== '$$tippyReact';
            }), [{
              name: '$$tippyReact',
              enabled: true,
              phase: 'beforeWrite',
              requires: ['computeStyles'],
              fn: function fn(_ref4) {
                var _state$modifiersData;

                var state = _ref4.state;
                var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
                // loop. This expression _must_ evaluate to false when required

                if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                  setAttrs({
                    placement: state.placement,
                    referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                    escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                  });
                }

                state.attributes.popper = {};
              }
            }])
          })
        });
      }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
      return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children ? /*#__PURE__*/React.cloneElement(children, {
        ref: function ref(node) {
          mutableBox.ref = node;
          preserveRef(children.ref, node);
        }
      }) : null, mounted && /*#__PURE__*/reactDom.createPortal(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
    }

    return Tippy;
  }

  var forwardRef = (function (Tippy, defaultProps) {
    return /*#__PURE__*/React.forwardRef(function TippyWrapper(_ref, _ref2) {
      var children = _ref.children,
          props = _objectWithoutPropertiesLoose(_ref, ["children"]);

      return (
        /*#__PURE__*/
        // If I spread them separately here, Babel adds the _extends ponyfill for
        // some reason
        React__default["default"].createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/React.cloneElement(children, {
          ref: function ref(node) {
            preserveRef(_ref2, node);
            preserveRef(children.ref, node);
          }
        }) : null)
      );
    });
  });
  var index = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(tippy));

  var Tippy = index;

  var __defProp$h = Object.defineProperty;
  var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
  var __hasOwnProp$h = Object.prototype.hasOwnProperty;
  var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$h = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$h.call(b, prop))
        __defNormalProp$h(a, prop, b[prop]);
    if (__getOwnPropSymbols$h)
      for (var prop of __getOwnPropSymbols$h(b)) {
        if (__propIsEnum$h.call(b, prop))
          __defNormalProp$h(a, prop, b[prop]);
      }
    return a;
  };
  const tooltipContainerStyle = (sx) => ({
    ".tippy-box": __spreadValues$h({
      "> .tippy-content": {
        padding: 0
      },
      backgroundColor: "neutral.inverse.00",
      borderColor: "neutral.inverse.00",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "hairline",
      boxShadow: "01",
      maxWidth: 240,
      padding: "inset.nano"
    }, sx)
  });
  const tooltipContentStyle = {
    color: "typeface.inverse.strong",
    fontSize: "xxxs",
    fontWeight: "bold",
    letterSpacing: "standard",
    lineHeight: "distant",
    paddingBottom: "stack.quark"
  };

  var __defProp$g = Object.defineProperty;
  var __defProps$8 = Object.defineProperties;
  var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
  var __hasOwnProp$g = Object.prototype.hasOwnProperty;
  var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$g = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$g.call(b, prop))
        __defNormalProp$g(a, prop, b[prop]);
    if (__getOwnPropSymbols$g)
      for (var prop of __getOwnPropSymbols$g(b)) {
        if (__propIsEnum$g.call(b, prop))
          __defNormalProp$g(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
  var __objRest$f = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$g.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$g)
      for (var prop of __getOwnPropSymbols$g(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$g.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Tooltip = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { children, message, offset = 10, title, zIndex = 9999, sx, arrow = true } = _b, props = __objRest$f(_b, ["children", "message", "offset", "title", "zIndex", "sx", "arrow"]);
    const renderContent = () => /* @__PURE__ */ React__default["default"].createElement(Box, null, title && /* @__PURE__ */ React__default["default"].createElement(Body, {
      sx: tooltipContentStyle
    }, title), /* @__PURE__ */ React__default["default"].createElement(Caption, {
      brand: true
    }, message));
    const renderArrow = () => `
            <svg width="16" height="6" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 0L8 4H0L4 0Z" fill="${defaultTheme$1.colors.neutral.inverse["00"]}"/>
            </svg>
        `;
    return /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: tooltipContainerStyle(sx)
    }, /* @__PURE__ */ React__default["default"].createElement(Tippy, __spreadProps$8(__spreadValues$g({
      allowHTML: true,
      appendTo: "parent",
      arrow: arrow ? renderArrow() : "",
      content: renderContent(),
      interactive: true,
      maxWidth: 240,
      offset: [0, offset],
      zIndex
    }, props), {
      ref
    }), children));
  });

  const getPackStyle = {
    height: "100%",
    position: "relative",
    width: "100%"
  };

  var __defProp$f = Object.defineProperty;
  var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
  var __hasOwnProp$f = Object.prototype.hasOwnProperty;
  var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$f = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$f.call(b, prop))
        __defNormalProp$f(a, prop, b[prop]);
    if (__getOwnPropSymbols$f)
      for (var prop of __getOwnPropSymbols$f(b)) {
        if (__propIsEnum$f.call(b, prop))
          __defNormalProp$f(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$e = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$f.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$f)
      for (var prop of __getOwnPropSymbols$f(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$f.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Pack = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { children, divider, spacing, sx } = _b, props = __objRest$e(_b, ["children", "divider", "spacing", "sx"]);
    const renderChildrens = () => {
      const childrenCount = React__default["default"].Children.count(children);
      const childWithProps = React__default["default"].Children.map(children, (child, index) => {
        if (!React__default["default"].isValidElement(child)) {
          return child;
        }
        const isLastChild = index === childrenCount - 1;
        const getMarginLocation = () => {
          switch (props.direction) {
            case "row":
            case "row-reverse":
              return {
                marginInline: spacing
              };
            case "column":
            case "column-reverse":
              return {
                marginBlock: spacing
              };
            default:
              return null;
          }
        };
        const renderDivider = () => {
          const direction = props.direction ? props.direction : "column";
          if (divider && typeof divider === "boolean" && !isLastChild) {
            return /* @__PURE__ */ React__default["default"].createElement(Divider, {
              variant: direction.indexOf("row") >= 0 ? "vertical" : "horizontal"
            });
          } else if (divider && typeof divider !== "boolean" && !isLastChild) {
            return divider;
          }
          return null;
        };
        return [
          React__default["default"].cloneElement(child, {
            sx: getMarginLocation()
          }),
          renderDivider()
        ];
      });
      return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
    };
    return /* @__PURE__ */ React__default["default"].createElement(Flex, __spreadValues$f({
      ref,
      sx: __spreadValues$f(__spreadValues$f({}, getPackStyle), sx)
    }, props), renderChildrens());
  });

  var Keyboard;
  (function(Keyboard2) {
    Keyboard2["Escape"] = "Escape";
    Keyboard2["ArrowDown"] = "ArrowDown";
    Keyboard2["ArrowUp"] = "ArrowUp";
    Keyboard2["ArrowRight"] = "ArrowRight";
    Keyboard2["ArrowLeft"] = "ArrowLeft";
    Keyboard2["Enter"] = "Enter";
    Keyboard2["Home"] = "Home";
    Keyboard2["End"] = "End";
    Keyboard2["PageUp"] = "PageUp";
    Keyboard2["PageDown"] = "PageDown";
    Keyboard2["Space"] = "Space";
    Keyboard2["Tab"] = "Tab";
    Keyboard2["Backspace"] = "Backspace";
  })(Keyboard || (Keyboard = {}));

  const filterList = (searchText, list, sensitive = false) => {
    const textFormatter = searchText.toLowerCase();
    return list.filter((value) => {
      if (sensitive) {
        return value.label.includes(searchText);
      }
      const valueUnsensitive = value.label.toLowerCase();
      return stringNormalize(valueUnsensitive).includes(stringNormalize(textFormatter));
    });
  };
  const getKeyOfKeyboard = ({ key, code }) => key.trim() ? key : code;
  const basicUid = (prefix = "") => `${prefix}${new Date().getUTCMilliseconds().toString(36)}`;
  const toggleDropUp = (target, dropdown) => {
    const gutter = 16;
    const position = target.getBoundingClientRect().top;
    const targetHeight = target.getBoundingClientRect().height;
    const dropdownHeight = dropdown.getBoundingClientRect().height + gutter;
    const { innerHeight: windowHeight } = window;
    return position > dropdownHeight && windowHeight - position < targetHeight + dropdownHeight;
  };

  const getDropdownBaseStyle = (hover, focus, active, disabled) => {
    const getBackgroundColor = () => {
      if (!disabled && active) {
        return "interaction.blend.02";
      } else if (!disabled && (hover || focus)) {
        return "interaction.blend.01";
      }
      return "transparent";
    };
    return {
      alignItems: "center",
      backgroundColor: getBackgroundColor(),
      borderColor: !disabled && !active && focus ? "interaction.select.focus" : "transparent",
      borderStyle: "solid",
      borderWidth: "thin",
      cursor: disabled ? "default" : "pointer",
      display: "flex",
      justifyContent: "space-between",
      minHeight: 40,
      outline: "none",
      padding: "squish.nano",
      width: "100%"
    };
  };

  var __defProp$e = Object.defineProperty;
  var __defProps$7 = Object.defineProperties;
  var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
  var __hasOwnProp$e = Object.prototype.hasOwnProperty;
  var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$e = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$e.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    if (__getOwnPropSymbols$e)
      for (var prop of __getOwnPropSymbols$e(b)) {
        if (__propIsEnum$e.call(b, prop))
          __defNormalProp$e(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
  var __objRest$d = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$e)
      for (var prop of __getOwnPropSymbols$e(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const DropdownModuleBase = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { children, disabled, selected, sx } = _b, props = __objRest$d(_b, ["children", "disabled", "selected", "sx"]);
    const [active, setActive] = React.useState(false);
    const [focus, setFocus] = React.useState(false);
    const [hover, setHover] = React.useState(false);
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$7(__spreadValues$e({}, props), {
      "aria-selected": selected,
      onBlur: () => setFocus(false),
      onFocus: () => setFocus(true),
      onMouseDown: () => setActive(true),
      onMouseEnter: () => setHover(true),
      onMouseLeave: () => setHover(false),
      onMouseUp: () => setActive(false),
      ref,
      role: "option",
      sx: __spreadValues$e(__spreadValues$e({}, getDropdownBaseStyle(hover, focus, active, disabled)), sx)
    }), children);
  });

  const dropdownModuleSingleLeftStyle = {
    alignItems: "center",
    display: "flex",
    pointerEvents: "none"
  };

  var __defProp$d = Object.defineProperty;
  var __defProps$6 = Object.defineProperties;
  var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
  var __hasOwnProp$d = Object.prototype.hasOwnProperty;
  var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$d = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$d.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    if (__getOwnPropSymbols$d)
      for (var prop of __getOwnPropSymbols$d(b)) {
        if (__propIsEnum$d.call(b, prop))
          __defNormalProp$d(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
  var __objRest$c = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$d)
      for (var prop of __getOwnPropSymbols$d(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const DropdownModuleSingle = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { disabled, label, leadingIcon, selected } = _b, props = __objRest$c(_b, ["disabled", "label", "leadingIcon", "selected"]);
    return /* @__PURE__ */ React__default["default"].createElement(DropdownModuleBase, __spreadProps$6(__spreadValues$d({}, props), {
      disabled,
      ref,
      selected
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: dropdownModuleSingleLeftStyle
    }, leadingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: disabled ? "interaction.blend.04" : "support.01",
      mr: "inline.nano",
      size: "md"
    }, leadingIcon), selected ? /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      pb: "stack.quark",
      pr: "stack.nano",
      pt: "stack.quark",
      variant: "md"
    }, label) : /* @__PURE__ */ React__default["default"].createElement(Body, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      variant: "sm"
    }, label)), selected && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      color: disabled ? "interaction.blend.04" : "interaction.blend.07",
      size: "md"
    }, /* @__PURE__ */ React__default["default"].createElement(almaIcons.Check, null)));
  });
  const DropdownModuleMultiple = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { checked, disabled, label } = _d, props = __objRest$c(_d, ["checked", "disabled", "label"]);
    return /* @__PURE__ */ React__default["default"].createElement(DropdownModuleBase, __spreadProps$6(__spreadValues$d({}, props), {
      disabled,
      ref,
      selected: checked
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: dropdownModuleSingleLeftStyle
    }, /* @__PURE__ */ React__default["default"].createElement(CheckBox, {
      checked,
      disabled,
      readOnly: true
    }), checked ? /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      ml: "inline.nano",
      pb: "stack.quark",
      pr: "stack.nano",
      pt: "stack.quark",
      variant: "md"
    }, label) : /* @__PURE__ */ React__default["default"].createElement(Body, {
      color: disabled ? "typeface.meld" : "typeface.pure",
      ml: "inline.nano",
      variant: "sm"
    }, label)));
  });

  const commonCSS = styled.css`
    p {
        ${cssTextEllipsisOneLine}
    }

    ${({ focused }) => focused && styled.css`
            background-color: ${defaultTheme$1.colors.interaction.blend["01"]} !important;
        `}
`;
  const Option$1 = styled__default$1["default"](DropdownModuleSingle).attrs(() => ({
    role: "option",
    tabIndex: -1
  }))`
    ${commonCSS}
`;
  const OptionMultiple = styled__default$1["default"](DropdownModuleMultiple).attrs(() => ({
    role: "option",
    tabIndex: -1
  }))`
    ${commonCSS}
`;

  let nextId$2 = 0;
  const Option = React__default["default"].forwardRef(({ selected, focused, value, multiple, onClick, onMouseDown }, ref) => {
    const innerId = React__default["default"].useMemo(() => {
      nextId$2 += 1;
      return `${basicUid("o")}_${nextId$2}`;
    }, []);
    return /* @__PURE__ */ React__default["default"].createElement("div", {
      onMouseDown
    }, multiple ? /* @__PURE__ */ React__default["default"].createElement(OptionMultiple, {
      checked: selected,
      disabled: value.disabled,
      focused: !!focused,
      id: innerId,
      label: value.label,
      onClick,
      ref
    }) : /* @__PURE__ */ React__default["default"].createElement(Option$1, {
      disabled: value.disabled,
      focused: !!focused,
      id: innerId,
      label: value.label,
      leadingIcon: value.leadingIcon,
      onClick,
      onMouseDown,
      ref,
      selected
    }));
  });

  const useProps = () => {
    const [usedAsSupport, setUsedAsSupport] = React__default["default"].useState(false);
    const [options, setOptions] = React__default["default"].useState([]);
    const [activeElement, setActiveElement] = React__default["default"].useState(null);
    const [selectedOptionRef, setCurrentOptionRef] = React__default["default"].useState(null);
    const [selectedOption, setSelectedOption] = React__default["default"].useState();
    const [selectedOptions, setSelectedOptions] = React__default["default"].useState([]);
    const [focusedOption, setFocusedOption] = React__default["default"].useState();
    const [multiple, setMultiple] = React__default["default"].useState(false);
    const hostRef = React__default["default"].useRef(null);
    const updateSelectedOption = React__default["default"].useCallback((selected) => {
      setSelectedOption(selected);
      setSelectedOptions((previousOptions) => {
        if ((selected == null ? void 0 : selected.value) === void 0 || !multiple) {
          return previousOptions;
        }
        if (previousOptions.some((option) => option.value === selected.value)) {
          return previousOptions.filter((option) => option.value !== selected.value);
        }
        return [...previousOptions, selected];
      });
    }, [multiple]);
    const resetSelectedOptions = React__default["default"].useCallback(() => {
      setSelectedOptions([]);
      setSelectedOption(void 0);
    }, []);
    const removeSelectedOption = React__default["default"].useCallback((indexTarget = -1) => {
      setSelectedOptions((previousSelectedOptions) => {
        if (!previousSelectedOptions.length) {
          setSelectedOption(void 0);
          return previousSelectedOptions;
        }
        const innerIndexTarget = indexTarget !== -1 ? indexTarget : previousSelectedOptions.length - 1;
        const newSelectedOptions = previousSelectedOptions.filter((_, index) => index !== innerIndexTarget);
        const lastOption = [...newSelectedOptions].pop();
        if (lastOption) {
          setSelectedOption(lastOption);
        }
        return newSelectedOptions;
      });
    }, []);
    const optionsRef = React__default["default"].useMemo(() => Array(options.length).fill("").map(() => React__default["default"].createRef()), [options.length]);
    const selectedIndexOption = React__default["default"].useMemo(() => selectedOption ? options.indexOf(selectedOption) : -1, [options, selectedOption]);
    const focusedIndexOption = React__default["default"].useMemo(() => focusedOption ? options.indexOf(focusedOption) : -1, [options, focusedOption]);
    React__default["default"].useEffect(() => {
      if (focusedIndexOption !== -1 && optionsRef[focusedIndexOption]) {
        setCurrentOptionRef(optionsRef[focusedIndexOption].current);
      } else if (selectedIndexOption !== -1 && optionsRef[selectedIndexOption]) {
        setCurrentOptionRef(optionsRef[selectedIndexOption].current);
      } else {
        setCurrentOptionRef(null);
      }
    }, [selectedIndexOption, optionsRef, focusedIndexOption]);
    const updateNextOption = (shift = 1) => {
      const nextIndex = focusedIndexOption + shift;
      let index = 0;
      if (options[nextIndex]) {
        index = nextIndex;
      }
      return setFocusedOption(options[index]);
    };
    const updatePreviousOption = (shift = 1) => {
      const previousIndex = focusedIndexOption - shift;
      let index = options.length - 1;
      if (previousIndex !== -1 && options[previousIndex]) {
        index = previousIndex;
      }
      return setFocusedOption(options[index]);
    };
    const handleKeyboard = (key, event) => {
      switch (key) {
        case Keyboard.ArrowDown:
        case Keyboard.ArrowRight:
          updateNextOption();
          break;
        case Keyboard.ArrowUp:
        case Keyboard.ArrowLeft:
          updatePreviousOption();
          break;
        case Keyboard.PageUp:
          event.preventDefault();
          setFocusedOption(options[0]);
          break;
        case Keyboard.PageDown:
          event.preventDefault();
          setFocusedOption(() => {
            const index = options.length - 1;
            return options[index];
          });
          break;
        case Keyboard.Escape:
          setFocusedOption(void 0);
          break;
        case Keyboard.Enter:
          if (focusedOption) {
            updateSelectedOption(focusedOption);
          }
          break;
      }
    };
    return {
      activeElement,
      focusedIndexOption,
      focusedOption,
      handleKeyboard,
      hostRef,
      options,
      optionsRef,
      removeSelectedOption,
      resetSelectedOptions,
      selectedIndexOption,
      selectedOption,
      selectedOptionRef,
      selectedOptions,
      setActiveElement,
      setFocusedOption,
      setMultiple,
      setOptions,
      setSelectedOption,
      setSelectedOptions,
      setUsedAsSupport,
      updateNextOption,
      updatePreviousOption,
      updateSelectedOption,
      usedAsSupport
    };
  };
  const Context = React__default["default"].createContext({});
  const useContext = () => React__default["default"].useContext(Context);
  const Provider = ({ children }) => /* @__PURE__ */ React__default["default"].createElement(Context.Provider, {
    value: useProps()
  }, children);

  const DropDownContent = styled__default$1["default"](Box)`
    display: block;
    position: relative;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    max-height: ${({ maxHeight }) => maxHeight > 0 ? `${maxHeight}px` : "100%"};
    &::-webkit-scrollbar-track {
        border-radius: 0 0 ${defaultTheme$1.radii.xs} 0;
    }
    &:focus {
        outline: none;
    }
`;
  const DropDownContainer = styled__default$1["default"](Box)`
    overflow: hidden;
    border-radius: ${defaultTheme$1.radii.xs};
    background-color: ${defaultTheme$1.colors.neutral["00"]};
    box-shadow: ${defaultTheme$1.shadows["01"]};
    z-index: 10;
    position: absolute;

    &:focus-within {
        > ${DropDownContent} {
            &:focus {
                outline: none;
            }
        }
    }

    &:focus-visible {
        outline: none !important;
    }
`;

  var __defProp$c = Object.defineProperty;
  var __defProps$5 = Object.defineProperties;
  var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
  var __hasOwnProp$c = Object.prototype.hasOwnProperty;
  var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$c = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$c.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    if (__getOwnPropSymbols$c)
      for (var prop of __getOwnPropSymbols$c(b)) {
        if (__propIsEnum$c.call(b, prop))
          __defNormalProp$c(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
  var __objRest$b = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$c)
      for (var prop of __getOwnPropSymbols$c(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  let nextId$1 = 0;
  const DropDownBaseWithoutProvider = (_a, ref) => {
    var _b = _a, {
      open,
      "aria-labelledby": ariaLabelledBy,
      options: optionsProp,
      onSelected,
      onClose,
      maxRows = 4,
      id: propId,
      focusWhenOpened = true,
      filterBy,
      loading,
      multiple,
      defaultValue,
      value: valueProp,
      parentContainerRef,
      handleClickOutside
    } = _b, restProps = __objRest$b(_b, [
      "open",
      "aria-labelledby",
      "options",
      "onSelected",
      "onClose",
      "maxRows",
      "id",
      "focusWhenOpened",
      "filterBy",
      "loading",
      "multiple",
      "defaultValue",
      "value",
      "parentContainerRef",
      "handleClickOutside"
    ]);
    const {
      options,
      setOptions,
      selectedOption,
      handleKeyboard,
      usedAsSupport,
      optionsRef,
      hostRef,
      selectedOptionRef,
      activeElement,
      setActiveElement,
      focusedOption,
      setFocusedOption,
      selectedOptions,
      setMultiple,
      updateSelectedOption,
      setSelectedOptions,
      setSelectedOption
    } = useContext();
    const [firedSelection, setFiredSelection] = React__namespace.useState(false);
    const currentSelectedOption = React__namespace.useMemo(() => multiple ? selectedOptions : selectedOption, [multiple, selectedOption, selectedOptions]);
    const firedDefaultValue = React__namespace.useRef(defaultValue);
    React__namespace.useEffect(() => {
      setMultiple(!!multiple);
    }, [multiple, setMultiple]);
    const updateSelected = React__namespace.useCallback((value) => {
      let innerValue = Array.isArray(value) ? value : [value || {}];
      innerValue = innerValue.filter((item) => optionsProp.some((option) => option.value === item.value));
      if (multiple) {
        setSelectedOptions(innerValue);
      } else {
        setSelectedOption(innerValue[0]);
      }
    }, [multiple, optionsProp, setSelectedOption, setSelectedOptions]);
    React__namespace.useEffect(() => {
      if (firedDefaultValue.current && !valueProp) {
        updateSelected(defaultValue);
        firedDefaultValue.current = defaultValue;
      } else {
        updateSelected(valueProp);
      }
    }, [defaultValue, updateSelected, valueProp]);
    React__namespace.useEffect(() => {
      if (!firedSelection) {
        return;
      }
      if (onSelected) {
        onSelected(currentSelectedOption);
      }
      setFiredSelection(false);
    }, [currentSelectedOption, firedSelection, onSelected]);
    const id = React__namespace.useMemo(() => {
      if (propId) {
        return propId;
      }
      nextId$1 += 1;
      return `${basicUid("d")}_${nextId$1}`;
    }, [propId]);
    const [maxHeight, setMaxHeight] = React__namespace.useState(0);
    const innerOptions = React__namespace.useMemo(() => !optionsProp ? [] : optionsProp.filter((option, index, optionList) => optionList.indexOf(option) === index), [optionsProp]);
    React__namespace.useEffect(() => {
      if (typeof filterBy === "string" && filterBy.length > 0) {
        setFocusedOption(void 0);
        setOptions(filterList(filterBy, innerOptions));
      } else {
        setOptions(innerOptions);
      }
    }, [filterBy, innerOptions, setFocusedOption, setOptions, updateSelectedOption]);
    React__namespace.useEffect(() => {
      var _a2;
      let innerActiveElement = null;
      if (open) {
        innerActiveElement = document.activeElement;
        if (focusWhenOpened && !usedAsSupport) {
          (_a2 = hostRef.current) == null ? void 0 : _a2.focus();
        }
      }
      setActiveElement(innerActiveElement);
      return () => {
        if (!usedAsSupport) {
          innerActiveElement == null ? void 0 : innerActiveElement.focus();
        }
      };
    }, [focusWhenOpened, hostRef, setActiveElement, usedAsSupport, open]);
    React__namespace.useEffect(() => {
      let innerMaxHeight = 0;
      optionsRef.forEach((optionRef, index) => {
        var _a2;
        const { current } = optionRef;
        if (!current) {
          return;
        }
        innerMaxHeight += current.offsetHeight;
        current.removeAttribute("tabindex");
        (_a2 = current.querySelector("input")) == null ? void 0 : _a2.setAttribute("tabindex", "-1");
        if (index + 1 === maxRows) {
          setMaxHeight(innerMaxHeight);
        }
      });
    }, [maxRows, optionsRef, open]);
    React__namespace.useEffect(() => {
      const { current: hostElement } = hostRef;
      if (hostElement && selectedOptionRef && hostElement.scrollHeight > hostElement.clientHeight) {
        const scrollBottom = hostElement.clientHeight + hostElement.scrollTop;
        const targetBottom = selectedOptionRef.offsetTop + selectedOptionRef.offsetHeight;
        if (targetBottom > scrollBottom) {
          hostElement.scrollTop = targetBottom - hostElement.clientHeight;
        } else if (selectedOptionRef.offsetTop < hostElement.scrollTop) {
          hostElement.scrollTop = selectedOptionRef.offsetTop;
        }
      }
    }, [selectedOptionRef, hostRef, open]);
    const handleClose = () => {
      setFocusedOption(void 0);
      if (onClose) {
        onClose(activeElement);
      }
    };
    const handleKeyDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const keyCode = getKeyOfKeyboard(event);
      handleKeyboard(keyCode, event);
      switch (keyCode) {
        case Keyboard.Enter:
          if (!multiple) {
            handleClose();
          }
          break;
        case Keyboard.Escape:
          handleClose();
          break;
      }
    };
    React__namespace.useImperativeHandle(ref, () => ({
      currentSelectedOption,
      setFiredSelection
    }));
    const containerRef = React__namespace.useRef(null);
    React__namespace.useEffect(() => {
      const handleOutsideContainerClick = (evt) => {
        var _a2, _b2;
        const containerRect = (_a2 = containerRef.current) == null ? void 0 : _a2.getBoundingClientRect();
        const parentContainerRect = (_b2 = parentContainerRef == null ? void 0 : parentContainerRef.current) == null ? void 0 : _b2.getBoundingClientRect();
        if (open && containerRect && parentContainerRect) {
          const clickedOutsideX = evt.clientX < containerRect.left || evt.clientX > containerRect.right;
          const clickedOutsideY = evt.clientY < containerRect.top || evt.clientY > containerRect.bottom;
          const parentClickedOutsideX = evt.clientX < parentContainerRect.left || evt.clientX > parentContainerRect.right;
          const parentClickedOutsideY = evt.clientY < parentContainerRect.top || evt.clientY > parentContainerRect.bottom;
          if (clickedOutsideX && parentClickedOutsideX || clickedOutsideY && parentClickedOutsideY) {
            handleClickOutside && handleClickOutside(false);
          }
        }
      };
      window.addEventListener("click", handleOutsideContainerClick);
      return () => window.removeEventListener("click", handleOutsideContainerClick);
    }, [containerRef, open, handleClickOutside, parentContainerRef]);
    if (!open) {
      return null;
    }
    return /* @__PURE__ */ React__namespace.createElement(DropDownContainer, __spreadProps$5(__spreadValues$c({}, restProps), {
      ref: containerRef
    }), /* @__PURE__ */ React__namespace.createElement(DropDownContent, {
      "aria-activedescendant": !usedAsSupport ? selectedOptionRef == null ? void 0 : selectedOptionRef.id : void 0,
      "aria-expanded": open,
      "aria-labelledby": ariaLabelledBy,
      id,
      maxHeight,
      onBlur: () => {
        handleClose();
      },
      onKeyDown: handleKeyDown,
      ref: hostRef,
      role: "listbox",
      tabIndex: usedAsSupport ? void 0 : -1
    }, options.map((option, index) => /* @__PURE__ */ React__namespace.createElement(Option, {
      focused: (focusedOption == null ? void 0 : focusedOption.value) === option.value,
      key: option.value,
      multiple,
      onClick: () => {
        if (!option.disabled) {
          setFiredSelection(true);
          if (!multiple) {
            handleClose();
          }
          updateSelectedOption(option);
        }
      },
      ref: optionsRef[index],
      selected: multiple ? selectedOptions.some((selected) => selected.value === option.value) : (selectedOption == null ? void 0 : selectedOption.value) === option.value,
      value: option
    }))), loading && /* @__PURE__ */ React__namespace.createElement(Box, {
      sx: { alignItems: "center", display: "flex", justifyContent: "center" }
    }, /* @__PURE__ */ React__namespace.createElement(Spinner, {
      size: "sm"
    })));
  };
  const DropDownWithoutProvider = React__namespace.forwardRef(DropDownBaseWithoutProvider);
  const DropDownComponent = React__namespace.forwardRef((props, ref) => /* @__PURE__ */ React__namespace.createElement(Provider, null, /* @__PURE__ */ React__namespace.createElement(DropDownWithoutProvider, __spreadProps$5(__spreadValues$c({}, props), {
    ref
  }))));

  const Select$1 = styled__default$1["default"](Box)`
    position: relative;

    input {
        ${cssTextEllipsisOneLine}
    }
`;
  const DropDown = styled__default$1["default"](DropDownWithoutProvider)`
    border-radius: ${`0 0 ${defaultTheme$1.radii.xs} ${defaultTheme$1.radii.xs}`};
    position: absolute;
    width: 100%;

    ${({ positionTop }) => !!positionTop && styled.css`
            border-radius: ${defaultTheme$1.radii.xs};
            bottom: ${positionTop + Number(defaultTheme$1.space.stack.nano.replace("px", ""))}px;
            ${DropDownContent} {
                &::-webkit-scrollbar-track {
                    border-radius: 0 ${defaultTheme$1.radii.xs} ${defaultTheme$1.radii.xs} 0;
                }
            }
        `}
`;

  const setReactInputValue = (input, value, trackerValue) => {
    input.value = value;
    const inputGeneric = input;
    const tracker = inputGeneric._valueTracker;
    if (tracker && tracker.setValue) {
      tracker.setValue(trackerValue);
    } else {
      throw new Error("Not found prop _valueTracker in input");
    }
  };
  const dispatchChangeInputEvent = (element, newValue, trackerValue = element.value) => {
    setReactInputValue(element, newValue, trackerValue);
    const event = new Event("input", { bubbles: true });
    element.dispatchEvent(event);
  };

  const StyledChipInput = styled__default$1["default"](ChipInput)`
    max-width: 120px;

    p {
        ${cssTextEllipsisOneLine}
    }
`;
  const StyledChipStatic = styled__default$1["default"](ChipStatic)`
    p {
        ${cssTextEllipsisOneLine}
    }
`;

  var __defProp$b = Object.defineProperty;
  var __defProps$4 = Object.defineProperties;
  var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
  var __hasOwnProp$b = Object.prototype.hasOwnProperty;
  var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$b = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$b.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    if (__getOwnPropSymbols$b)
      for (var prop of __getOwnPropSymbols$b(b)) {
        if (__propIsEnum$b.call(b, prop))
          __defNormalProp$b(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
  var __objRest$a = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$b.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$b)
      for (var prop of __getOwnPropSymbols$b(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$b.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const SelectChips = (_a) => {
    var _b = _a, {
      brand,
      disabled,
      options,
      maxVisible = 1,
      onWidth,
      onClose,
      inputElement,
      sx,
      variantSize
    } = _b, props = __objRest$a(_b, [
      "brand",
      "disabled",
      "options",
      "maxVisible",
      "onWidth",
      "onClose",
      "inputElement",
      "sx",
      "variantSize"
    ]);
    const containerRef = React__default["default"].useRef(null);
    const [optionsVisible, setOptionsVisible] = React__default["default"].useState(options);
    const [optionsRestCount, setOptionsRestCount] = React__default["default"].useState(0);
    const widthRef = React__default["default"].useRef(0);
    React__default["default"].useEffect(() => {
      var _a2;
      if (onWidth) {
        const width = (_a2 = containerRef.current) == null ? void 0 : _a2.getBoundingClientRect().width;
        if (widthRef.current !== width) {
          widthRef.current = width || 0;
          onWidth(width);
        }
      }
    }, [onWidth]);
    React__default["default"].useEffect(() => {
      if (maxVisible >= 0 && options) {
        const innerOptions = [...options];
        setOptionsVisible(innerOptions.splice(0, maxVisible));
        setOptionsRestCount(innerOptions.length);
      } else {
        setOptionsVisible(options);
      }
    }, [maxVisible, options]);
    React__default["default"].useEffect(() => {
      var _a2;
      (_a2 = containerRef.current) == null ? void 0 : _a2.querySelectorAll("span").forEach((element) => {
        element.removeAttribute("tabindex");
      });
    }, [options]);
    const [leftOffset, setLeftOffset] = React__default["default"].useState(0);
    React__default["default"].useEffect(() => {
      var _a2;
      const labelElement = (_a2 = inputElement == null ? void 0 : inputElement.parentElement) == null ? void 0 : _a2.querySelector("label");
      if ((labelElement == null ? void 0 : labelElement.offsetWidth) !== leftOffset) {
        setLeftOffset((labelElement == null ? void 0 : labelElement.offsetWidth) || 0);
      }
    }, [leftOffset, inputElement]);
    if (!(optionsVisible == null ? void 0 : optionsVisible.length)) {
      return null;
    }
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$4(__spreadValues$b({
      ref: containerRef,
      role: "listbox"
    }, props), {
      sx: __spreadValues$b({
        alignItems: "center",
        bottom: 0,
        display: "flex",
        height: variantSize === "sm" ? "100%" : void 0,
        left: variantSize === "sm" ? leftOffset : 0,
        padding: "squish.nano",
        paddingLeft: variantSize === "sm" ? "inline.nano" : void 0,
        position: "absolute",
        zIndex: 1
      }, sx)
    }), optionsVisible.map((option, index) => /* @__PURE__ */ React__default["default"].createElement(StyledChipInput, {
      brand,
      disabled,
      key: option.value,
      label: option.label,
      onClose: () => {
        if (onClose) {
          onClose(index);
        }
      },
      role: "option",
      sx: { ml: index === 0 ? void 0 : "inset.nano" },
      tabIndex: 0,
      variant: "sm"
    })), !!optionsRestCount && /* @__PURE__ */ React__default["default"].createElement(StyledChipStatic, {
      brand,
      disabled,
      label: `+${optionsRestCount}`,
      sx: { ml: "inset.nano" },
      variant: "sm"
    }));
  };

  var __defProp$a = Object.defineProperty;
  var __defProps$3 = Object.defineProperties;
  var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
  var __hasOwnProp$a = Object.prototype.hasOwnProperty;
  var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$a = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$a.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    if (__getOwnPropSymbols$a)
      for (var prop of __getOwnPropSymbols$a(b)) {
        if (__propIsEnum$a.call(b, prop))
          __defNormalProp$a(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
  var __objRest$9 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$a)
      for (var prop of __getOwnPropSymbols$a(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  let nextId = 0;
  const SelectBase = (_a) => {
    var _b = _a, {
      options: optionsProp,
      id: parentId,
      inputId: propId,
      variant = "default",
      dropdownProps,
      supportMessage,
      label,
      placeholder,
      required,
      multiple,
      className,
      maxRows,
      defaultValue,
      value: valueProp,
      loading,
      maxChips,
      onSelected,
      onBlur,
      onFocus,
      onChange,
      name,
      inputRef: inputRefProp,
      maskConfig
    } = _b, props = __objRest$9(_b, [
      "options",
      "id",
      "inputId",
      "variant",
      "dropdownProps",
      "supportMessage",
      "label",
      "placeholder",
      "required",
      "multiple",
      "className",
      "maxRows",
      "defaultValue",
      "value",
      "loading",
      "maxChips",
      "onSelected",
      "onBlur",
      "onFocus",
      "onChange",
      "name",
      "inputRef",
      "maskConfig"
    ]);
    var _a2, _b2, _c;
    const {
      hostRef,
      setUsedAsSupport,
      handleKeyboard,
      selectedOptionRef,
      selectedOption,
      setFocusedOption,
      selectedOptions,
      removeSelectedOption,
      updateSelectedOption,
      focusedOption
    } = useContext();
    const [open, setOpen] = React__namespace.useState(false);
    const [filter, setFilter] = React__namespace.useState();
    const [inputValue, setInputValue] = React__namespace.useState("");
    React__namespace.useEffect(() => {
      if (!multiple && (!valueProp || valueProp && !valueProp.value)) {
        setInputValue(maskConfig ? IMask__default["default"].pipe("", maskConfig) : "");
      }
    }, [multiple, valueProp, maskConfig]);
    const valuePropRef = React__namespace.useRef(valueProp);
    React__namespace.useEffect(() => {
      if (!valuePropRef.current && valueProp && !Array.isArray(valueProp) || valuePropRef.current && valueProp && !Array.isArray(valuePropRef.current) && !Array.isArray(valueProp) && valuePropRef.current.value !== valueProp.value) {
        setInputValue(maskConfig ? IMask__default["default"].pipe(valueProp.label, maskConfig) : valueProp.label);
        valuePropRef.current = valueProp;
      }
    }, [valueProp, maskConfig]);
    const [containerChipsWidth, setContainerChipsWidth] = React__namespace.useState();
    const [containsMouseDown, setcontainsMouseDown] = React__namespace.useState(false);
    const [triggerInputFocus, setTriggerInputFocus] = React__namespace.useState();
    const [firedFocus, setFiredFocus] = React__namespace.useState(false);
    const [isDropUp, setIsDropUp] = React__namespace.useState(false);
    const inputId = React__namespace.useMemo(() => {
      if (propId) {
        return propId;
      }
      nextId += 1;
      return `${basicUid("s")}_${nextId}`;
    }, [propId]);
    const labelId = `l_${inputId}`;
    const inputRef = React__namespace.useRef(null);
    const selectContainerRef = React__namespace.useRef(null);
    const dropdownStateRef = React__namespace.useRef(null);
    const initialValue = React__namespace.useRef(true);
    const supportMessageVariant = React__namespace.useMemo(() => {
      switch (variant) {
        case "error":
          return "invalid";
        case "success":
          return "valid";
        default:
          return "default";
      }
    }, [variant]);
    React__namespace.useEffect(() => {
      if (selectedOption && initialValue.current && !multiple) {
        setInputValue(maskConfig ? IMask__default["default"].pipe(selectedOption.label, maskConfig) : selectedOption.label);
        initialValue.current = false;
      }
    }, [multiple, selectedOption, maskConfig]);
    const updateCheckDropUp = () => {
      if (selectContainerRef.current && hostRef.current) {
        setIsDropUp(toggleDropUp(selectContainerRef.current, hostRef.current));
      }
    };
    React__namespace.useLayoutEffect(() => {
      updateCheckDropUp();
    });
    React__namespace.useEffect(() => {
      var _a3;
      (_a3 = document.querySelector(`[for="${inputId}"]`)) == null ? void 0 : _a3.setAttribute("id", labelId);
    }, [inputId, labelId]);
    React__namespace.useEffect(() => {
      if (!open) {
        setFilter(void 0);
      }
    }, [open]);
    React__namespace.useEffect(() => {
      var _a3;
      if (multiple) {
        if (!open) {
          setTriggerInputFocus(!!selectedOptions.length);
        } else {
          setFilter(void 0);
          (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
        }
      }
    }, [open, multiple, selectedOptions]);
    React__namespace.useEffect(() => {
      setUsedAsSupport(true);
    }, [setUsedAsSupport]);
    const handleInputKeyDown = (event) => {
      var _a3;
      const keyCode = getKeyOfKeyboard(event);
      handleKeyboard(keyCode, event);
      switch (keyCode) {
        case Keyboard.ArrowUp:
          event.preventDefault();
          setOpen(true);
          break;
        case Keyboard.Escape:
        case Keyboard.Tab:
          setOpen(false);
          break;
        case Keyboard.Enter:
          event.preventDefault();
          if (focusedOption) {
            (_a3 = dropdownStateRef.current) == null ? void 0 : _a3.setFiredSelection(true);
          }
          setOpen((previous) => {
            if (multiple && previous) {
              return previous;
            }
            return !previous;
          });
          break;
        case Keyboard.Backspace:
          if (multiple && !inputValue.length && selectedOptions.length) {
            removeSelectedOption(-1);
            if (inputRef.current) {
              dispatchChangeInputEvent(inputRef.current, "", " ");
            }
          }
          break;
        default:
          setOpen(true);
          break;
      }
    };
    const handleInputKeyUp = (event) => {
      const keyCode = getKeyOfKeyboard(event);
      if (keyCode === Keyboard.Backspace) {
        setOpen(true);
        return;
      }
      return;
    };
    const handleInputChange = (event) => {
      var _a3;
      const { value } = event.target;
      const valueFormatted = value.replace(/^\s+/g, "").replace(/\s+/g, " ");
      setInputValue(maskConfig ? IMask__default["default"].pipe(valueFormatted, maskConfig) : valueFormatted);
      setFilter(valueFormatted);
      const isEmptyValue = !valueFormatted;
      if (isEmptyValue) {
        updateSelectedOption();
      }
      if (onChange) {
        const selected = (_a3 = dropdownStateRef.current) == null ? void 0 : _a3.currentSelectedOption;
        if (Array.isArray(selected)) {
          onChange(event, selected.length ? selected : void 0);
        } else if (selected == null ? void 0 : selected.label) {
          onChange(event, isEmptyValue ? void 0 : selected);
        } else {
          onChange(event, void 0);
        }
      }
    };
    const handleSelected = React__namespace.useCallback((selected) => {
      if (onSelected) {
        onSelected(selected);
      }
      if (inputRef.current) {
        if (Array.isArray(selected)) {
          dispatchChangeInputEvent(inputRef.current, "", " ");
        } else {
          dispatchChangeInputEvent(inputRef.current, (selected == null ? void 0 : selected.label) || "");
        }
      }
    }, [onSelected]);
    const handleClose = () => {
      var _a3;
      if (!multiple) {
        setOpen(false);
        (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
      }
    };
    const handleMouseDown = (event) => {
      var _a3;
      if (event.button !== 0 || props.disabled) {
        return;
      }
      if (event.target === inputRef.current) {
        setOpen(!open);
      } else if ((_a3 = selectContainerRef.current) == null ? void 0 : _a3.contains(event.target)) {
        setcontainsMouseDown(true);
        setTriggerInputFocus(true);
      }
    };
    const handleChipsWidth = (size) => {
      setContainerChipsWidth(size);
    };
    const handleChipsClose = (indexTarget) => {
      var _a3;
      (_a3 = dropdownStateRef.current) == null ? void 0 : _a3.setFiredSelection(true);
      removeSelectedOption(indexTarget);
      setOpen(true);
    };
    const handleInputFocus = (event) => {
      if (props.disabled) {
        return;
      }
      if (!firedFocus) {
        if (onFocus) {
          onFocus(event);
        }
        setFiredFocus(true);
        setcontainsMouseDown(false);
      }
    };
    const handleInputBlur = (event) => {
      if (props.disabled) {
        return;
      }
      if (containsMouseDown) {
        setcontainsMouseDown(false);
      } else {
        setFocusedOption(void 0);
        setOpen(false);
        setFiredFocus(false);
        setTriggerInputFocus(!!selectedOptions.length);
        if (multiple) {
          setInputValue(maskConfig ? IMask__default["default"].pipe("", maskConfig) : "");
        } else if (inputValue !== (selectedOption == null ? void 0 : selectedOption.label)) {
          setInputValue(maskConfig ? IMask__default["default"].pipe((selectedOption == null ? void 0 : selectedOption.label) || "", maskConfig) : (selectedOption == null ? void 0 : selectedOption.label) || "");
        }
        if (onBlur) {
          onBlur(event);
        }
      }
    };
    const handleInputRef = (node) => {
      inputRef.current = node;
      if (!inputRefProp) {
        return;
      }
      if (typeof inputRefProp === "function") {
        inputRefProp(node);
      } else if (inputRefProp) {
        inputRefProp.current = node;
      }
    };
    return /* @__PURE__ */ React__namespace.createElement(React__namespace.Fragment, null, /* @__PURE__ */ React__namespace.createElement(Select$1, {
      "aria-expanded": open,
      "aria-haspopup": open ? "listbox" : void 0,
      "aria-owns": open ? (_a2 = hostRef.current) == null ? void 0 : _a2.id : void 0,
      className,
      id: parentId,
      onMouseDown: handleMouseDown,
      ref: selectContainerRef,
      role: "combobox",
      sx: props.sx,
      width: props.width
    }, /* @__PURE__ */ React__namespace.createElement(Box, {
      sx: { position: "relative", width: props.width }
    }, multiple && /* @__PURE__ */ React__namespace.createElement(SelectChips, {
      brand: props.brand,
      disabled: props.disabled,
      inputElement: inputRef.current,
      maxVisible: maxChips,
      onClose: handleChipsClose,
      onWidth: handleChipsWidth,
      options: selectedOptions,
      variantSize: props.variantSize
    }), /* @__PURE__ */ React__namespace.createElement(Input, __spreadProps$3(__spreadValues$a({
      "aria-activedescendant": open ? selectedOptionRef == null ? void 0 : selectedOptionRef.id : void 0,
      "aria-autocomplete": "list",
      "aria-controls": open ? (_b2 = hostRef.current) == null ? void 0 : _b2.id : void 0,
      autoCapitalize: "none",
      autoComplete: "off",
      id: inputId,
      label,
      placeholder,
      required,
      style: {
        paddingLeft: containerChipsWidth
      },
      trailingIcon: /* @__PURE__ */ React__namespace.createElement(Icon, {
        size: "sm"
      }, open ? /* @__PURE__ */ React__namespace.createElement(almaIcons.ChevronUp, null) : /* @__PURE__ */ React__namespace.createElement(almaIcons.ChevronDown, null)),
      triggerFocus: triggerInputFocus,
      value: inputValue,
      variant
    }, props), {
      name,
      onBlur: handleInputBlur,
      onChange: handleInputChange,
      onFocus: handleInputFocus,
      onKeyDown: handleInputKeyDown,
      onKeyUp: handleInputKeyUp,
      ref: handleInputRef
    }))), /* @__PURE__ */ React__namespace.createElement(DropDown, __spreadProps$3(__spreadValues$a({
      "aria-labelledby": labelId,
      defaultValue,
      filterBy: filter,
      loading,
      maxRows,
      multiple,
      onClose: handleClose,
      onSelected: handleSelected,
      options: optionsProp,
      positionTop: isDropUp ? (_c = inputRef.current) == null ? void 0 : _c.getBoundingClientRect().height : 0,
      ref: dropdownStateRef
    }, dropdownProps), {
      handleClickOutside: (openState) => setOpen(openState),
      open,
      parentContainerRef: selectContainerRef,
      value: valueProp
    })), /* @__PURE__ */ React__namespace.createElement(Wrap, null, typeof supportMessage === "string" ? /* @__PURE__ */ React__namespace.createElement(SupportMessage, {
      brand: props.brand,
      disabled: props.disabled,
      value: supportMessage,
      variant: supportMessageVariant
    }) : supportMessage == null ? void 0 : supportMessage.map((suptMsg, i) => /* @__PURE__ */ React__namespace.createElement(WrapItem, {
      key: i,
      mb: "inline.quark",
      mr: "inline.nano"
    }, /* @__PURE__ */ React__namespace.createElement(SupportMessage, {
      brand: props.brand,
      disabled: props.disabled,
      tabIndex: i,
      value: suptMsg,
      variant: supportMessageVariant
    }))))), name && selectedOptions.map((option) => /* @__PURE__ */ React__namespace.createElement("input", {
      hidden: true,
      key: option.value,
      name,
      readOnly: true,
      value: option.value
    })));
  };
  const Select = (props) => /* @__PURE__ */ React__namespace.createElement(Provider, null, /* @__PURE__ */ React__namespace.createElement(SelectBase, __spreadValues$a({}, props)));

  const boxGridStyle = () => ({
    height: "100%",
    position: "relative",
    width: "100%"
  });

  var __defProp$9 = Object.defineProperty;
  var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
  var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
  var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$9 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$9.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    if (__getOwnPropSymbols$9)
      for (var prop of __getOwnPropSymbols$9(b)) {
        if (__propIsEnum$9.call(b, prop))
          __defNormalProp$9(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$8 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$9)
      for (var prop of __getOwnPropSymbols$9(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const SimpleGrid = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { children, sx } = _b, props = __objRest$8(_b, ["children", "sx"]);
    const _a2 = props, { columns, spacingX, spacingY, spacing, minChildWidth } = _a2, rest = __objRest$8(_a2, ["columns", "spacingX", "spacingY", "spacing", "minChildWidth"]);
    const templateColumns = minChildWidth ? `repeat(auto-fit, minmax(${minChildWidth}px, 1fr))` : void 0;
    const renderChildrens = () => {
      if (Array.isArray(children)) {
        return children.map((value, idx) => /* @__PURE__ */ React__default["default"].createElement(GridItem, {
          key: idx
        }, value));
      }
      return children;
    };
    return /* @__PURE__ */ React__default["default"].createElement(Grid, __spreadValues$9({
      columns,
      gap: spacing,
      gridColumnGap: spacingX,
      gridRowGap: spacingY,
      gridTemplateColumns: templateColumns,
      ref,
      sx: __spreadValues$9(__spreadValues$9({}, boxGridStyle()), sx)
    }, rest), renderChildrens());
  });

  var __defProp$8 = Object.defineProperty;
  var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
  var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
  var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$8 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$8.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    if (__getOwnPropSymbols$8)
      for (var prop of __getOwnPropSymbols$8(b)) {
        if (__propIsEnum$8.call(b, prop))
          __defNormalProp$8(a, prop, b[prop]);
      }
    return a;
  };
  const Multiselect = (props) => /* @__PURE__ */ React__default["default"].createElement(Select, __spreadValues$8({
    multiple: true
  }, props));

  const getShapeStyle = (label, variantSize, hover, focus, active, controledOpen) => {
    const getShapeWidth = () => {
      if (!label) {
        return variantSize === "lg" ? 48 : 32;
      }
      return "fit-content";
    };
    const getShapeBackgroundColor = () => {
      if (active || controledOpen) {
        return "interaction.blend.02";
      } else if (hover || focus) {
        return "interaction.blend.01";
      }
      return "transparent";
    };
    const getShapePadding = () => {
      if (label) {
        return variantSize === "lg" ? "inline.xxxs" : "inline.nano";
      }
      return null;
    };
    return {
      alignItems: "center",
      backgroundColor: getShapeBackgroundColor(),
      borderColor: focus && !active ? "interaction.select.focus" : "transparent",
      borderRadius: "xs",
      borderStyle: "solid",
      borderWidth: "thin",
      cursor: "pointer",
      display: "flex",
      height: variantSize === "lg" ? 48 : 32,
      justifyContent: "center",
      paddingLeft: getShapePadding(),
      paddingRight: getShapePadding(),
      width: getShapeWidth()
    };
  };
  const getTextStyle = (disabled, trailingIcon, hover, focus, active, controledOpen) => {
    const getTextColor = () => {
      if (disabled) {
        return "typeface.meld";
      } else if (active || controledOpen) {
        return "interaction.select.active";
      } else if (hover || focus) {
        return "interaction.select.focus";
      }
      return "interaction.select.default";
    };
    return {
      color: getTextColor(),
      marginRight: trailingIcon ? "inline.nano" : void 0
    };
  };
  const getIconStyle = (disabled, hover, focus, active, controledOpen) => {
    const getIconColor = () => {
      if (disabled) {
        return "interaction.blend.05";
      } else if (active || controledOpen) {
        return "interaction.select.active";
      } else if (hover || focus) {
        return "interaction.select.focus";
      }
      return "interaction.select.default";
    };
    return {
      color: getIconColor()
    };
  };

  var __defProp$7 = Object.defineProperty;
  var __defProps$2 = Object.defineProperties;
  var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
  var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
  var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$7 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$7.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    if (__getOwnPropSymbols$7)
      for (var prop of __getOwnPropSymbols$7(b)) {
        if (__propIsEnum$7.call(b, prop))
          __defNormalProp$7(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
  var __objRest$7 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$7)
      for (var prop of __getOwnPropSymbols$7(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Menu = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, {
      disabled,
      dropdownProps,
      label,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      onMouseUp,
      open,
      sx,
      trailingIcon,
      variantSize
    } = _b, props = __objRest$7(_b, [
      "disabled",
      "dropdownProps",
      "label",
      "onBlur",
      "onClick",
      "onFocus",
      "onKeyDown",
      "onMouseDown",
      "onMouseEnter",
      "onMouseLeave",
      "onMouseUp",
      "open",
      "sx",
      "trailingIcon",
      "variantSize"
    ]);
    const [active, setActive] = React__default["default"].useState(false);
    const [focus, setFocus] = React__default["default"].useState(false);
    const [hover, setHover] = React__default["default"].useState(false);
    const [controledOpen, setControledOpen] = React__default["default"].useState(false);
    const handleKeyDown = (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      const keyCode = evt.key.trim() ? evt.key : evt.code;
      switch (keyCode) {
        case "Space":
          !disabled && setControledOpen(!controledOpen);
          break;
      }
    };
    const wrapperRef = React__default["default"].useRef(null);
    return /* @__PURE__ */ React__default["default"].createElement(Box, {
      ref: (containerRef) => {
        if (ref && typeof ref !== "function") {
          ref.current = containerRef;
          wrapperRef.current = ref.current;
        }
      },
      sx
    }, /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$2(__spreadValues$7({
      tabIndex: disabled ? -1 : 0
    }, props), {
      onBlur: (evt) => {
        if (onBlur) {
          onBlur(evt);
        }
        !disabled && setFocus(false);
      },
      onClick: (evt) => {
        if (onClick) {
          onClick(evt);
        }
        !disabled && setControledOpen(!controledOpen);
      },
      onFocus: (evt) => {
        if (onFocus) {
          onFocus(evt);
        }
        !disabled && setFocus(true);
      },
      onKeyDown: (evt) => {
        if (onKeyDown) {
          onKeyDown(evt);
        }
        !disabled && handleKeyDown(evt);
      },
      onMouseDown: (evt) => {
        if (onMouseDown) {
          onMouseDown(evt);
        }
        !disabled && setActive(true);
      },
      onMouseEnter: (evt) => {
        if (onMouseEnter) {
          onMouseEnter(evt);
        }
        !disabled && setHover(true);
      },
      onMouseLeave: (evt) => {
        if (onMouseLeave) {
          onMouseLeave(evt);
        }
        !disabled && setHover(false);
      },
      onMouseUp: (evt) => {
        if (onMouseUp) {
          onMouseUp(evt);
        }
        !disabled && setActive(false);
        !disabled && setFocus(false);
      },
      sx: getShapeStyle(label, variantSize, hover, focus, active, controledOpen)
    }), label && /* @__PURE__ */ React__default["default"].createElement(TextInteraction, {
      sx: getTextStyle(disabled, trailingIcon, hover, focus, active, controledOpen),
      variant: "md"
    }, label), trailingIcon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      size: "md",
      sx: getIconStyle(disabled, hover, focus, active, controledOpen)
    }, trailingIcon)), /* @__PURE__ */ React__default["default"].createElement(DropDownComponent, __spreadProps$2(__spreadValues$7({
      focusWhenOpened: false
    }, dropdownProps), {
      handleClickOutside: (openState) => setControledOpen(openState),
      open: typeof open !== "undefined" ? open : controledOpen,
      parentContainerRef: wrapperRef
    })));
  });

  const StyledDatepickerContainer = styled__default$1["default"](Box)`
    .react-datepicker {
        &-popper {
            z-index: ${({ zIndex = 1 }) => zIndex};
        }

        &__portal {
            width: 100vw;
            height: 100vh;
            position: fixed;
            left: 0;
            top: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            background: ${defaultTheme$1.colors.typeface.meld};
            z-index: ${({ zIndex }) => zIndex};
        }

        &__month-container {
            margin-right: 48px;

            &:last-child {
                margin-right: 0;
            }
        }

        &__day-names {
            display: block;
            white-space: nowrap;
            border-bottom: 1px solid ${defaultTheme$1.colors.neutral[30]};
        }

        &__week {
            display: block;
            white-space: nowrap;
        }

        &__day--in-selecting-range {
            background-color: ${defaultTheme$1.colors.interaction.subtle["01"]};
        }

        &__day-name,
        &__day {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 44px;

            &:not(:empty) {
                height: 44px;
            }

            & p {
                color: ${defaultTheme$1.colors.typeface.smooth};
                border-bottom: 1px solid transparent;
            }
        }

        &__day {
            cursor: pointer;
        }

        &__day:focus:not(.react-datepicker__day--excluded),
        &__day--selected,
        &__day--selecting-range-start,
        &__day--selecting-range-end,
        &__day--selecting-range-start.react-datepicker__day--selecting-range-end,
        &__day--selected.react-datepicker__day--outside-month {
            background-color: ${defaultTheme$1.colors.interaction.select.active};
            border-radius: ${defaultTheme$1.radii.xs};

            & p {
                color: ${defaultTheme$1.colors.interaction.on.brand.select.active};
            }

            &.react-datepicker__day--today {
                & p {
                    box-sizing: border-box;
                    border-bottom: 1px solid ${defaultTheme$1.colors.interaction.on.brand.select.active};
                }
            }
        }

        &__day--outside-month,
        &__day--excluded {
            & p {
                color: ${defaultTheme$1.colors.typeface.meld};
            }
        }

        &__day--selecting-range-start {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;

            & p {
                color: ${defaultTheme$1.colors.interaction.on.brand.select.active};
            }
        }

        &__day--selecting-range-end {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;

            & p {
                color: ${defaultTheme$1.colors.interaction.on.brand.select.active};
            }
        }

        &__day--today {
            & p {
                box-sizing: border-box;
                border-bottom: 1px solid ${defaultTheme$1.colors.interaction.select.default};
            }
        }
        &__aria-live {
            display: none;
        }
    }
`;
  const getCalendarContainerStyle = () => ({
    backgroundColor: "neutral.00",
    borderColor: "neutral.20",
    borderRadius: "xs",
    borderStyle: "solid",
    borderWidth: "hairline",
    boxShadow: "01",
    boxSizing: "border-box",
    display: "flex",
    padding: "inset.xs",
    position: "relative"
  });
  const getCalendarHeaderStyle = () => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between"
  });
  const getYearSelectTabStyle = () => ({
    margin: "0 auto",
    width: "100%"
  });

  var __defProp$6 = Object.defineProperty;
  var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
  var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
  var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$6 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$6.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    if (__getOwnPropSymbols$6)
      for (var prop of __getOwnPropSymbols$6(b)) {
        if (__propIsEnum$6.call(b, prop))
          __defNormalProp$6(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$6 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$6)
      for (var prop of __getOwnPropSymbols$6(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const headingSxVariantStyle = {
    lg: {
      fontSize: "lg"
    },
    md: {
      fontSize: "md",
      letterSpacing: "standard"
    },
    sm: {
      fontSize: "sm",
      letterSpacing: "standard",
      lineHeight: "distant"
    },
    xl: {
      fontSize: "xl",
      lineHeight: "medium"
    },
    xxl: {
      fontSize: "xxl",
      lineHeight: "large"
    },
    xxxl: {
      fontSize: "xxxl",
      lineHeight: "large"
    }
  };
  const Heading = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant = "lg" } = _b, props = __objRest$6(_b, ["variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues$6({
      as: "h1",
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontWeight: "bold",
      letterSpacing: "small",
      lineHeight: "large",
      ref,
      sx: __spreadValues$6({}, headingSxVariantStyle[variant])
    }, props));
  });

  var __defProp$5 = Object.defineProperty;
  var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
  var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
  var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$5 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$5.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    if (__getOwnPropSymbols$5)
      for (var prop of __getOwnPropSymbols$5(b)) {
        if (__propIsEnum$5.call(b, prop))
          __defNormalProp$5(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$5 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$5)
      for (var prop of __getOwnPropSymbols$5(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Calendar = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, {
      monthsShown = 1,
      showYearSelect,
      variant = "default",
      value,
      yearSelectEnd,
      yearSelectStart,
      zIndex,
      onChange,
      selected
    } = _b, props = __objRest$5(_b, [
      "monthsShown",
      "showYearSelect",
      "variant",
      "value",
      "yearSelectEnd",
      "yearSelectStart",
      "zIndex",
      "onChange",
      "selected"
    ]);
    const customHeader = ({
      changeYear,
      changeMonth,
      date,
      customHeaderCount,
      decreaseMonth,
      increaseMonth,
      monthDate,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled
    }, activeYearSelectTab2, setActiveYearSelectTab2) => {
      const shouldRenderLeftArrow = customHeaderCount === 0;
      const shouldRenderRightArrow = customHeaderCount === monthsShown - 1;
      const getYears = () => {
        const startYear = yearSelectStart ? yearSelectStart : new Date().getFullYear() - 100;
        const endYear = yearSelectEnd ? yearSelectEnd : new Date().getFullYear();
        const years = range$1(startYear, endYear + 1);
        return years.map((year) => ({ label: year.toString(), value: year.toString() }));
      };
      const getMonths = () => months.map((key) => ({ label: key, value: key }));
      return /* @__PURE__ */ React__default["default"].createElement(Box, null, showYearSelect && /* @__PURE__ */ React__default["default"].createElement(Box, null, /* @__PURE__ */ React__default["default"].createElement(Box, {
        sx: getYearSelectTabStyle()
      }, /* @__PURE__ */ React__default["default"].createElement(TabContainer, {
        mb: "inset.nano"
      }, (variant === "default" || variant === "without-year") && /* @__PURE__ */ React__default["default"].createElement(Tab, {
        active: activeYearSelectTab2 === "day",
        id: "year-select-tab-day",
        label: "Dia",
        onClick: () => setActiveYearSelectTab2("day"),
        tabName: "day"
      }), /* @__PURE__ */ React__default["default"].createElement(Tab, {
        active: activeYearSelectTab2 === "month",
        id: "year-select-tab-month",
        label: "M\xEAs",
        onClick: () => setActiveYearSelectTab2("month"),
        tabName: "month"
      }), (variant === "default" || variant === "month-picker") && /* @__PURE__ */ React__default["default"].createElement(Tab, {
        active: activeYearSelectTab2 === "year",
        id: "year-select-tab-year",
        label: "Ano",
        onClick: () => setActiveYearSelectTab2("year"),
        tabName: "year"
      }))), activeYearSelectTab2 === "year" && /* @__PURE__ */ React__default["default"].createElement(DropDownComponent, {
        id: "calendar-year-dropdown",
        maxRows: 0,
        onSelected: (e) => {
          const selectedYear = parseInt(e.value.toString(), 10);
          changeYear(selectedYear);
          const newDate = selected ? new Date(selected) : new Date();
          newDate.setFullYear(selectedYear);
          onChange(newDate, void 0);
          setActiveYearSelectTab2("month");
        },
        open: true,
        options: getYears(),
        sx: {
          "> #calendar-dropdown": { maxHeight: "100%" },
          bottom: 0,
          boxShadow: "none",
          height: "calc(100% - 80px)",
          left: 0,
          position: "absolute",
          width: "100%"
        },
        value: { label: date.getFullYear().toString(), value: date.getFullYear().toString() }
      }), activeYearSelectTab2 === "month" && /* @__PURE__ */ React__default["default"].createElement(DropDownComponent, {
        id: "calendar-month-dropdown",
        maxRows: 0,
        onSelected: (e) => {
          const selectedMonth = parseInt(monthParse[e.value].toString(), 10);
          changeMonth(selectedMonth);
          const newDate = selected ? new Date(selected) : new Date();
          newDate.setMonth(selectedMonth);
          onChange(newDate, void 0);
          if ((variant == null ? void 0 : variant.indexOf("default")) !== -1 || (variant == null ? void 0 : variant.indexOf("without-year")) !== -1) {
            setActiveYearSelectTab2("day");
          }
        },
        open: true,
        options: getMonths(),
        sx: {
          "> #calendar-dropdown": { maxHeight: "100%" },
          bottom: 0,
          boxShadow: "none",
          height: "calc(100% - 80px)",
          left: 0,
          position: "absolute",
          width: "100%"
        },
        value: { label: months[date.getMonth()], value: months[date.getMonth()] }
      })), /* @__PURE__ */ React__default["default"].createElement(Box, {
        sx: getCalendarHeaderStyle()
      }, /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
        color: "interaction.blend.07",
        disabled: prevMonthButtonDisabled || !shouldRenderLeftArrow,
        id: "datepicker-previous-month",
        leadingIcon: shouldRenderLeftArrow ? /* @__PURE__ */ React__default["default"].createElement(almaIcons.ArrowLeft, null) : void 0,
        onClick: () => decreaseMonth(),
        type: "button"
      }), /* @__PURE__ */ React__default["default"].createElement(Heading, {
        variant: "sm"
      }, monthDate.toLocaleString("pt-br", {
        month: "long",
        year: "numeric"
      })), /* @__PURE__ */ React__default["default"].createElement(ButtonIcon, {
        color: "interaction.blend.07",
        disabled: nextMonthButtonDisabled || !shouldRenderRightArrow,
        id: "datepicker-next-month",
        leadingIcon: shouldRenderRightArrow ? /* @__PURE__ */ React__default["default"].createElement(almaIcons.ArrowRight, null) : void 0,
        onClick: () => increaseMonth(),
        type: "button"
      })));
    };
    const getFormattedWeekDay = (formattedDate) => {
      if (weekParser[formattedDate]) {
        return /* @__PURE__ */ React__default["default"].createElement(Body, {
          variant: "sm"
        }, weekParser[formattedDate].substring(0, 3));
      }
      return /* @__PURE__ */ React__default["default"].createElement(Body, {
        variant: "sm"
      }, formattedDate.substring(0, 3));
    };
    const [activeYearSelectTab, setActiveYearSelectTab] = React__default["default"].useState("day");
    React__default["default"].useEffect(() => {
      if (variant === "default" || variant === "without-year") {
        setActiveYearSelectTab("day");
      } else {
        setActiveYearSelectTab("month");
      }
    }, [variant]);
    return /* @__PURE__ */ React__default["default"].createElement(StyledDatepickerContainer, {
      ref,
      zIndex
    }, /* @__PURE__ */ React__default["default"].createElement(ReactDatePicker__default["default"], __spreadValues$5({
      calendarContainer: ({ children }) => /* @__PURE__ */ React__default["default"].createElement(Box, {
        sx: getCalendarContainerStyle()
      }, children),
      formatWeekDay: getFormattedWeekDay,
      inline: true,
      monthsShown,
      onChange,
      renderCustomHeader: (params) => customHeader(params, activeYearSelectTab, setActiveYearSelectTab),
      renderDayContents: (dayOfMonth) => /* @__PURE__ */ React__default["default"].createElement(Body, {
        variant: "lg"
      }, dayOfMonth),
      selected
    }, props)));
  });

  var __defProp$4 = Object.defineProperty;
  var __defProps$1 = Object.defineProperties;
  var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
  var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
  var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$4 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$4.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    if (__getOwnPropSymbols$4)
      for (var prop of __getOwnPropSymbols$4(b)) {
        if (__propIsEnum$4.call(b, prop))
          __defNormalProp$4(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
  var __objRest$4 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$4)
      for (var prop of __getOwnPropSymbols$4(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const applyDateMask = (dateFormat, value) => {
    const cleanValueArray = Array.from(value.replace(/\D/g, ""));
    const dateFormatArray = Array.from(dateFormat.replace(/\w/g, "#"));
    const separator = dateFormat.replace(/\w/g, "").substring(0, 1);
    const newValue = cleanValueArray.slice();
    let loopCount = 0;
    for (let idx = 0; idx < dateFormatArray.length; idx++) {
      if (loopCount === cleanValueArray.length) {
        break;
      }
      if (dateFormatArray[idx] === separator) {
        newValue.splice(idx, 0, separator);
      } else {
        loopCount++;
      }
    }
    return newValue.join("");
  };
  const CustomInput = React__default["default"].forwardRef((_a, customInputRef) => {
    var _b = _a, { dateFormat, onChange, value } = _b, customInputProps = __objRest$4(_b, ["dateFormat", "onChange", "value"]);
    const [controlValue, setControlValue] = React__default["default"].useState(value || "");
    React__default["default"].useEffect(() => {
      if (value !== controlValue) {
        setControlValue(applyDateMask(dateFormat, value));
      }
    }, [value, controlValue, dateFormat]);
    const handleOnChange = (evt) => {
      if (onChange) {
        onChange(evt);
      }
      setControlValue(applyDateMask(dateFormat, evt.target.value));
    };
    return /* @__PURE__ */ React__default["default"].createElement(Input, __spreadProps$1(__spreadValues$4({
      width: "100%"
    }, customInputProps), {
      onChange: handleOnChange,
      ref: customInputRef,
      value: controlValue
    }));
  });
  const Datepicker = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { dateFormat: dateFormatProp, inputProps, trailingIcon } = _d, props = __objRest$4(_d, ["dateFormat", "inputProps", "trailingIcon"]);
    const dateFormat = dateFormatProp || "dd/MM/yyyy";
    return /* @__PURE__ */ React__default["default"].createElement(Calendar, __spreadValues$4({
      customInput: /* @__PURE__ */ React__default["default"].createElement(CustomInput, __spreadProps$1(__spreadValues$4({}, inputProps), {
        dateFormat,
        ref,
        trailingIcon
      })),
      dateFormat,
      inline: false,
      placeholderText: inputProps == null ? void 0 : inputProps.placeholder
    }, props));
  });
  const DatepickerRanged = React__default["default"].forwardRef(({ endDateProps, startDateProps, width: containerWidth, withPortal }, ref) => {
    const _a = endDateProps, { width: endDateWidth } = _a, endDateRestProps = __objRest$4(_a, ["width"]);
    const _b = startDateProps, { width: startDateWidth } = _b, startDateRestProps = __objRest$4(_b, ["width"]);
    return /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { display: "flex", position: "relative", width: containerWidth ? containerWidth : "100%" }
    }, /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { position: "relative", width: startDateWidth ? startDateWidth : "50%" }
    }, /* @__PURE__ */ React__default["default"].createElement(Datepicker, __spreadProps$1(__spreadValues$4({
      withPortal
    }, startDateRestProps), {
      endDate: endDateRestProps.endDate,
      monthsShown: 2,
      selected: startDateRestProps.startDate,
      selectsStart: true
    }))), /* @__PURE__ */ React__default["default"].createElement(Box, {
      sx: { position: "relative", width: endDateWidth ? endDateWidth : "50%" }
    }, /* @__PURE__ */ React__default["default"].createElement(Datepicker, __spreadProps$1(__spreadValues$4({
      withPortal
    }, endDateRestProps), {
      minDate: startDateRestProps.startDate,
      monthsShown: 2,
      selected: endDateRestProps.endDate,
      selectsEnd: true,
      startDate: startDateRestProps.startDate
    }))));
  });

  var __defProp$3 = Object.defineProperty;
  var __defProps = Object.defineProperties;
  var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
  var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
  var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
  var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$3 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    if (__getOwnPropSymbols$3)
      for (var prop of __getOwnPropSymbols$3(b)) {
        if (__propIsEnum$3.call(b, prop))
          __defNormalProp$3(a, prop, b[prop]);
      }
    return a;
  };
  var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __objRest$3 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$3)
      for (var prop of __getOwnPropSymbols$3(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const getSize = (variantSize) => {
    if (variantSize) {
      if (typeof variantSize === "number") {
        return variantSize;
      }
      switch (variantSize) {
        case "sm":
          return 24;
        case "md":
          return 32;
        case "lg":
          return 40;
      }
    }
    return "1rem";
  };
  const Skeleton = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { brand, speed = 2, spacing, sx } = _b, props = __objRest$3(_b, ["brand", "speed", "spacing", "sx"]);
    const customAnimation = react.keyframes({ from: { left: "-100%" }, to: { left: "100%" } });
    return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps(__spreadValues$3({}, props), {
      ref,
      sx: __spreadValues$3({
        bg: brand ? "neutral.on.brand.30" : "neutral.30",
        marginBottom: spacing,
        overflow: "hidden",
        position: "relative"
      }, sx)
    }), /* @__PURE__ */ React__default["default"].createElement(Box, {
      css: react.css`
                    animation: ${customAnimation} ${speed}s infinite;
                `,
      sx: {
        background: `linear-gradient(
                        to right,
                        transparent 0%,
                        ${brand ? defaultTheme$1.colors.interaction.on.brand.blend["02"] : defaultTheme$1.colors.interaction.blend["02"]} 40%,
                        ${brand ? defaultTheme$1.colors.interaction.on.brand.blend["02"] : defaultTheme$1.colors.interaction.blend["02"]} 60%,
                        transparent 100%
                    )`,
        height: "100%",
        left: "-100%",
        position: "absolute",
        right: 0,
        width: "100%"
      }
    }));
  });
  const SkeletonCircle = React__default["default"].forwardRef((_c, ref) => {
    var _d = _c, { variantSize = "md", sx } = _d, props = __objRest$3(_d, ["variantSize", "sx"]);
    return /* @__PURE__ */ React__default["default"].createElement(Skeleton, __spreadProps(__spreadValues$3({}, props), {
      ref,
      sx: __spreadValues$3({ borderRadius: "circle", height: getSize(variantSize), width: getSize(variantSize) }, sx)
    }));
  });
  const SkeletonText = React__default["default"].forwardRef((_e, ref) => {
    var _f = _e, { noOfLines = 1, variant = "sharp", variantSize = "md", sx } = _f, props = __objRest$3(_f, ["noOfLines", "variant", "variantSize", "sx"]);
    const getBaseComponent = (key) => /* @__PURE__ */ React__default["default"].createElement(Skeleton, __spreadProps(__spreadValues$3({}, props), {
      key,
      ref,
      sx: __spreadValues$3({
        borderRadius: variant === "sharp" ? "none" : "xs",
        height: getSize(variantSize),
        width: "100%"
      }, sx)
    }));
    if (noOfLines && noOfLines > 1) {
      const lines = [];
      for (let idx = 0; idx < noOfLines; idx++) {
        lines.push(getBaseComponent(idx));
      }
      return /* @__PURE__ */ React__default["default"].createElement(Box, null, lines);
    }
    return getBaseComponent();
  });

  var __defProp$2 = Object.defineProperty;
  var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
  var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
  var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$2 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    if (__getOwnPropSymbols$2)
      for (var prop of __getOwnPropSymbols$2(b)) {
        if (__propIsEnum$2.call(b, prop))
          __defNormalProp$2(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$2 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$2)
      for (var prop of __getOwnPropSymbols$2(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const Overline = React__default["default"].forwardRef((_a, ref) => {
    var props = __objRest$2(_a, []);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues$2({
      color: getColorTypfaceTokenByProp(props, "smooth"),
      fontFamily: "base",
      fontSize: "xxxs",
      fontWeight: "bold",
      letterSpacing: "medium",
      lineHeight: "distant",
      ref,
      sx: { textTransform: "uppercase" }
    }, props));
  });

  var __defProp$1 = Object.defineProperty;
  var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
  var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
  var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
  var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues$1 = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    if (__getOwnPropSymbols$1)
      for (var prop of __getOwnPropSymbols$1(b)) {
        if (__propIsEnum$1.call(b, prop))
          __defNormalProp$1(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest$1 = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols$1)
      for (var prop of __getOwnPropSymbols$1(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const isSmallProp = (variant) => variant === "sm";
  const Subtitle = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant } = _b, props = __objRest$1(_b, ["variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues$1({
      color: getColorTypfaceTokenByProp(props, "pure"),
      fontFamily: "base",
      fontSize: isSmallProp(variant) ? "md" : "lg",
      letterSpacing: isSmallProp(variant) ? "standard" : "small",
      lineHeight: isSmallProp(variant) ? "distant" : "large",
      ref
    }, props));
  });
  Subtitle.defaultProps = {
    variant: "lg"
  };

  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };
  var __objRest = (source, exclude) => {
    var target = {};
    for (var prop in source)
      if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
        target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(source)) {
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
          target[prop] = source[prop];
      }
    return target;
  };
  const TextAction = React__default["default"].forwardRef((_a, ref) => {
    var _b = _a, { variant } = _b, props = __objRest(_b, ["variant"]);
    return /* @__PURE__ */ React__default["default"].createElement(Typography, __spreadValues({
      color: getColorTypfaceTokenByProp(props, "strong"),
      fontFamily: "base",
      fontSize: isSmallProp$2(variant) ? "xxs" : "xs",
      fontWeight: "bold",
      letterSpacing: "standard",
      lineHeight: isSmallProp$2(variant) ? "tiny" : "superdistant",
      ref
    }, props));
  });
  TextAction.defaultProps = {
    variant: "lg"
  };

  exports.Accordion = Accordion;
  exports.Action = Action;
  exports.Banner = Banner;
  exports.Body = Body;
  exports.Box = Box;
  exports.BrandAvatar = BrandAvatar;
  exports.Breadcrumb = Breadcrumb;
  exports.BreadcrumbContainer = BreadcrumbContainer;
  exports.Button = Button;
  exports.ButtonFloating = ButtonFloating;
  exports.ButtonIcon = ButtonIcon;
  exports.Calendar = Calendar;
  exports.Caption = Caption;
  exports.Center = Center;
  exports.CheckBox = CheckBox;
  exports.ChipInput = ChipInput;
  exports.ChipStatic = ChipStatic;
  exports.ChipToggle = ChipToggle;
  exports.ColorModeProvider = ColorModeProvider;
  exports.Datepicker = Datepicker;
  exports.DatepickerRanged = DatepickerRanged;
  exports.Divider = Divider;
  exports.Dropdown = DropDownComponent;
  exports.DropdownModuleMultiple = DropdownModuleMultiple;
  exports.DropdownModuleSingle = DropdownModuleSingle;
  exports.Flex = Flex;
  exports.Grid = Grid;
  exports.GridItem = GridItem;
  exports.Heading = Heading;
  exports.Icon = Icon;
  exports.Input = Input;
  exports.InputPassword = InputPassword;
  exports.LinkInline = LinkInline;
  exports.LinkStandalone = LinkStandalone;
  exports.ListItem = ListItem;
  exports.Menu = Menu;
  exports.Multiselect = Multiselect;
  exports.Overlay = Overlay;
  exports.Overline = Overline;
  exports.Pack = Pack;
  exports.Pagination = Pagination;
  exports.PaginationItem = PaginationItem;
  exports.PersonAvatar = PersonAvatar;
  exports.Radio = Radio;
  exports.Search = Search;
  exports.Select = Select;
  exports.SimpleGrid = SimpleGrid;
  exports.Skeleton = Skeleton;
  exports.SkeletonCircle = SkeletonCircle;
  exports.SkeletonText = SkeletonText;
  exports.Snackbar = Snackbar;
  exports.Spacer = Spacer;
  exports.Spacing = Spacing;
  exports.Spinner = Spinner;
  exports.Stepper = Stepper;
  exports.StepperContainer = StepperContainer;
  exports.Subtitle = Subtitle;
  exports.SupportMessage = SupportMessage;
  exports.Switch = Switch;
  exports.Tab = Tab;
  exports.TabContainer = TabContainer;
  exports.TabPane = TabPane;
  exports.TabPanesContainer = TabPanesContainer;
  exports.TextAction = TextAction;
  exports.TextArea = TextArea;
  exports.TextInteraction = TextInteraction;
  exports.ThemeProvider = ThemeProvider;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;
  exports.Wrap = Wrap;
  exports.colors = defaultColors;
  exports.cssTextEllipsisOneLine = cssTextEllipsisOneLine;
  exports.getCustomTheme = getCustomTheme;
  exports.head = head;
  exports.mapResponsive = mapResponsive;
  exports.stringNormalize = stringNormalize;
  exports.tail = tail$2;
  exports.theme = defaultTheme$1;
  exports.useColorMode = useColorMode;
  exports.useThemeContext = useThemeContext;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
